// ----------------------------------------------------------------------

import { title } from 'process';
import { globalDashboardFr } from './modules/globalDashboard.fr';
import { privacyFr } from './modules/privacy.fr';
import { analyticsFr } from './modules/analytics.fr';
import { shareboostFr } from './modules/shareboost.fr';
import { stripeConnectFr } from './modules/stripeConnect.fr';
import { campaignFr } from './modules/campaign.fr';
import { fail } from 'assert';
import { reccurence_options } from 'src/_mock/eventDatesOptions';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to instadrinkpro@gmail.com.

// ----------------------------------------------------------------------

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Besoin d'aide? \n Consultez notre documentation.`,
    documentation: `documentation`,
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  product: `produit`,
  invoice: `facture`,
  details: `Détails`,
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `niveau menu 1`,
  menu_level_2: `niveau menu 2`,
  menu_level_3: `niveau menu 3`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  description: "Description de l'événement",
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  draft: 'Brouillon',
  ready: 'Prêt',
  published: 'publié',
  artists_lineup: 'Artists lineup',
  pass_culture: 'Pass Culture',
  attendees: 'participants',
  export: 'exporter',
  create_event: 'Créer un événement',
  create_org: 'Créer une organisation',
  sales: 'ventes',
  set_banking_message: '',
  label_Rows_Per_Page: 'Lignes par page',
  created_At: 'Créé à',
  location: 'Emplacement',
  title: 'titre',
  events: 'Événements',
  archived: 'Archivé',
  canceled: 'Annulé',
  Start_Date: "Date d’ouverture de l'événement",
  End_Date: "Date de clôture de l'événement",
  organisation: "Nom de l'organisation",
  organisations: 'Organisations',
  published_events: 'Événements publiés ',
  Add_event: 'Ajouter un événement',
  event_name: "Nom de l'événement",
  summary: 'Resumé de l’événement',
  cancel: 'Annuler',
  cancel_successful: 'Invitation annulée',
  cancel_failed: "Impossible d'annuler l'invitation",
  add: 'Ajouter',
  view_event: "visualiser l'événement",
  event_title: "Nom de l'évenement",
  cover: 'Photo de l’événement',
  cover_image: 'Photo de couverture',
  category: 'Catégorie',
  sub_category: 'sous-catégorie',
  status: 'Statut',
  listed: 'Evénement public',
  listed_tooltip:
    "Lorsqu'activé, votre événement sera visible publiquement et recherchable par tous dans la liste des événements",
  online_event: 'Evénement en Ligne',
  tags: 'Mots-clés',
  address: 'Adresse',
  city: 'Cité',
  capacity: 'Capacité',
  save: 'Enregistrer',
  Start_Time: "Heure d'ouverture de l'événement",
  End_Time: "Heure de clôture de l'événement",
  timezone: 'Fuseau horaire',
  Save_Changes: 'Sauvegarder les changements',
  Quantity: 'Quantité',
  Initial_Quantity: 'Quantité disponible',
  Max_Quantity: 'Max billets par commande',
  price: 'Prix',
  free: 'Gratuit',
  Sell_Time_Limit: 'Limite du temps de vente',
  delete: 'Supprimer',
  Edit: 'Editer',
  Add_Ticket: 'Ajouter Ticket',
  Sell_limit: 'Limite de vente',
  start: 'Début',
  end: 'Fin',
  Access_Time_Limit: "Heure d'accès à l'événement",
  Price_Quantity: 'Prix et Quantité',
  Access_limit: "Limite d'accès",
  name: 'Nom du Ticket',
  Your_event_is_already_published_on_this_link: 'Votre évènement est déjà publié sur ce lien',
  archive: 'Archiver',
  Event_Dashboard: "Dashboard de l'évenement",
  Preview_Event: "Aperçu de l'événement",
  publish: 'Publier',
  Email_Message: "Texte de l'email envoyé aux  participants à votre événement",
  Ticket_Message: 'Description du ticket',
  include: 'Inclus',
  required: 'Requis',
  Gender: 'Genre',
  Birthday: 'Date de naissance',
  HomePhone: 'Téléphone fixe',
  yourEventIs: 'Votre événement est ',
  date: 'Date',
  events_catering: 'Evénementiel et restauration',
  events_catering_description:
    'ID est une plateforme qui permet à vos clients d’acheter des billets pour assister à vos événements  ainsi que commander leur nourriture et boisson digitalement dans votre établissement.',
  create_digital_exp: 'Créez votre expérience digitale',
  create_digital_exp_description:
    'Les clients interagissent avec votre marque, à votre façon; vous contrôlez votre présence numérique afin de maximiser les revenus et la rentabilité.',
  digital_ticketing: 'LA BILLETTERIE DIGITALE',
  digital_ticketing_title:
    'Ajoutez vos événements et mettez en vente les billets sur notre plateforme.',
  digital_ticketing_description:
    'Chacun de vos clients désireux de participer, pourra cliquer sur un lien ou scanner un qr code sur le flyer digital ou physique de votre événement; ce dernier le dirigera vers la plateforme ID où il pourra sélectionner et payer sa place.',
  more_questions: 'Vous avez encore des questions?',
  more_questions_description:
    'Veuillez décrire votre cas pour recevoir les conseils les plus précis.',
  who_are_we: {
    who: 'Qui',
    are: 'sommes',
    we: 'Nous',
    work: 'Travaillons ensemble pour',
    futur: 'un meilleur avenir événementiel',
  },
  what_is_id: {
    title: "C'est quoi ID?",
    description:
      'ID est une plateforme qui permet à vos clients d’acheter des billets pour assister à vos événements  ainsi que commander leur nourriture et boisson digitalement dans votre établissement.',
  },
  about: {
    vision:
      'Notre vision: offrir la plateforme parfaite pour un avenir meilleur dans l’ événementiel et la restauration.',
    dream_team: 'DREAM TEAM',
    dream_team_description:
      "ID vous fournira une assistance si vous rencontrez des problèmes, notre équipe d'assistance vous répondra en moins d’un jour et nous avons également une documentation détaillée.",
  },
  testimonials: {
    title: 'TÉMOIGNAGES',
    who: 'Qui aime notre service? ',
    description:
      "Notre objectif est de créer la plateforme parfaite qui satisfera tous nos clients dans l’événementiel et la restauration. C'est pourquoi nous travaillons constamment sur nos services pour les améliorer chaque jour en écoutant les précieuses suggestions  que nos utilisateurs nous partagent.",
  },
  Min_Quantity: 'Min billets par commande',
  save_continue: 'Enregistrer et continuer',
  continue_later: 'Ne pas enregistrer et continuer plus tard',
  Link_to_buy_tickets_for_your_event: 'Lien pour acheter des places à votre événement',
  back: 'Retour',
  Complete_the_details_of_the_event_to_be_able_to_publish_it:
    "Compléter les détails de l'évènement pour pouvoir la publier",
  publish_the_event: "Publier l'évènement",
  view: 'Voir',
  ready_events: 'Événements prêts',
  drafted_events: 'Événements brouillons',
  archived_events: 'Événements archivés',
  canceled_events: 'Événements annulés',
  no_events: "Pas d'événements",
  my_events: 'Mes promo événements',
  total_sold: 'Total des recettes',
  sold_quantity: 'Nombre de billets vendus',
  send_batch_emails: 'Envoyer des e-mails groupés',
  export_tickets: 'Export Tickets',
  select_statuses_to_export: 'Select ticket statuses to export',
  total_selected_tickets: 'Total selected tickets',
  please_select_at_least_one_status: 'Please select at least one status to export',
  no_tickets_found_for_selected_statuses: 'No tickets found for the selected statuses',
  export_error: 'An error occurred during export',
  exporting: 'Exporting...',
  preordered: 'Preordered',
  refunded: 'Refunded',
  event_sales_status: "Statut des ventes de l'événement",
  event_closed_for_sales: 'Cet événement est actuellement fermé à la vente',
  event_open_for_sales: 'Cet événement est ouvert à la vente',
  open_sales: 'Ouvrir les ventes',
  close_sales: 'Fermer les ventes',
  confirm_open_sales: "Confirmer l'ouverture des ventes",
  confirm_close_sales: 'Confirmer la fermeture des ventes',
  open_sales_confirmation_message:
    'Êtes-vous sûr de vouloir ouvrir les ventes pour cet événement ? Cela permettra aux utilisateurs de faire de nouvelles réservations.',
  close_sales_confirmation_message:
    'Êtes-vous sûr de vouloir fermer les ventes pour cet événement ? Cela empêchera les utilisateurs de faire de nouvelles réservations.',
  event_closed_warning:
    "Les ventes sont actuellement fermées pour cet événement. Aucune nouvelle réservation ne peut être effectuée jusqu'à la réouverture des ventes.",
  event_link: "Lien de l'événement",
  sale_date: 'Date de vente',
  validated: 'Validés',
  confirmed: 'Confirmés',
  reimbursed: 'Remboursés',
  About: 'A propos',
  Name: 'Nom',
  promoters: 'PromoBoosters',
  add_promoter: 'Ajouter PromoBooster',
  choose_promoter: 'Choisir PromoBooster',
  remove: 'Retirer',
  min_followers: "Minimum d'abonnés",
  Dashboard: 'Tableau de bord',
  General: 'Général',
  Preview: 'Aperçu',
  required_information: 'Informations requises',
  promo_code: 'Codes Promo',
  email_campaigns: 'Campagnes Email',
  campaign_tracking: 'Suivi des Campagnes',
  overview: 'Vue globale',
  preview_your_event: "Aperçu de l'événement",
  Owner: 'Propriétaire',
  Account: 'Compte',
  account_settings: 'Paramètres du compte',
  Allowed_format: 'Formats autorisés',
  max_size: 'taille maximale de',
  billing: 'facturation',
  Email_Address: 'Adresse email',
  Phone_Number: 'Numéro de téléphone',
  Country: 'Pays',
  State_Region: 'État/Région',
  Zip_Code: 'Code postal',
  discount: 'Remise',
  maximum_number_of_sold_tickets: 'nombre maximum des billets vendus',
  Featured_tickets: 'Billets en vedette',
  No_promo_code_available: 'Pas de code promo disponible',
  add_promo_code: 'Ajouter code promo',
  This_code_is_already_used: 'Ce code est déjà utilisé!',
  discount_amount: 'Montant de la remise',
  advanced_options: 'Options avancés',
  all_tickets: 'Tous les billets',
  specific_tickets: 'Billets spécifiques',
  Legal_info: 'Informations légales',
  Followers: 'Abonnés',
  Total_events: "Nombre d'événements",
  Recommended: 'Recommendé',
  company_name: "Nom de l'entreprise",
  company_number: "Numéro de l'entreprise",
  Website: 'Site web',
  Cover: 'Couverture',
  add_organisation: 'Ajouter une organisation',
  create_user: 'créer un utilisateur',
  edit_reservation: 'Modifier la réservation',
  edit_reservation_info: 'Modifier les informations du client',
  users: 'utilisateurs',
  since: 'Depuis',
  firstname: 'Prénom',
  lastname: 'Nom',
  role: 'Rôle',
  access: 'accès',
  events_permissions: "Autorisations d'événements",
  organisations_permissions: 'Autorisations des organisations',
  Yes: 'Oui',
  No: 'Non',
  Permissions: 'Autorisations',
  Editing: 'Edition',
  Roles: 'Rôles',
  Search: 'Recherche',
  Event_stats: "Statistiques de l'événement",
  Number_of_purchase: "Nombre d'achats",
  Link: 'Lien',
  sold: 'vendus',
  available: 'disponibles',
  Tickets_status: 'Etat des tickets',
  There_is_no_tickets_status_for_this_event: "Il n'y a pas état de billets pour cet événement",
  promoter: 'PromoBooster',
  invite_user: 'Inviter utilisateur',
  initial: 'initial',
  upcoming: 'à venir',
  ongoing: ' en cours',
  past: 'passé',
  Organisation: 'Organisation',
  Bio: 'Bio',
  Type: 'Type',
  Evenementiel: 'Evenementiel',
  Restaurant: 'Restaurant',
  'Music Studio': 'Studio de Musique',
  'Create Your Music Studio': 'Créez votre Studio de Musique',
  'Set up your recording studio with professional features':
    "Configurez votre studio d'enregistrement avec des fonctionnalités professionnelles",
  'Your music studio is ready to start accepting bookings!':
    'Votre studio de musique est prêt à accepter les réservations!',
  'Studio Name': 'Nom du Studio',
  'Studio Description': 'Description du Studio',
  'Studio Address': 'Adresse du Studio',
  'Create Music Studio': 'Créer le Studio de Musique',
  'Create your recording studio with professional booking and management features':
    "Créez votre studio d'enregistrement avec des fonctionnalités professionnelles de réservation et de gestion",
  'Enter the full address of your music studio':
    "Entrez l'adresse complète de votre studio de musique",
  'Contact Information': 'Informations de Contact',
  'Help clients find and contact your studio':
    'Aidez les clients à trouver et contacter votre studio',
  'Additional Contact Information': 'Informations de Contact Supplémentaires',
  Optional: 'Optionnel',
  'Studio Features & Services': 'Fonctionnalités et Services du Studio',
  'Choose the features and services for your studio':
    'Choisissez les fonctionnalités et services pour votre studio',
  'Studio Management Features': 'Fonctionnalités de Gestion du Studio',
  'Required features are automatically enabled and cannot be disabled':
    'Les fonctionnalités requises sont activées automatiquement et ne peuvent pas être désactivées',
  'Services Offered': 'Services Offerts',
  'Select the services your studio provides to clients':
    'Sélectionnez les services que votre studio fournit aux clients',
  'Selection Summary': 'Résumé de la Sélection',
  'Enabled Features': 'Fonctionnalités Activées',
  'Availability & Booking Settings': 'Paramètres de Disponibilité et de Réservation',
  'Configure when your studio is available for bookings':
    'Configurez quand votre studio est disponible pour les réservations',
  'Basic Booking Settings': 'Paramètres de Réservation de Base',
  'Time Slot Duration': 'Durée du Créneau Horaire',
  'Select duration': 'Sélectionnez la durée',
  'Advance Booking (Days)': "Réservation à l'Avance (Jours)",
  'How far in advance can clients book?':
    "Combien de temps à l'avance les clients peuvent-ils réserver?",
  'Minimum Notice (Hours)': 'Préavis Minimum (Heures)',
  'Minimum hours notice required for booking':
    'Heures minimales de préavis requises pour la réservation',
  'Maximum Booking Duration (Minutes)': 'Durée Maximale de Réservation (Minutes)',
  'Maximum session length': 'Durée maximale de session',
  'Buffer Time (Minutes)': 'Temps de Pause (Minutes)',
  'Break time between sessions': 'Temps de pause entre les sessions',
  'Auto-approve bookings': 'Approuver automatiquement les réservations',
  'Allow back-to-back bookings': 'Autoriser les réservations consécutives',
  'Working Hours': 'Heures de Travail',
  'Advanced Settings': 'Paramètres Avancés',
  'These settings enable cross-day bookings for long recording sessions':
    "Ces paramètres permettent les réservations inter-journalières pour de longues sessions d'enregistrement",
  'Enable cross-day bookings': 'Activer les réservations inter-journalières',
  'Maximum Cross-Day Hours': 'Heures Inter-Journalières Maximales',
  'Maximum hours a session can extend into the next day':
    "Heures maximales qu'une session peut s'étendre sur le jour suivant",
  'Allow weekend crossover': 'Autoriser le passage de week-end',
  'Require same-day start': 'Exiger un début le même jour',
  'Creating your music studio...': 'Création de votre studio de musique...',
  'Please wait while we set up your studio with all the selected features.':
    'Veuillez patienter pendant que nous configurons votre studio avec toutes les fonctionnalités sélectionnées.',
  'This may take a few moments.': 'Cela peut prendre quelques instants.',
  'Set up your professional recording studio with comprehensive booking and management features':
    "Configurez votre studio d'enregistrement professionnel avec des fonctionnalités complètes de réservation et de gestion",
  'Quick setup with essential features pre-configured for immediate use':
    'Configuration rapide avec des fonctionnalités essentielles pré-configurées pour une utilisation immédiate',
  'Enter your music studio name': 'Entrez le nom de votre studio de musique',
  'Describe your music studio services and specialties':
    'Décrivez les services et spécialités de votre studio de musique',
  'Upload a cover image that represents your studio':
    'Téléchargez une image de couverture qui représente votre studio',
  Open: 'Ouvert',
  Closed: 'Fermé',
  Back: 'Retour',
  Required: 'Requis',
  // Studio Business Settings
  'Studio Business': 'Activité du Studio',
  'Studio Visibility': 'Visibilité du Studio',
  'Control whether your studio appears in public listings and search results':
    'Contrôlez si votre studio apparaît dans les listes publiques et les résultats de recherche',
  'Publicly Visible': 'Visible Publiquement',
  'Your studio appears in public listings and can be found by clients':
    'Votre studio apparaît dans les listes publiques et peut être trouvé par les clients',
  'Your studio is hidden from public view and only accessible by direct link':
    'Votre studio est masqué de la vue publique et accessible uniquement par lien direct',
  'Accept Bookings': 'Accepter les Réservations',
  'Your studio is accepting new booking requests':
    'Votre studio accepte de nouvelles demandes de réservation',
  'New bookings are temporarily disabled':
    'Les nouvelles réservations sont temporairement désactivées',
  'Music Styles & Genres': 'Styles et Genres Musicaux',
  'Add music styles and genres you specialize in to help clients find you':
    'Ajoutez les styles et genres musicaux dans lesquels vous vous spécialisez pour aider les clients à vous trouver',
  'Add music style or genre (e.g., Rock, Jazz, Hip Hop)':
    'Ajoutez un style ou genre musical (ex: Rock, Jazz, Hip Hop)',
  'No music styles added yet. Add some to help clients find your studio.':
    'Aucun style musical ajouté pour le moment. Ajoutez-en quelques-uns pour aider les clients à trouver votre studio.',
  'Save Studio Settings': 'Sauvegarder les Paramètres du Studio',
  // Featured Artists Management
  'Featured Artists': 'Artistes Vedettes',
  'Showcase artists who have worked with your studio (with their consent)':
    'Mettez en avant les artistes qui ont travaillé avec votre studio (avec leur consentement)',
  'Add Artist': 'Ajouter un Artiste',
  'Featured Artists Settings': 'Paramètres des Artistes Vedettes',
  'Save Settings': 'Sauvegarder les Paramètres',
  'Enable Featured Artists': 'Activer les Artistes Vedettes',
  'When enabled, featured artists will be visible in the showcase':
    "Lorsqu'activé, les artistes vedettes seront visibles dans la vitrine",
  'Important:': 'Important:',
  'Only add artists who have given explicit consent to be featured. Always respect artist privacy and rights.':
    "N'ajoutez que des artistes qui ont donné un consentement explicite pour être présentés. Respectez toujours la vie privée et les droits des artistes.",
  'Enable featured artists above to start showcasing artists who have worked with your studio':
    'Activez les artistes vedettes ci-dessus pour commencer à présenter les artistes qui ont travaillé avec votre studio',
  'Add First Artist': 'Ajouter le Premier Artiste',
  'No featured artists added yet. Add your first artist to get started!':
    'Aucun artiste vedette ajouté pour le moment. Ajoutez votre premier artiste pour commencer!',
  Hidden: 'Masqué',
  'Consent Given': 'Consentement Donné',
  'Hide artist': "Masquer l'artiste",
  'Show artist': "Montrer l'artiste",
  'Edit artist': "Modifier l'artiste",
  'Remove artist': "Supprimer l'artiste",
  'Edit Featured Artist': "Modifier l'Artiste Vedette",
  'Add Featured Artist': 'Ajouter un Artiste Vedette',
  'Artist Name': "Nom de l'Artiste",
  Genre: 'Genre',
  Description: 'Description',
  'Brief description of the artist or their work with your studio...':
    "Brève description de l'artiste ou de son travail avec votre studio...",
  'Website URL': 'URL du Site Web',
  'Instagram URL': 'URL Instagram',
  'Spotify URL': 'URL Spotify',
  'YouTube URL': 'URL YouTube',
  'Invalid website URL': 'URL de site web invalide',
  'Invalid Instagram URL': 'URL Instagram invalide',
  'Invalid Spotify URL': 'URL Spotify invalide',
  'Invalid YouTube URL': 'URL YouTube invalide',
  'Artist Photo': "Photo de l'Artiste",
  'I confirm that this artist has given explicit consent to be featured in our studio showcase':
    'Je confirme que cet artiste a donné un consentement explicite pour être présenté dans notre vitrine de studio',
  'This is required for legal and ethical reasons':
    'Ceci est requis pour des raisons légales et éthiques',
  'Artist consent is required to showcase their work':
    "Le consentement de l'artiste est requis pour présenter son travail",
  Cancel: 'Annuler',
  Update: 'Mettre à jour',
  Add: 'Ajouter',
  Artist: 'Artiste',
  // Error/Success messages for artist management
  'Failed to load featured artists': 'Échec du chargement des artistes vedettes',
  'Failed to load artists data': 'Échec du chargement des données des artistes',
  'Featured artists settings saved successfully!':
    'Paramètres des artistes vedettes sauvegardés avec succès!',
  'Failed to save artists settings': 'Échec de la sauvegarde des paramètres des artistes',
  'Photo uploaded successfully!': 'Photo téléchargée avec succès!',
  'Failed to upload photo': 'Échec du téléchargement de la photo',
  'Please enter an artist name': "Veuillez saisir un nom d'artiste",
  'Artist updated successfully!': 'Artiste mis à jour avec succès!',
  'Artist added successfully!': 'Artiste ajouté avec succès!',
  'Failed to save artist': "Échec de la sauvegarde de l'artiste",
  'Artist removed successfully!': 'Artiste supprimé avec succès!',
  'Failed to remove artist': "Échec de la suppression de l'artiste",
  'Artist visibility updated!': "Visibilité de l'artiste mise à jour!",
  'Failed to update artist visibility': "Échec de la mise à jour de la visibilité de l'artiste",
  'Failed to save new order': 'Échec de la sauvegarde du nouvel ordre',
  // Music Genres for Featured Artists
  Pop: 'Pop',
  Rock: 'Rock',
  'Hip Hop': 'Hip Hop',
  Electronic: 'Électronique',
  Jazz: 'Jazz',
  Classical: 'Classique',
  Folk: 'Folk',
  Blues: 'Blues',
  Reggae: 'Reggae',
  Punk: 'Punk',
  Metal: 'Métal',
  Indie: 'Indie',
  'World Music': 'Musique du Monde',
  Experimental: 'Expérimental',
  Other: 'Autre',
  // ManageAvailability Component
  'Studio Availability': 'Disponibilité du Studio',
  'Configure your studio working hours, booking time slots, and availability rules':
    'Configurez les horaires de travail de votre studio, les créneaux de réservation et les règles de disponibilité',
  'Booking Rules': 'Règles de Réservation',
  'Time Slots': 'Créneaux Horaires',
  'Weekly Schedule': 'Planning Hebdomadaire',
  'Set your studio operating hours for each day of the week. Enable 24-hour mode or set cross-midnight schedules (e.g., 22:00 to 06:00 next day)':
    "Définissez les heures d'ouverture de votre studio pour chaque jour de la semaine. Activez le mode 24h ou définissez des horaires qui traversent minuit (ex: 22h00 à 06h00 le lendemain)",
  'Cross-Day Booking Policy': 'Politique de Réservation Inter-Journalière',
  'Enable Cross-Day Bookings': 'Activer les Réservations Inter-Journalières',
  'Allow bookings that span across midnight (e.g., 23:00 PM to 2:00 AM)':
    "Autoriser les réservations qui s'étendent au-delà de minuit (ex: 23h00 à 02h00)",
  'Max Cross-Day Hours': 'Heures Inter-Journalières Maximales',
  'Maximum hours a booking can span across days':
    "Nombre maximal d'heures qu'une réservation peut s'étendre sur plusieurs jours",
  'Allow Weekend Crossover': 'Autoriser le Passage de Week-end',
  'Allow bookings to cross from weekend to weekday or vice versa':
    'Autoriser les réservations à passer du week-end à la semaine ou vice versa',
  'Require Same Day Start': 'Exiger un Début le Même Jour',
  'Booking must start and end on the same calendar day':
    'La réservation doit commencer et se terminer le même jour calendaire',
  '24h': '24h',
  'Start Time': 'Heure de Début',
  'End Time': 'Heure de Fin',
  'Next day': 'Jour suivant',
  'Cross-midnight schedule:': 'Horaire traversant minuit:',
  'next day': 'jour suivant',
  'Booking Configuration': 'Configuration des Réservations',
  'Configure booking rules and restrictions':
    'Configurez les règles et restrictions de réservation',
  'Advance Booking Days': "Jours de Réservation à l'Avance",
  'How many days in advance can clients book':
    "Combien de jours à l'avance les clients peuvent-ils réserver",
  'Minimum Notice (hours)': 'Préavis Minimum (heures)',
  'Minimum hours before booking': 'Heures minimales avant la réservation',
  'Max Session Duration (minutes)': 'Durée Maximale de Session (minutes)',
  'Maximum booking duration': 'Durée maximale de réservation',
  'Buffer Time (minutes)': 'Temps de Pause (minutes)',
  'Break time between bookings': 'Temps de pause entre les réservations',
  'Automatically approve booking requests without manual review':
    'Approuver automatiquement les demandes de réservation sans révision manuelle',
  'Allow bookings to be scheduled consecutively':
    'Autoriser les réservations à être planifiées de manière consécutive',
  'Time Slot Configuration': 'Configuration des Créneaux Horaires',
  'Configure booking time slots and intervals':
    'Configurez les créneaux horaires et intervalles de réservation',
  'Time Slot Unit': 'Unité de Créneau Horaire',
  'Default Slot Duration (minutes)': 'Durée de Créneau par Défaut (minutes)',
  'Default duration for booking slots': 'Durée par défaut pour les créneaux de réservation',
  'Time slots will be generated based on your working hours and selected time unit. Clients can select from available slots when booking.':
    "Les créneaux horaires seront générés en fonction de vos heures de travail et de l'unité de temps sélectionnée. Les clients peuvent choisir parmi les créneaux disponibles lors de la réservation.",
  Reset: 'Réinitialiser',
  'Loading availability settings...': 'Chargement des paramètres de disponibilité...',
  'Failed to load availability settings. Please try refreshing the page.':
    'Échec du chargement des paramètres de disponibilité. Veuillez actualiser la page.',
  'Availability settings saved successfully!':
    'Paramètres de disponibilité sauvegardés avec succès!',
  'An error occurred. Please try again.': "Une erreur s'est produite. Veuillez réessayer.",
  // Form validation messages for availability
  'Advance booking days is required': "Les jours de réservation à l'avance sont requis",
  'Minimum booking notice is required': 'Le préavis minimum de réservation est requis',
  'Maximum booking duration is required': 'La durée maximale de réservation est requise',
  'Time slot duration is required': 'La durée du créneau horaire est requise',
  'Buffer time is required': 'Le temps de pause est requis',
  // Time units
  '15 minutes': '15 minutes',
  '30 minutes': '30 minutes',
  '1 hour': '1 heure',
  Email: 'Email',
  Drop_or_Select_file: 'Déposer ou sélectionner un fichier',
  Rajoutez_une_image_de_couverture_pour_votre_événement:
    'Rajoutez une image de couverture pour votre événement',
  Upload_photo: 'Télécharger une photo',
  Update_photo: 'Mettre à jour la photo',
  organisation_users: "Utilisateurs de l'organisation",
  Agent_liés_à_lorganisation: "Agents liés à l'organisation",
  Agents_en_attente_de_confirmation: 'Agents en attente de confirmation',
  Instadrink_admin: 'Administrateur I.D',
  create_role: 'Créer un role',
  Predefined_roles: 'Rôles prédéfinis',
  Custom_roles: 'Rôles personnalisés',
  Agents: 'Agents',
  Organizer: 'Organisateur',
  Bouncer: 'Videur',
  Ambassador: 'Ambassadeur',
  promotion_groups: 'groupes de promotion',
  Dates: 'Dates',
  Tickets: 'Tickets',
  Information: 'Informations',
  Messages: 'Messages',
  Promotion: 'Promotion',
  Participants: 'Participants',
  Client: 'Client',
  description_placeholder:
    'Décrivez à vos futurs participants l’ambiance exceptionnelle qui règnera dans votre évènement',
  Tickets_collection: 'Collection des tickets',
  Stop_sell_time_is_at: "L'heure limite de vente est à",
  drag_and_drop: "Glissez et déposez pour changer l'ordre",
  delete_ticket_confirmation: 'Êtes-vous sûr de vouloir supprimer ce billet ?',
  Access_Time_Thresholdt: "Heure de fin d'accès de l'évènement",
  order: 'ordre',
  Créez_les_tickets_pour_votre_événement: 'Créez les tickets pour votre événement',
  stop_sell_time_error_message:
    'La date de fin doit être postérieure à la date de début et ne doit pas dépasser la date de fin de vente',
  Tickets_quantity_error_message:
    "La quantité totale de tickets a atteint la capacité maximale de l'événement, qui est",
  Write_something_awesome: "Écris quelque chose d'incroyable...",
  Code: 'Code',
  delete_promocode_confirm_message: 'Êtes-vous sûr de vouloir supprimer ce code ?',
  Activate_promotion: 'Activer la promotion',
  Desactivate_promotion: 'Désactiver la promotion',
  Configure_RP_offer: "Configurer l'offre PromoBooster",
  promotion_status: 'statut de la promotion',
  TooltipTextForPromotionGroups:
    'Dans cette section, vous pouvez créer et gérer des groupes de Personnes Ressources (PR) pour vos événements.',
  TooltipTextForEventLink: "Publiez votre événement pour obtenir votre lien d'événement.",
  TooltipTextForPromotionGroupsForReferral:
    'Dans cette section, vous trouverez les groupes PromoBooster dont vous êtes membre, et vous pouvez quitter le groupe à tout moment.',
  confirm_delete_promoter: 'Êtes-vous sûr de vouloir supprimer ce PromoBooster ?',
  Preview_promoter_link: 'Aperçu du lien du PromoBooster',
  Locked: 'Verouillé',
  pending: 'En attente',
  accepted: 'accepté',
  rejected: 'rejeté',
  Publish_my_event_now: 'Publier mon évènement maintenant',
  publish_later: 'Publier plus tard',
  Your_event_is_still_draft:
    'Votre évènement est toujours un brouillon, terminer la configuration pour le publier',
  Are_you_sure_to_publish_the_event: "Êtes-vous sûr de publier l'événement  ",
  pourcentage: 'pourcentage',
  Rate: 'Taux',
  Message: 'Message',
  submit: 'Soumettre',
  Create_group: 'Créer un groupe',
  Groups: 'Groupes',
  Edit_group: 'Editer le groupe',
  Search_by_Name: 'Rechercher par nom',
  Enter_group_name: 'Entrez le nom du groupe',
  No_promoters_found: 'Aucun PromoBooster trouvé',
  Add_group: 'Ajouter le groupe',
  Number_of_sales: 'Nombre de ventes',
  Turnover: "Chiffre d'affaires",
  Number_of_clients: 'Nombre de clients',
  Promotion_requests: 'Demandes de promotion',
  Requests: 'Demandes',
  Notifications: 'Notifications',
  Referral_requests: 'Demandes de PromoBooster',
  no_requests: "Il n'y a aucune demande",
  request_message: 'vous a envoyé une demande pour vous inviter à être le Promobooster de',
  Accept: 'Accepter',
  Reject: 'Rejeter',
  Your_invitation_to: 'Votre invitation à',
  on: 'le',
  at: 'à',
  is: 'est',
  promotion_rate: 'taux de promotion',
  consigne: 'consigne',
  Cancel_request: 'Annuler la demande',
  Send_request: 'Envoyer une demande',
  No_events:
    'Recherchez un événement avec lequel vous aimeriez collaborer en tant que PromoBooster',
  Search_for_new_events: 'Rechercher de nouveaux événements',
  Search_for_Events: 'Rechercher des événements',
  Sales_stats: 'Statistiques de ventes',
  Total_sales: 'Total ventes',
  Total_reservation: 'Total reservations',
  Bienvenue_message: 'Bienvenue sur I.D, choisissez votre domaine',
  second_bienvenu_message:
    "Bienvenue sur I.D, sélectionnez votre domaine d’activité entre l'évenementiel et la restauration.",
  Continue: 'Continuer',
  Event: 'Evénement',
  orga_message: 'choisissez l’organisation sous laquelle vous créerez votre événement',
  Skip: 'Passer',
  All_steps_completed: 'Toutes les étapes terminées',
  you_have_finished: 'vous avez terminé',
  limit_sell_message: 'Entrez une date limite et une heure de vente des tickets',
  stopSellDate: 'Date de fin de vente des tickets',
  status_tooltip:
    "Ce champ de statut calcule automatiquement la date de début et la date de fin, et vous donne le statut de l'événement",
  Step: 'Etape',
  correct_start_date: 'Corriger la date de démarrage passé',
  Finish: 'Teminer',
  event_name_tooltip: 'Quel est le nom de votre événement?',
  event_summary_tooltip:
    'Donnez un avant-goût des belles surprises qui attendent les futurs participants à votre événement.',
  event_description_tooltip:
    'Cette fois, décrivez en détails votre événement auquel les futurs participants auront la chance de participer.',
  event_cover_tooltip: 'choisissez une photo pour votre événement',
  organisation_tooltip: 'choisissez le nom de l’organisation qui organisera votre événement',
  category_tooltip: 'choisissez une catégorie pour votre événement',
  subCategory_tooltip: 'choisissez une sous-catégorie pour votre événement',
  Business: 'Affaires',
  Charity: 'Charité',
  Causes: 'Causes',
  Community: 'Communauté',
  Concerts: 'Concerts',
  Music: 'Musique',
  Conferences: 'Conférences',
  Expos: 'Expositions',
  Fashion: 'Mode',
  Festivals: 'Festivals',
  Film: 'Cinéma',
  Media: 'Médias',
  Food: 'Nourriture',
  Drink: 'Boisson',
  Health: 'Santé',
  Hobbies: 'Loisirs',
  Nightlife: 'Vie nocturne',
  Performing: 'Arts du',
  arts: 'spéctacle',
  Seasonal: 'Saisonnier',
  Holiday: 'Vacances',
  Sports: 'Sports',
  Fitness: 'Forme physique',
  Travel: 'Voyage',
  Outdoor: 'Plein air',
  Career: 'Carrière',
  Design: 'Conception',
  Educators: 'Éducateurs',
  Environment: 'Environnement',
  Sustainability: 'Durabilité',
  Finance: 'Finance',
  Investment: 'Investissement',
  Non: 'Non',
  Profit: 'But lucratif',
  NGOs: 'ONG',
  Real: 'Réel',
  Estate: 'Immobilier',
  Sales: 'Ventes',
  Marketing: 'Marketing',
  Startups: 'Startups',
  Small: 'Petites',
  Animal: 'Animaux',
  Welfare: 'Bien-être',
  Art: 'Art',
  Auctions: 'Ventes aux enchères',
  Benefit: 'Bénéfice',
  Walks: 'Marches',
  Disaster: 'Catastrophe',
  Relief: 'Secours',
  Donor: 'Donateur',
  Recognition: 'Reconnaissance',
  Educational: 'Éducatives',
  Fundraising: 'Collecte de fonds',
  Homeless: 'Sans-abri',
  shelters: 'Refuges',
  Human: 'Humains',
  Rights: 'Droits',
  International: 'International',
  Aid: 'Aide',
  Marches: 'Marches',
  Poverty: 'Pauvreté',
  Rallies: 'Rassemblements',
  Demonstrations: 'Manifestations',
  Ethnic: 'Ethnique',
  Fairs: 'Foires',
  Farmers: 'Agriculteurs',
  markets: 'marchés',
  Fetes: 'Fêtes',
  Fun: 'Amusant',
  runs: 'courses',
  Heritage: 'Patrimoine',
  Historic: 'Historique',
  Language: 'Langue',
  LGBTQ: 'LGBTQ',
  Nationality: 'Nationalité',
  Parades: 'Défilés',
  Protests: 'Manifestations',
  Religious: 'Religieux',
  Renaissance: 'Renaissance',
  Spiritual: 'Spirituel',
  Town: 'Ville',
  hall: 'salle',
  meetings: 'réunions',
  Acoustic: 'Acoustique',
  Americana: 'Américaine',
  Bluegrass: 'Bluegrass',
  Cultural: 'Culturel',
  Dance: 'Danse',
  EDM: 'Musique électronique',
  Hip: 'Hip',
  Hop: 'Hop',
  Rap: 'Rap',
  Latin: 'Latin',
  Opera: 'Opéra',
  Psychedelic: 'Psychedelique',
  Singer: 'Chanteur',
  Songwriter: 'auteur-compositeur',
  Top: 'Top',
  World: 'Monde',
  Colloquium: 'Colloque',
  Conference: 'Conférence',
  Congress: 'Congrès',
  Convention: 'Convention',
  Demonstration: 'Démonstration',
  Exhibition: 'Exposition',
  Forum: 'Forum',
  Meeting: 'Réunion',
  Presentation: 'Présentation',
  Round: 'Rond',
  table: 'table',
  Seminar: 'Séminaire',
  Symposium: 'Symposium',
  Workshop: 'Atelier',
  Award: 'Récompense',
  Ceremonies: 'Cérémonies',
  Screening: 'Projection',
  Movie: 'Film',
  Premiere: 'Première',
  Television: 'Télévision',
  Video: 'Vidéo',
  Game: 'Jeu',
  Education: 'Éducation',
  Industry: 'Industrie',
  Science: 'Science',
  Technology: 'Technologie',
  Barbecue: 'Barbecue',
  Breakfast: 'Petit déjeuner',
  Brunch: 'Brunch',
  Buffet: 'Buffet',
  Cocktail: 'Cocktail',
  Mixology: 'Mixologie',
  Culinary: 'Culinaire',
  workshops: 'ateliers',
  Dessert: 'Dessert',
  Pastry: 'Pâtisserie',
  Tastings: 'Dégustations',
  Dinner: 'Dîner',
  Farm: 'Dîner',
  to: 'De la ferme',
  Table: 'à',
  Dining: 'la table',
  Gourmet: 'Gastronomique',
  Markets: 'Marchés',
  Lunch: 'Déjeuner',
  Picnic: 'Pique-nique',
  Wine: 'Vin',
  Beer: 'Bière',
  Adult: 'Adulte',
  Anime: 'Animé',
  Comics: 'Bandes dessinées',
  Book: 'Livre',
  Books: 'Livres',
  Collecting: 'Collection',
  Cooking: 'Cuisine',
  DIY: 'Faites-le vous-même',
  Crafts: 'Artisanat',
  Drawing: 'Dessin',
  Painting: 'Peinture',
  Gaming: 'Jeux',
  Gardening: 'Jardinage',
  Home: 'Amélioration',
  Improvement: "de l'habitat",
  Knitting: 'Tricot',
  Photography: 'Photographie',
  Reading: 'Lecture',
  Sewing: 'Couture',
  Writing: 'Écriture',
  Bar: 'Tournées',
  Crawls: 'des bars',
  Bingo: 'Loto',
  Cabaret: 'Cabaret',
  Casino: 'Casino',
  Comedy: 'Comédie',
  Clubs: 'Clubs',
  Parties: 'Fêtes',
  Dancehall: 'Dancehall',
  Drinks: 'Boissons',
  Karaoke: 'Karaoké',
  Nightclubs: 'Boîtes de nuit',
  Mic: 'ouvert',
  Pubs: 'Pubs',
  Raves: 'Raves',
  Medical: 'Médical',
  Spa: 'Spa',
  Yoga: 'Yoga',
  Circus: 'Cirque',
  Exhibitions: 'Expositions',
  Magic: 'Magie',
  Musicals: 'Comédies musicales',
  Plays: 'Pièces de théâtre',
  Theater: 'Théâtre',
  Christmas: 'Noël',
  Easter: 'Pâques',
  Halloween: 'Halloween',
  Hanukkah: 'Hanoucca',
  New: 'Réveillon ',
  Year: 'du',
  Eve: 'Nouvel An',
  Thanksgiving: 'Action de grâce',
  Archery: "Tir à l'arc",
  Baseball: 'Baseball',
  Basketball: 'Basket-ball',
  Camping: 'Camping',
  Camps: 'Camps',
  Cars: 'Voitures',
  Cheer: 'Pom-pom girl',
  Climbing: 'Escalade',
  Cycling: 'Cyclisme',
  Diving: 'Plongée',
  Exercise: 'Exercice',
  Fishing: 'Pêche',
  Football: 'Football',
  Golf: 'Golf',
  Hiking: 'Randonnée',
  Hockey: 'Hockey',
  Hunting: 'Chasse',
  Jogging: 'Jogging',
  Lacrosse: 'Lacrosse',
  Motorsports: 'Sports mécaniques',
  Obstacles: "Parcours d'obstacles",
  Parachuting: 'Parachutisme',
  Rally: 'Rallye',
  Rugby: 'Rugby',
  Running: 'Course à pied',
  Skating: 'Patinage',
  Skiing: 'Ski',
  Snow: 'hiver',
  Snowboarding: 'Snowboard',
  Soccer: 'Football',
  Softball: 'Softball',
  Sport: 'Sport',
  Surfing: 'Surf',
  Swimming: 'Natation',
  Water: 'nautiques',
  Tennis: 'Tennis',
  Volleyball: 'Volleyball',
  Walking: 'Marche',
  Weightlifting: 'Haltérophilie',
  Windsurfing: 'Planche à voile',
  Wrestling: 'Lutte',
  Cruise: 'Croisière',
  Expeditions: 'Expéditions',
  Museum: 'Musée',
  visit: 'visite',
  Road: 'Voyages',
  Trips: 'en voiture',
  tours: 'Visites',
  Rp_request: 'vous a envoyé une demande pour être le PromoBooster de son événement',
  warning_message:
    'Veuillez d\'abord appuyer sur "ajouter" pour enregistrer votre billet et continuer',
  correct_date_tooltip: 'La date de début sélectionnée pour votre événement est déjà passée.',
  step1:
    "À cette étape, vous trouverez les statistiques de ventes de l'événement et la liste des participants à l'événement.",
  step2: "À cette étape, vous pouvez modifier les détails de l'événement.",
  step3: "À cette étape, vous pouvez modifier les dates et heures de l'événement.",
  step4:
    'À cette étape, vous pouvez ajouter de nouveaux billets pour votre événement ou modifier les billets existants.',
  step5: 'À cette étape, vous pouvez publier ou archiver votre événement.',
  step6:
    "À cette étape, vous trouverez la vue de l'événement pour les clients en mode bureau ou mobile.",
  step7: 'À cette étape, vous trouverez un aperçu des détails de votre événement.',
  step8: "À cette étape, vous pouvez obtenir des informations sur l'événement.",
  stepCodePromo: 'À cette étape, vous pouvez ajouter des codes promotionnels pour les billets.',
  step10:
    'À cette étape, vous pouvez gérer les PromoBooster de votre événement, créer un groupe de PromoBooster ou envoyer des demandes pour que le PromoBooster soit PromoBooster de votre événement.',
  step11: 'À cette étape, vous trouverez la liste des participants.',
  total_sold_tooltip: "Il s'agit du prix de vente total des billets pour l'événement.",
  sold_quantity_tooltip: "Il s'agit de la quantité totale de billets vendus pour l'événement.",
  link_tooltip: "Il s'agit du lien vers l'événement où vous pouvez acheter vos billets.",
  table_tooltip: 'Voici le tableau où vous trouverez la liste des participants à cet événement.',
  create_event_button_tooltip: 'Cliquez ici pour créer un nouvel événement.',
  events_table_tooltip:
    "Il s'agit du tableau des événements où vous pouvez trouver les détails de vos événements.",
  You_have_no_organisations: "Vous n'avez aucune organisation",
  alert_orga_title: 'Vous devez créer une organisation pour pouvoir créer un événement ensuite.',
  Configurate_here: 'Configurez ici',
  legal_verification: 'Vérification légale de votre compte',
  alert_stripe_configuration_title:
    'Veuillez compléter vos informations légales pour activer votre compte et pouvoir vendre vos billets.',
  Bank_balance: 'Solde bancaire',
  View_my_Stripe_account: 'Consultez mon compte Stripe',
  Your_balance: 'Votre solde',
  Add_new_card: 'Ajouter une nouvelle carte',
  Name_on_card: 'Nom sur la carte',
  Card_number: 'Numéro de carte',
  Expiration_date: "Date d'expiration",
  QRcode_tooltip: 'Cliquez ici pour personnaliser et télécharger le code QR de votre événement',
  File_Type: 'Type de fichier',
  send_invitation: 'Envoyer une invitation',
  Size: 'Taille',
  Color: 'Couleur',
  Background_Color: 'Couleur de fond',
  Download_QR_Code: 'Télécharger le code QR',
  Download_Invoice: 'Télécharger la facture',
  show_qr_code: 'Afficher le code QR',
  Close: 'Fermer',
  Customize_QR_Code: 'Personnaliser le code QR',
  no_users_yet: 'Aucun utilisateur pour le moment',
  plz_invite_users: 'Veuillez inviter des utilisateurs',
  invite_organizer: 'Inviter organisateur',
  invite: 'inviter',
  settings: 'configuration',
  invite_owners: 'inviter propriétaires',
  register: 'S’inscrire',
  password: 'Mot de passe',
  confirm_password: 'Confirmer le mot de passe',
  email_adress: 'Adresse email',
  division_agent: 'Agent',
  division_promoter: 'Promoteur',
  invite_owner: 'Je souhaite inviter un propriétaire',
  invite_referrer: 'Je souhaite inviter un PromoBooster',
  invite_ambassador: 'Je souhaite inviter un ambassadeur',
  iam_owner: 'Je suis un proprietaire',
  iam_owner_desc: 'Gérez vos organisations, restaurants et vos événements',
  iam_amb: 'Je suis un ambassadeur',
  iam_amb_desc: 'Promouvez des organisations et gagnez des commissions',
  iam_ref: 'Je suis un PromoBooster',
  iam_ref_desc: 'Référez des évenements et gagnez des commissions',
  start_free: 'Commencez tout à fait gratuitement.',
  no_credit_card: 'Aucune carte de crédit nécessaire.',
  have_account: 'Vous avez déjà un compte?',
  by_register_1: "En m'inscrivant, j'accepte les ",
  by_register_2: "Conditions d'utilisation",
  by_register_3: ' et la ',
  by_register_4: 'Politique de confidentialité.',
  manager_better_register: 'Gérez plus efficacement vos événements avec I.D',
  referral: 'PromoBooster',
  first_name_required: 'Prénom requis',
  first_name_short: 'Le prénom est trop court - doit comporter au moins 3 caractères.',
  first_name_long: 'Le prénom est trop long - doit comporter 50 caractères maximum.',
  first_name_alpha: 'Le prénom ne peut contenir que des caractères alphabétiques.',
  last_name_required: 'Nom de famille requis',
  last_name_short: 'Le nom de famille est trop court - doit comporter au moins 3 caractères.',
  last_name_long: 'Le nom de famille est trop long - doit comporter 50 caractères maximum.',
  last_name_alpha: 'Le nom de famille ne peut contenir que des caractères alphabétiques.',
  email_invalid: "L'email doit être une adresse email valide",
  email_required: 'Email requis',
  password_required: 'Mot de passe requis',
  password_short: 'Le mot de passe est trop court - doit comporter au moins 8 caractères.',
  password_long: 'Le mot de passe est trop long - doit comporter au maximum 128 caractères.',
  password_alpha: 'Le mot de passe ne peut contenir que des lettres latines.',
  password_lowercase: 'Le mot de passe doit contenir au moins une lettre minuscule.',
  password_uppercase: 'Le mot de passe doit contenir au moins une lettre majuscule.',
  password_number: 'Le mot de passe doit contenir un chiffre.',
  password_special: 'Le mot de passe doit contenir au moins un caractère spécial.',
  password_no_repeat:
    'Le mot de passe ne doit pas contenir trois caractères identiques consécutifs.',
  confirm_password_match: 'Les mots de passe doivent correspondre',
  confirm_password_required: 'Confirmer le mot de passe est requis',
  division_required: 'Division requise',
  division_invalid: 'La division doit être soit PromoBooster soit Agent',
  role_required: 'Rôle requis',
  role_invalid_promoter: 'Rôle invalide pour le PromoBooster',
  role_invalid_agent: "Rôle invalide pour l'agent",
  login: 'Connexion',
  fr: 'Français',
  en: 'English',
  es: 'Espagnol',
  pt: 'Portugais',
  lang: 'Langue',
  creating_account: 'Création de Compte en Cours',
  creating_account_desc: 'Finalisation de Votre Configuration de Compte',
  creating_account_info:
    "Votre compte est en cours de configuration. Veuillez rester sur cette page jusqu'à ce que le processus soit terminé. Nous apprécions votre patience !",
  accept_invitation_info:
    "Veuillez noter qu'après avoir accepté l'invitation ci-dessous, vous recevrez un e-mail de vérification. Après vérification, vous pourrez compléter la configuration de votre compte, y compris les options pour modifier votre nom et votre langue préférée.",
  invitation_already_processed:
    "Cette invitation a déjà été traitée. Veuillez consulter votre tableau de bord des événements pour plus d'informations.",
  'invitation.continuation_title': 'Invitation déjà envoyée !',
  'invitation.continuation_body':
    'Une invitation a déjà été envoyée pour cet e-mail. Veuillez consulter votre boîte de réception (et vos indésirables) et cliquez sur le lien de vérification.\n\nSi l\'email est introuvable, vous pouvez continuer en tapant le bouton <0>Réinviter</0>.',
  'invitation.continuation_use_existing': 'Je vérifie mes e-mails',
  'invitation.continuation_start_new': 'Réinviter',
  verify_email: 'Vérifiez Votre E-mail',
  verify_email_desc: 'Compte Créé avec Succès',
  verify_email_info:
    'Félicitations pour la configuration de votre compte ! Veuillez vérifier votre boîte de réception pour confirmer votre compte et accéder à toutes les fonctionnalités.',
  wait_verify: 'Veuillez patienter un moment pendant que nous vérifions votre e-mail.',
  wait_redirect: "Ne fermez pas cette fenêtre avant d'être redirigé vers le tableau de bord.",
  initialAccountHeader: 'Finalisez votre compte I.D',
  initialAccountDescription:
    'Bon retour! Définissez simplement votre mot de passe ci-dessous pour finaliser la configuration de votre compte.',
  initialAccountButton: 'Terminer la configuration',
  processingAccountHeader: 'Configuration de votre compte...',
  processingAccountDescription:
    'Veuillez patienter un instant pendant que nous confirmons vos informations et sécurisons votre compte.',
  processingAccountButton: 'En cours de finalisation...',
  successAccountHeader: 'Succès! Compte prêt',
  successAccountDescription:
    'Votre compte a été configuré avec succès et vous êtes en train de vous connecter. Vous allez être redirigé vers le tableau de bord sous peu.',
  successAccountButton: 'Redirection...',
  errorAccountHeader: 'Un problème est survenu',
  errorAccountDescription:
    "Il y a eu un problème avec la configuration de votre compte. Le lien pourrait être invalide ou expiré, ou l'adresse e-mail pourrait être incorrecte.",
  errorAccountButton: 'Réessayer',
  linkexpiredAccountHeader: 'Vérifiez Votre E-mail',
  linkexpiredAccountDescription:
    "Il y a eu un problème avec la configuration de votre compte. Le lien pourrait être invalide ou expiré, ou l'adresse e-mail pourrait être incorrecte.",
  verification_expired:
    'Echec du configuration du compte! Le lien de vérification de votre compte a expiré.',
  new_verification_link_sent:
    'Un nouveau lien de vérification a été envoyé à votre adresse e-mail.',
  login_welcome: 'Salut, Bienvenue',
  login_connect: 'Connectez-vous à I.D',
  login_type: 'Entrez vos coordonnées ci-dessous.',
  login_no_account: "Vous n'avez pas de compte ?",
  login_register: "S'inscrire",
  owner_total_part: "Il s'agit des parts du propriétaire pour la vente des tickets de l'événement.",
  my_share: 'Ma part',
  network: 'Réseau',
  Remember_password: 'Se souvenir du mot de passe',
  forgot_password: 'Mot de passe oublié?',
  create_your_first_organization: 'Créez votre première organisation',
  create_organization_step_description:
    "Pour commencer à gérer vos événements, créez votre première organisation. Vous pouvez créer autant d'organisations que vous le souhaitez plus tard.",
  create_your_first_event: 'Créez votre premier événement',
  create_event_step_description:
    'Maintenant que vous avez créé votre première organisation, il est temps de créer brièvement votre premier événement. Vous pourrez le modifier en détail plus tard.',
  congratulations: 'Félicitations !',
  last_step_description:
    'Vous pouvez maintenant accéder à la liste des événements et continuer à créer votre événement.',
  create_your_first_restaurant: 'Créez votre premier restaurant',
  create_restaurant_step_description:
    'Pour commencer à gérer vos tables, créez votre premier restaurant. Vous pouvez créer autant de restaurants que vous le souhaitez plus tard.',
  create_restaurant_last_step_description:
    'Vous pouvez maintenant accéder à la liste des restaurants et continuer à créer vos tables.',
  Logout: 'Déconnexion',
  Settings: 'Paramètres',
  create_store: 'Créer un restaurant',
  add_category: 'Ajouter une catégorie',
  select_store: 'Sélectionner un restaurant',
  add_new_product: 'Ajouter un nouveau produit',
  add_new_category: 'Ajouter une nouvelle catégorie',
  products: 'Produits',
  categories: 'Catégories',
  unavailable: 'Indisponible',
  composite: 'Composite',
  alcoholic: 'Alcoolique',
  Available: 'Disponible',
  simple: 'Simple',
  search_product: 'Rechercher un produit...',
  min_price: 'Prix minimum',
  max_price: 'Prix maximum',
  add_product: 'Ajouter un produit',
  edit_product: 'Modifier le produit',
  product_details: 'Détails du produit',
  composition_items: 'Éléments de composition',
  caption: 'Légende',
  extra: 'Supplément',
  max_quantity: 'Quantité maximale',
  add_composition: 'Ajouter une composition',
  items: 'Articles',
  item_name: "Nom de l'article",
  add_item: 'Ajouter un article',
  preparation_time: 'Temps de préparation',
  Orders: 'Commandes',
  current_orders: 'Commandes Actuelles',
  store: 'Restaurant',
  no_stores_message:
    "Vous n'avez aucun restaurant pour voir les commandes, veuillez d'abord en créer un",
  Pending: 'En Attente',
  in_preparation: 'En Préparation',
  Preparation: 'Préparation',
  accept_order: 'Accepter la commande',
  order_is_ready: 'La commande est prête',
  finish_order: 'Terminer la commande',
  total: 'Total',
  order_of: 'Commande de',
  Contact: 'Contact',
  reservations_shares: 'Partages de réservations',
  client_name: 'Nom du client',
  total_amount: 'Montant total',
  owner_share: 'Part du propriétaire',
  instadrink_share: "Part d'I.D",
  rp_share: 'Part de PromoBooster',
  thanks_join_invite: 'Merci de rejoindre notre communaute !',
  account_created_check_email: 'Compte créé, veuillez valider votre email',
  verify_before_expire: 'Vérifier votre mail avant expiration',
  if_mistake_contact_instadrink: 'Si vous avez une erreur, contactez I.D',
  ambassador_share: "Part de l'ambassadeur",
  shares_distribution: 'Répartition des parts',
  group_name: 'Nom du groupe',
  group_members: 'Membres du groupe',
  created_by: 'Créé par',
  leave_group: 'Quitter le groupe',
  with_product: 'Avec produit',
  all_categories: 'Toutes les catégories',
  inclusives: 'Inclusives',
  closing_Time: 'Heure de fermeture',
  open: 'Ouvert',
  Rush_hour: 'Heure de pointe',
  preview_store: 'Aperçu du restaurant',
  Delete_account: 'Supprimer le compte',
  invitation_rejected: 'Invitation rejeté',
  Are_you_sure_you_want_to_delete_your_account: 'Êtes-vous sûr de vouloir supprimer votre compte',
  delete_account_page_message:
    'En choisissant de supprimer votre compte, vous optez pour la suppression permanente de toutes vos données de notre système.',
  restaurants: 'Restaurants',
  stores: 'Magasins',
  commandes: 'Commandes',
  applications: 'Applications',
  inviteUsers: 'Inviter des utilisateurs',
  inviteAgents: 'Inviter des agents',
  inviteStaff: 'Inviter du personnel',
  invitationsList: 'Liste des invitations',
  promotersTree: 'Arbre des invitations',
  promotionGroups: 'Groupes de PromoBoosters',
  onboarding: 'Onboarding',

  // Enhanced Organization Onboarding
  enhanced_organization: {
    address_requires_coordinates: 'Veuillez sélectionner une adresse valide parmi les suggestions',

    // Step Labels
    step_labels: {
      basic: 'Informations de base',
      contact: 'Informations de contact',
      type: "Type d'organisation",
      roles: 'Rôles du personnel',
      staff: "Membres de l'équipe",
      features: 'Fonctionnalités et paramètres',
      availability: 'Disponibilité et horaires',
      showcase: 'Vitrine musicale',
      quick_setup: 'Configuration rapide',
    },

    // Dialog Title and General
    create_organization: 'Créer une organisation',
    step: 'Étape',
    of: 'sur',
    quick_mode: 'Mode rapide',
    quick_setup: 'Configuration rapide',
    music_studio: 'Studio de musique',

    // Basic Information Step
    tell_us_about_organization: 'Parlez-nous de votre organisation',
    basic_info_subtitle: 'Commençons par les informations de base',
    organization_name: "Nom de l'organisation",
    organization_name_required: "Nom de l'organisation *",
    organization_name_exists: "Ce nom d'organisation existe déjà",
    description: 'Description',
    description_required: 'Description *',
    language: 'Langue',
    organization_logo: "Logo de l'organisation",
    upload_logo: 'Télécharger le logo',
    cover_image: 'Image de couverture',
    upload_cover_image: "Télécharger l'image de couverture",
    change_logo: 'Changer le logo',

    // Quick Mode
    quick_setup_mode: 'Mode configuration rapide',
    using_quick_setup:
      'Utilise la configuration rapide avec les paramètres par défaut - désactiver pour une configuration détaillée',
    skip_detailed_setup:
      'Ignorer la configuration détaillée et utiliser les paramètres par défaut. Vous pouvez tout configurer plus tard.',
    detailed_setup: 'Configuration détaillée',

    // Contact Information Step
    contact_information: 'Informations de contact',
    contact_info_subtitle: "Fournissez les coordonnées et l'adresse de votre studio",
    email_address: 'Adresse e-mail',
    main_contact_email: 'E-mail de contact principal du studio',
    phone_number: 'Numéro de téléphone',
    contact_phone_number: 'Numéro de téléphone de contact',
    website: 'Site web',
    studio_website_optional: 'Site web de votre studio (optionnel)',
    studio_address: 'Adresse du studio',
    full_address_location: 'Adresse complète où se trouve votre studio',
    location_verified: 'Emplacement vérifié',
    no_locations_found: 'Aucun emplacement trouvé',
    contact_info_help:
      'Les informations de contact aident les clients à trouver et contacter votre studio. Vous pouvez mettre à jour ces détails plus tard dans les paramètres.',

    // Type Selection Step
    creating_music_studio: "Création d'un studio de musique",
    creating_studio_subtitle:
      "Vous créez une organisation de studio d'enregistrement avec des fonctionnalités améliorées",
    what_type_organization: "Quel type d'organisation est-ce ?",
    type_selection_subtitle: "Cela nous aide à personnaliser l'expérience pour vous",
    existing: 'Existant',

    // Roles Setup Step
    set_up_staff_roles: 'Configurer les rôles du personnel',
    roles_setup_subtitle:
      'Définissez les rôles pour les membres de votre équipe. Vous pouvez ignorer cette étape.',
    use_recommended_roles: "Utiliser les rôles recommandés pour ce type d'organisation",
    recommended_roles: 'Rôles recommandés',
    custom_roles: 'Rôles personnalisés',
    role_name: 'Nom du rôle',

    // Staff Setup Step
    add_team_members: "Ajouter des membres à l'équipe",
    staff_setup_subtitle:
      'Ajoutez les membres de votre équipe. Vous pouvez toujours en ajouter plus tard.',
    add_staff_member: 'Ajouter un membre du personnel',
    add_new_staff_member: 'Ajouter un nouveau membre du personnel',
    name: 'Nom',
    name_required: 'Nom *',
    email: 'E-mail',
    email_required: 'E-mail *',
    password: 'Mot de passe',
    leave_empty_default: 'Laisser vide pour la valeur par défaut (123)',
    role: 'Rôle',
    cancel: 'Annuler',
    add_member: 'Ajouter un membre',
    added_staff_members: 'Membres du personnel ajoutés',
    custom_role: 'Rôle personnalisé',

    // Availability Setup Step
    studio_availability: 'Disponibilité du studio',
    availability_subtitle:
      'Configurez les heures de travail de votre studio, les créneaux de réservation et les règles de disponibilité',
    please_fix_issues: 'Veuillez corriger les problèmes suivants :',
    working_hours: 'Heures de travail',
    booking_rules: 'Règles de réservation',
    time_slots: 'Créneaux horaires',
    weekly_schedule: 'Planning hebdomadaire',
    weekly_schedule_subtitle:
      "Définissez les heures d'ouverture de votre studio pour chaque jour de la semaine. Activez le mode 24h ou configurez des horaires franchissant minuit (ex: 22h00 à 06h00 le lendemain)",

    // Cross-Day Booking Policy
    cross_day_booking_policy: 'Politique de réservation inter-journalière',
    enable_cross_day_bookings: 'Activer les réservations inter-journalières',
    cross_day_help:
      "Autoriser les réservations qui s'étendent au-delà de minuit (ex: 23h00 à 02h00)",
    max_cross_day_hours: 'Heures inter-journalières max',
    max_cross_day_help:
      "Nombre maximum d'heures qu'une réservation peut s'étendre sur plusieurs jours",
    allow_weekend_crossover: 'Autoriser le passage week-end',
    weekend_crossover_help:
      'Autoriser les réservations à passer du week-end aux jours de semaine ou vice versa',
    require_same_day_start: 'Exiger un début le même jour',
    same_day_start_help: 'La réservation doit commencer et se terminer le même jour calendaire',

    // Days of Week
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',

    // Time Configuration
    start_time: 'Heure de début',
    end_time: 'Heure de fin',
    next_day: 'Le lendemain',
    cross_midnight_schedule: 'Horaire franchissant minuit :',

    // Booking Configuration
    booking_configuration: 'Configuration des réservations',
    booking_config_subtitle: 'Configurez les règles et restrictions de réservation',
    advance_booking_days: "Jours de réservation à l'avance",
    advance_booking_help: "Combien de jours à l'avance les clients peuvent réserver",
    minimum_notice_hours: 'Préavis minimum (heures)',
    minimum_notice_help: 'Heures minimales avant la réservation',
    max_session_duration: 'Durée max de session (minutes)',
    max_duration_help: 'Durée maximale de réservation',
    buffer_time_minutes: 'Temps de pause (minutes)',
    buffer_time_help: 'Temps de pause entre les réservations',
    auto_approve_bookings: 'Approuver automatiquement les réservations',
    auto_approve_help: 'Approuver automatiquement les demandes de réservation sans examen manuel',
    allow_back_to_back: 'Autoriser les réservations consécutives',
    back_to_back_help: 'Autoriser la programmation de réservations consécutives',

    // Time Slot Configuration
    time_slot_configuration: 'Configuration des créneaux horaires',
    time_slot_subtitle: 'Configurez les créneaux de réservation et les intervalles',
    time_slot_unit: 'Unité de créneau horaire',
    default_slot_duration: 'Durée par défaut du créneau (minutes)',
    slot_duration_help: 'Durée par défaut pour les créneaux de réservation',
    time_slot_help:
      "Les créneaux horaires seront générés en fonction de vos heures de travail et de l'unité de temps sélectionnée. Les clients peuvent sélectionner parmi les créneaux disponibles lors de la réservation.",

    // Actions
    reset_to_defaults: 'Réinitialiser aux valeurs par défaut',
    current_settings_applied:
      "Les paramètres actuels seront appliqués lorsque vous terminerez l'intégration",
    availability_for_studios:
      "Les paramètres de disponibilité sont principalement conçus pour les studios d'enregistrement. Vous pouvez les configurer plus tard dans votre tableau de bord si nécessaire.",
    skip_configure_later:
      "Vous pouvez ignorer cette étape et configurer les paramètres de disponibilité plus tard dans votre tableau de bord. Ces paramètres aident à automatiser votre processus de réservation et l'expérience client.",

    // Showcase Setup Step
    music_showcase: 'Vitrine musicale',
    showcase_subtitle:
      'Configurez une vitrine musicale pour afficher le travail de votre studio aux clients',
    enable_music_showcase: 'Activer la vitrine musicale',
    showcase_enabled_help:
      'Quand activée, votre vitrine musicale sera visible aux clients sur le profil de votre studio',
    showcase_title: 'Titre de la vitrine',
    showcase_title_placeholder: 'ex: Nos dernières productions',
    showcase_description: 'Description de la vitrine',
    showcase_description_placeholder: 'Décrivez votre vitrine musicale...',
    add_music_tracks_later:
      'Vous pouvez ajouter des pistes musicales de YouTube, Spotify, SoundCloud et autres plateformes après avoir terminé la configuration.',
    showcase_for_studios:
      "La vitrine musicale est spécialement conçue pour les studios d'enregistrement. Cette étape peut être ignorée pour les autres types d'organisation.",
    configure_showcase_later:
      'Ne vous inquiétez pas, vous pouvez toujours configurer votre vitrine musicale plus tard dans votre tableau de bord.',

    // Quick Setup Step
    quick_setup_title: 'Configuration rapide',
    quick_setup_subtitle_studio:
      'Créez votre studio de musique avec une configuration minimale. Vous pouvez tout personnaliser plus tard.',
    quick_setup_subtitle_general:
      'Créez votre organisation avec une configuration minimale. Vous pouvez tout personnaliser plus tard.',
    contact_email: 'E-mail de contact',
    contact_phone: 'Téléphone de contact',
    logo: 'Logo',
    optional: 'Optionnel',
    studio_description_placeholder:
      'Décrivez votre studio de musique, ses spécialités et ce qui le rend unique...',
    organization_description_placeholder: 'Décrivez votre organisation et ses services...',

    // Default Settings Preview
    default_settings_applied: 'Paramètres par défaut appliqués',
    standard_working_hours: 'Heures de travail standard',
    basic_booking_settings: 'Paramètres de réservation de base',
    default_roles: 'Rôles par défaut',
    core_features_enabled: 'Fonctionnalités principales activées',
    standard_availability_settings: 'Paramètres de disponibilité standard',
    basic_notification_preferences: 'Préférences de notification de base',
    customize_settings_later:
      'Tous les paramètres peuvent être personnalisés plus tard dans votre tableau de bord.',
    changed_your_mind: "Vous avez changé d'avis ?",
    switch_to_detailed:
      'Vous pouvez passer à la configuration détaillée pour configurer les rôles, le personnel, les fonctionnalités et la disponibilité étape par étape. Vos informations de base seront préservées.',

    // Navigation
    back: 'Retour',
    skip: 'Ignorer',
    next: 'Suivant',
    complete_setup: 'Terminer la configuration',

    // Validation Messages
    validation: {
      advance_booking_range: "Les jours de réservation à l'avance doivent être entre 1 et 365",
      minimum_notice_positive: 'Le préavis minimum de réservation ne peut pas être négatif',
      max_duration_minimum: "La durée maximale de réservation doit être d'au moins 15 minutes",
      slot_duration_minimum: "La durée du créneau horaire doit être d'au moins 15 minutes",
      buffer_time_positive: 'Le temps de pause ne peut pas être négatif',
      reset_success: 'Paramètres de disponibilité réinitialisés aux valeurs par défaut',
      fix_issues: 'Veuillez corriger les problèmes suivants :',
      advance_booking_days: "Les jours de réservation à l'avance doivent être un nombre positif",
      minimum_notice_hours: 'Les heures de préavis minimum doivent être un nombre positif',
      max_session_duration: 'La durée maximale de session doit être un nombre positif',
      buffer_time_minutes: 'Le temps de pause doit être un nombre positif',
      default_slot_duration: 'La durée par défaut du créneau doit être un nombre positif',
    },

    // Completion Messages
    organization_created_success: 'Organisation créée avec succès !',
    create_organization_failed: "Échec de la création de l'organisation",
    user_not_authenticated: 'Utilisateur non authentifié',

    // Additional Translation Keys for Enhanced UI

    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    time_units: {
      fifteenMinutes: '15 minutes',
      thirtyMinutes: '30 minutes',
      oneHour: '1 heure',
    },
    placeholders: {
      contact_email: 'contact@studio.com',
      contact_phone: '+33 1 23 45 67 89',
    },
    alerts: {
      availability_reset: 'Paramètres de disponibilité réinitialisés aux valeurs par défaut',
      studio_availability_note:
        "Les paramètres de disponibilité sont principalement conçus pour les studios d'enregistrement. Vous pouvez les configurer plus tard dans votre tableau de bord si nécessaire.",
      skip_availability_note:
        "Vous pouvez ignorer cette étape et configurer les paramètres de disponibilité plus tard dans votre tableau de bord. Ces paramètres aident à automatiser votre processus de réservation et l'expérience client.",
    },

    availability: {
      cross_day_description:
        "Autoriser les réservations qui s'étendent au-delà de minuit (ex: 23h00 à 02h00)",
      max_cross_day_hours_help:
        "Nombre maximum d'heures qu'une réservation peut s'étendre sur plusieurs jours",
      weekend_crossover_help:
        'Autoriser les réservations à passer du week-end aux jours de semaine ou vice versa',
      same_day_start_help: 'La réservation doit commencer et se terminer le même jour calendaire',
      next_day: 'Le lendemain',
      cross_midnight_schedule: 'Horaire franchissant minuit :',
      next_day_suffix: 'le lendemain',
      advance_booking_help: "Combien de jours à l'avance les clients peuvent réserver",
      min_notice_help: 'Heures minimales avant la réservation',
      max_duration_help: 'Durée maximale de réservation',
      buffer_time_help: 'Temps de pause entre les réservations',
      auto_approve_help: 'Approuver automatiquement les demandes de réservation sans examen manuel',
      back_to_back_help: 'Autoriser la programmation de réservations consécutives',
      slot_duration_help: 'Durée par défaut pour les créneaux de réservation',
      time_slots_explanation:
        "Les créneaux horaires seront générés en fonction de vos heures de travail et de l'unité de temps sélectionnée. Les clients peuvent sélectionner parmi les créneaux disponibles lors de la réservation.",
      settings_apply_note:
        "Les paramètres actuels seront appliqués lorsque vous terminerez l'intégration",
    },
    tabs: {
      working_hours: 'Heures de travail',
      booking_rules: 'Règles de réservation',
      time_slots: 'Créneaux horaires',
    },
    sections: {
      weekly_schedule: 'Planning hebdomadaire',
      weekly_schedule_description:
        "Définissez les heures d'ouverture de votre studio pour chaque jour de la semaine. Activez le mode 24h ou configurez des horaires franchissant minuit (ex: 22h00 à 06h00 le lendemain)",
      cross_day_policy: 'Politique de réservation inter-journalière',
      booking_configuration: 'Configuration des réservations',
      booking_configuration_description: 'Configurez les règles et restrictions de réservation',
      time_slot_configuration: 'Configuration des créneaux horaires',
      time_slot_description: 'Configurez les créneaux de réservation et les intervalles',
    },
    controls: {
      enable_cross_day: 'Activer les réservations inter-journalières',
      max_cross_day_hours: 'Heures inter-journalières max',
      allow_weekend_crossover: 'Autoriser le passage week-end',
      require_same_day_start: 'Exiger un début le même jour',
      twentyFourHours: '24h',
      start_time: 'Heure de début',
      end_time: 'Heure de fin',
      advance_booking_days: "Jours de réservation à l'avance",
      minimum_notice_hours: 'Préavis minimum (heures)',
      max_session_duration: 'Durée max de session (minutes)',
      buffer_time_minutes: 'Temps de pause (minutes)',
      auto_approve_bookings: 'Approuver automatiquement les réservations',
      allow_back_to_back: 'Autoriser les réservations consécutives',
      time_slot_unit: 'Unité de créneau horaire',
      default_slot_duration: 'Durée par défaut du créneau (minutes)',
      reset_to_defaults: 'Réinitialiser aux valeurs par défaut',
    },
    quick_setup_content: {
      title: 'Configuration rapide',
      subtitle_studio:
        'Créez votre studio de musique avec une configuration minimale. Vous pouvez tout personnaliser plus tard.',
      subtitle_general:
        'Créez votre organisation avec une configuration minimale. Vous pouvez tout personnaliser plus tard.',
      default_settings_applied: 'Paramètres par défaut appliqués',
      standard_working_hours: 'Heures de travail standard',
      basic_booking_settings: 'Paramètres de réservation de base',
      default_roles: 'Rôles par défaut',
      core_features_enabled: 'Fonctionnalités principales activées',
      standard_availability_settings: 'Paramètres de disponibilité standard',
      basic_notification_preferences: 'Préférences de notification de base',
      customize_settings_later:
        'Tous les paramètres peuvent être personnalisés plus tard dans votre tableau de bord.',
      changed_your_mind: "Vous avez changé d'avis ?",
      switch_to_detailed:
        'Vous pouvez passer à la configuration détaillée pour configurer les rôles, le personnel, les fonctionnalités et la disponibilité étape par étape. Vos informations de base seront préservées.',
    },
    showcase: {
      title: 'Vitrine musicale',
      subtitle:
        'Configurez une vitrine musicale pour afficher le travail de votre studio aux clients',
      enable_showcase: 'Activer la vitrine musicale',
      enabled_help:
        'Quand activée, votre vitrine musicale sera visible aux clients sur le profil de votre studio',
      showcase_title: 'Titre de la vitrine',
      title_placeholder: 'ex: Nos dernières productions',
      description: 'Description de la vitrine',
      description_placeholder: 'Décrivez votre vitrine musicale...',
      add_tracks_later:
        'Vous pouvez ajouter des pistes musicales de YouTube, Spotify, SoundCloud et autres plateformes après avoir terminé la configuration.',
      for_studios:
        "La vitrine musicale est spécialement conçue pour les studios d'enregistrement. Cette étape peut être ignorée pour les autres types d'organisation.",
      configure_later:
        'Ne vous inquiétez pas, vous pouvez toujours configurer votre vitrine musicale plus tard dans votre tableau de bord.',
    },
    buttons: {
      back: 'Retour',
      skip: 'Ignorer',
      next: 'Suivant',
      complete_setup: 'Terminer la configuration',
      cancel: 'Annuler',
      add_member: 'Ajouter un membre',
      reset_to_defaults: 'Réinitialiser aux valeurs par défaut',
      switch_to_detailed: 'Passer à la configuration détaillée',
    },
    roles: {
      setup_title: 'Configurer les rôles du personnel',
      setup_subtitle:
        'Définissez les rôles pour les membres de votre équipe. Vous pouvez ignorer cette étape.',
      use_recommended: "Utiliser les rôles recommandés pour ce type d'organisation",
      recommended: 'Rôles recommandés',
      custom: 'Rôles personnalisés',
      role_name: 'Nom du rôle',
      custom_role: 'Rôle personnalisé',
    },
  },
  invite_more_users: "Inviter plus d'utilisateurs",
  your_organisation_staff: 'Les employés de votre organisation',
  inv_org_desc: "L'organisateur de votre événement",
  inv_bnc_desc: "Le controleur d'accès à votre évènement",
  invite_more_staff: 'Inviter plus du personnel',
  delete_event_modal: "Êtes-vous sûr de vouloir supprimer l'événement",
  publish_event_modal: "Êtes-vous sûr de vouloir publier l'événement",
  cancel_event_modal: "Êtes-vous sûr de vouloir annuler l'événement",
  archive_event_modal: "Êtes-vous sûr de vouloir archiver l'événement",
  duplicate_event: "Dupliquer l'événement",
  duplicate: 'Dupliquer',
  reservations: 'Réservations',
  multiple_persons: 'Plusieurs personnes',
  persons_number: 'Nombre de personnes',
  vatRate: 'Taux TVA',
  price_TTC: 'Prix TTC',
  Occupation: 'Profession',
  priceHt: 'Prix hors TVA',
  promobooster_mode: 'Mode Promobooster',
  promo_mode: 'Mode Promo',
  Amount: 'Montant',
  Percentage: 'Pourcentage',
  include_owners: 'inclure les propriétaires',
  add_anonymous_promoter: 'Ajouter un SpyBooster',
  Confirm_Name: 'Confirmer le nom',
  Add_Anonymous_Name: 'Ajouter un SpyBooster',
  ask_for_invoice: 'demander une facture',
  add_invoice_button: 'Ajouter ',
  enter_valid_invoice: 'Veuillez saisir une facture valide',
  Compan_Name_Last_Name: 'Société/Nom/Nom de famille',
  tva: 'TVA',
  adresse: 'Adresse',
  postal_code: 'Code Postal',
  country: 'Country',
  additional_information: 'Informations Complémentaires',
  invoice_information: 'Facturation',
  survey_information: 'Sondage',
  know_from_invoice: 'Quelles informations exigez-vous de votre facture ?',
  know_from_attendees: 'Que devez-vous savoir de vos participants ?',
  add_invoice: 'Ajouter un nouveau champ',
  active_invoice: 'Activer la facture',
  actived_invoice: 'La facture est activée',
  preview_your_share: 'Aperçu Répartition  ',
  Number_of_event: `Nombre d'événement`,
  time_of_creation: 'Créer à',
  Owner_details: 'Détails du propriétaire',
  greetings: 'Salutations,',
  you_have_been_invited: 'Vous avez été invité à rejoindre I.D 🎉',
  plz_wait_a_moment: 'Veuillez patienter un moment',
  thanks_time: 'Merci pour votre temps',
  averagePreparationTime: 'Temps moyen de préparation',
  minutes: 'minutes',
  seconds: 'secondes',
  select_menu: 'Sélectionner un menu',
  capacity_warning_message: 'Les capacités sont épuisés par rapport à la capacité globale.',
  add_product_alert:
    'Pour ajouter un produit à vos billets, veuillez lier un magasin à votre événement',
  remaining_places: 'places restantes',
  navigate_to_event_menu: "Accéder au menu de l'événement",
  you_have_no_store: "Vous n'avez pas de restaurant",
  reject_order: 'Rejeter la commande',
  add_Waiter: 'Ajouter un serveur',
  add_room: 'Ajouter Chambre',
  room_name: 'Nom De Chambre',
  campaigns: {
    segment: 'Segment',
    mailCount: 'Nombre d\'e-mails',
    title: 'Campagnes e-mail',
    audience: 'Audience',
    createNew: 'Créer une nouvelle campagne',
    name: 'Nom',
    template: 'Modèle',
    scheduledTime: 'Heure programmée',
    actions: 'Actions',
    backToList: 'Retour à la liste des campagnes',
    info: 'Informations sur la campagne',
    mails: 'E-mails',
    email: 'E-mail',
    emailStatus: "Statut de l'e-mail",
    confirmDeletion: 'Confirmer la suppression',
    deleteConfirmationMessage:
      'Êtes-vous sûr de vouloir supprimer cette campagne e-mail ? Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    delete: 'Supprimer',
    status: 'Statut',
    edit: 'Modifier la campagne',
    create: 'Créer une nouvelle campagne',
    campaignName: 'Nom de la campagne',
    save: 'Enregistrer',
    selectTemplate: 'Sélectionner un modèle',
    createNewTemplate: 'Créer un nouveau modèle',
    statistics: 'Statistiques',
    mailRRecords: "Enregistrements d'e-mails",
    audienceType: {
      title: 'Audience',
      all: 'Tous les contacts',
      segment: 'Segment spécifique',
      eventBuyers: 'Acheteurs de billets',
    },
    stats: {
      title: 'Statistiques de la Campagne',
      delivered: 'Livrés',
      opened: 'Ouverts',
      clicked: 'Cliqués',
      bounced: 'Rejetés',
      totalProcessed: 'Total traités',
      success: 'Succès',
      failed: 'Échoués',
      deliveryRate: 'Taux de livraison',
      skipped: 'Ignorés',
    },
    emailstatus: {
      'email.sent': 'Envoyé',
      'email.delivered': 'Livré',
      'email.delivery_delayed': 'Livraison Retardée',
      'email.complained': 'Réclamation Reçue',
      'email.bounced': 'Rejeté',
      'email.opened': 'Ouvert',
      'email.clicked': 'Cliqué',
      'email.unsubscribed': 'Désabonné',
      'email.failed': "Échec d'Envoi",
      'email.blocked': 'Bloqué',
      'email.dropped': 'Abandonné',
      'email.deferred': 'Différé',
      'email.rejected': 'Rejeté',
    },
    campaignStatus: {
      label: 'Statut',
      completed: 'Terminé',
      pending: 'En attente',
      scheduled: 'Programmé',
      sending: "En cours d'envoi",
      launched: 'Envoyé',
      failed: 'Échoué',
      'template-ready': 'Modèle prête',
      draft: 'Brouillon',
    },
    subject: "Objet de l'email",
    subjectHelperText: "Vous pouvez personnaliser l'objet du modèle pour cette campagne",
    launchType: {
      title: 'Type de lancement',
      immediate: 'Lancer immédiatement',
      scheduled: 'Planifier pour plus tard',
    },
    drawer: {
      create: 'Créer une Campagne',
      edit: 'Modifier la Campagne',
      name: 'Nom de la Campagne',
      audienceType: "Type d'Audience",
      segment: 'Sélectionner un Segment',
      draftInfo: 'La campagne sera enregistrée comme brouillon',
    },
    schedule: {
      action: 'Planifier',
      send: 'Envoyer',
      title: 'Planifier la Campagne',
      info: "Planifier l'envoi pour la campagne : {{name}}",
      scheduledTimeHelper: 'Choisissez une date et une heure future pour envoyer votre campagne',
      errors: {
        scheduleTimeRequired: 'Veuillez sélectionner une heure de planification',
        testEmailRequired: 'Veuillez entrer une adresse email de test',
        scheduleFailed: 'Échec de la planification de la campagne',
        testSendFailed: "Échec de l'envoi de l'email test",
      },
      success: {
        testSent: 'Email test envoyé avec succès',
        launched: 'Campagne lancée avec succès',
        scheduled: 'Campagne planifiée avec succès',
      },
    },
    filters: {
      all: 'Tous',
      sent: 'Envoyé',
      failed: 'Échoué',
    },
    emails: {
      recipient: 'Destinataire',
      status: "Statut de l'e-mail",
      sentAt: 'Envoyé à',
      messageId: 'ID du message',
    },
  },
  Include_Platform_Fees: 'Inclure les frais de plateforme',
  Final_Price: 'Prix final',
  Platform_Fee_Info:
    'Lorsque cette option est activée, la commission de la plateforme de 2,5% sera ajoutée au prix du billet et payée par les participants. Si désactivée, cette commission sera prélevée sur vos revenus de billetterie.',
  Breakdown_Price: 'Détail du prix',
  Ticket_Price: 'Prix du billet',
  Service_Fees: 'Frais de service',
  Per_Ticket: 'par billet',
  Platform_Fee: 'Frais de plateforme',
  Total: 'Total',
  Cost_to_buyers: 'Coût pour les acheteurs',
  contacts: {
    totalContacts: '{{count}} contacts',
    import: 'Importer des contacts',
    export: 'Exporter en CSV',
    deleteSelected: 'Supprimer sélectionnés',
    search: 'Rechercher',
    noContactsToExport: 'Aucun contact à exporter.',
    errorDeletingContacts: 'Erreur lors de la suppression des contacts',
    errorLoadingContacts: 'Erreur lors du chargement des contacts',
    confirmDeletion: 'Confirmer la suppression',
    confirmDeletionMessage:
      'Êtes-vous sûr de vouloir supprimer les {count} contacts sélectionnés ?',
    cancel: 'Annuler',
    delete: 'Supprimer',
    dragAndDropInstruction:
      'Glissez et déposez un fichier CSV ou XLSX ici, ou cliquez pour sélectionner',
    file: 'Fichier : {name}',
    removeFile: 'Supprimer le fichier',
    informationMapping: 'Correspondance des informations',
    select: 'Sélectionner',
    additionalFields: 'Champs supplémentaires',
    errorParsingFile: "Erreur lors de l'analyse du fichier. Veuillez réessayer.",
    contactsImportedSuccessfully: 'Contacts importés avec succès',
    errorImportingContacts: "Erreur lors de l'importation des contacts. Veuillez réessayer.",
    fields: {
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      age: 'Âge',
      gender: 'Genre',
      country: 'Pays',
      zone: 'Zone',
      postalCode: 'Code postal',
    },
  },
  'Secret page link': 'Secret page link',
  'The secret page link will be generated when the ticket is created.':
    'The secret page link will be generated when the ticket is created.',
  no_confirmed_tickets_to_export: 'Aucun billet confirmé à exporter',
  export_confirmed_ticket_ids_tooltip: 'Exporter les ID des billets confirmés',
  loading: 'Chargement...',
  export_confirmed_tickets: 'Exporter les billets confirmés ({{count}})',
  check_invitation_list: "Vérifier la liste d'invitations",
  segments: {
    create: {
      title: 'Créer un Nouveau Segment',
      newDynamicSegment: 'Nouveau segment dynamique',
      newManualSegment: 'Nouveau segment manuel',
      engagement: 'Engagement',
      selectType: 'Sélectionnez un type de segment',
      dynamicSegment: {
        title: 'Segment filtres dynamiques',
        description:
          "Appliquez une liste d'attributs pour sélectionner une partie de vos contacts. Vos contacts seront automatiquement ajoutés ou enlevés de ce segment en fonction des filtres choisis.",
      },
      manualSegment: {
        title: 'Segment manuel via CSV',
        description:
          'Vous pouvez importer une liste de contacts depuis un fichier CSV pour les regrouper en segment. Vous pouvez utiliser cette fonctionnalité pour réimporter des contacts existants en tant que nouveau segment.',
      },
      step: 'Étape',
      of: 'sur',
      newsletterContacts: '{{count}} / 2000 contacts inscrits à votre newsletter déjà importés.',
      selectAgeRange: "Sélectionner l'intervalle d'âge que vous voulez filtrer :",
      averageAge: 'Moyenne : {{age}} ans',
      infoKnownFor: 'Cette information est connue pour {{count}} contacts',
      selectCountries: 'Sélectionner un ou des pays',
      selectZones: 'Sélectionner des zones',
      addPostalCodes: 'Ajouter des codes postaux (séparés par une virgule)',
      selectLanguage: 'Sélectionner la langue',
      removeFile: 'Supprimer le fichier',
      whenAdded: 'Quand ce contact a été ajouté à votre communauté',
      contactsImported: 'contacts inscrits à votre newsletter déjà importés.',
      dropFileHere: 'Déposez votre fichier CSV, XLS ou XLSX ici',
      fileRequirements:
        "Votre fichier doit au minimum avoir une colonne avec l'adresse e-mail des contacts.",
      removeFilters: 'Supprimer les filtres',
      contactInformation: 'INFORMATIONS DE CONTACT',
      marketing: 'MARKETING',
      history: 'HISTORIQUE',
      fieldMapping: 'Mapping des champs',
      additionalFields: 'Champs additionnels',
      segmentName: 'Nom du segment',
      description: 'Description',
      matchingContacts: 'contacts correspondant',
      back: 'Retour',
      cancel: 'Annuler',
      next: 'Suivant',
      createSegment: 'Créer un segment',
      importContacts: 'Importer les contacts en tant que segment',
    },
    fieldsMapping: {
      name: 'Nom',
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      age: 'Âge',
      gender: 'Genre',
      country: 'Pays',
      zone: 'Zone',
      postalCode: 'Code postal',
    },
    filters: {
      activeFilters: 'Filtres actifs',
      hasEmail: 'A un e-mail',
      emailVerified: 'E-mail vérifié',
      hasPhone: 'A un numéro de téléphone',
      age: {
        rangeInfo: 'Age comprise entre {{min}} et {{max}} ans',
        title: 'Âge',
      },
      gender: 'Genre',
      location: 'Localisation',
      language: 'Langue',
      dateAdded: "Date d'ajout",
      selectCountries: 'Sélectionner un ou des pays',
      selectZones: 'Sélectionner des zones',
      postalCodes: 'Ajouter des codes postaux (séparés par une virgule)',
      selectLanguage: 'Sélectionner la langue',
      allTime: 'Tout le temps',
      today: "Aujourd'hui",
      yesterday: 'Hier',
      last7days: 'Derniers 7 jours',
      last14days: 'Derniers 14 jours',
      last30days: 'Derniers 30 jours',
      last90days: 'Derniers 90 jours',
      customDates: 'Dates personnalisées',
      from: 'Du',
      to: 'Au',
      events: {
        title: 'Participation aux événements',
        hasAttendedEvents: 'Événements assistés',
        attendanceInfo: 'A assisté à {{count}} événements ou plus',
        selectRange: "Sélectionnez le nombre minimum d'événements assistés",
        infoTooltip:
          "Cela correspondra aux utilisateurs qui ont assisté à au moins ce nombre d'événements",
      },
    },
  },
  segment: {
    Create: {
      matchingContacts: 'contacts correspondants',
      back: 'Retour',
      cancel: 'Annuler',
      next: 'Suivant',
      importContacts: 'Importer les contacts',
      title: 'Créer un segment',
    },
  },
  templates: {
    createNew: 'Créer un nouveau modèle',
    subject: "Objet de l'email",
    subjectRequired: "L'objet de l'email est requis",
    createSuccess: 'Modèle créé avec succès',
    createError: 'Échec de la création du modèle',
  },
  // stripe_connect moved to modules/stripeConnect.fr.ts
  survey: {
    title: "Créateur de Sondage d'Événement",
    enable: 'Activer le Sondage',
    noResponses: 'Pas encore de réponses',
    totalResponses: 'Réponses totales : {{count}}',
    noSurveyData: 'Aucune donnée de sondage disponible',
    errorLoading: 'Erreur lors du chargement des données du sondage',
    question: {
      title: 'Question {{number}}',
      required: 'Obligatoire',
      text: 'Texte de la Question',
      type: 'Type de Question',
      types: {
        shortText: 'Texte Court',
        longText: 'Texte Long',
        radio: 'Boutons Radio',
        checkbox: 'Cases à Cocher',
      },
      options: 'Options :',
      addOption: 'Ajouter une Option',
      submit: 'Soumettre la Question',
      validation: {
        emptyText: 'Le texte de la question ne peut pas être vide.',
        radioOptions: 'La question à choix unique doit avoir au moins une option.',
        checkboxOptions: 'La question à choix multiples doit avoir au moins une option.',
      },
    },
    addQuestion: 'Ajouter une Question',
    answersSummary: 'Résumé des Réponses',
  },
  guests: {
    guestLists: "Listes d'invités",
    addList: 'Ajouter une liste',
    addGuest: 'Ajouter un invité',
    searchGuests: 'Rechercher des invités',
    addNewList: 'Ajouter une nouvelle liste',
    listName: 'Nom de la liste',
    guestList: "Liste d'invités",
    sendEmailsToNewGuests: 'Envoyer des emails aux nouveaux invités',
    single: 'Unique',
    import: 'Importer',
    text: 'Texte',
    name: 'Nom',
    email: 'Email',
    totalTickets: 'Billets totaux',
    freeTickets: 'Billets gratuits',
    dragDropCsv: 'Glissez et déposez un fichier CSV ici, ou cliquez pour sélectionner un fichier',
    guestDetailsPlaceholder:
      'Entrez les détails des invités (un par ligne) : Nom, BilletsTotal+BilletsGratuits, Email',
    importGuests: 'Importer les invités',
    editGuest: "Modifier l'invité",
    update: 'Mettre à jour',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage:
      'Êtes-vous sûr de vouloir supprimer cet invité ? Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    mapColumns: 'Mapper les colonnes',
    emailLabel: 'Email',
    ticketsInfo: 'Billets',
    deleteList: "Supprimer la liste d'invités",
    deleteListConfirmation: "Êtes-vous sûr de vouloir supprimer la liste d'invités : ",
    deleteListWarning:
      ' Cela supprimera également tous les invités de cette liste et ne peut pas être annulé.',
    invalidFileType:
      'Type de fichier invalide. Veuillez télécharger un fichier CSV ou Excel (.csv, .xlsx, .xls)',
    csvImportInstructions:
      'Téléchargez un fichier CSV ou Excel avec les informations des invités. Le fichier doit contenir les colonnes suivantes :',
    csvRequiredColumns: 'Colonnes requises',
    nameColumnDescription: "Nom complet de l'invité (obligatoire)",
    emailColumnDescription: "Adresse e-mail de l'invité (facultatif)",
    totalTicketsColumnDescription: 'Nombre total de billets alloués (minimum 1)',
    freeTicketsColumnDescription:
      'Nombre de billets gratuits (doit être inférieur ou égal au nombre total de billets)',
  },
  promoboosters: {
    referral_sales: 'Ventes par Parrainage',
    other_sales: 'Autres Ventes',
    available: 'Disponible',
    No_tickets_sold_yet: 'Aucun billet vendu pour le moment',
    ticket_category: 'Catégorie de Billet',
    total_sold: 'Total Vendu',
    initial_quantity: 'Quantité Initiale',
  },
  only_confirmed_tickets_can_be_refunded: 'Seuls les billets confirmés peuvent être remboursés',
  refund_ticket: 'Rembourser le billet',
  can_only_send_email_for_confirmed_or_validated:
    'Peut uniquement envoyer un e-mail pour les billets confirmés ou validés',
  send_confirmation_email: "Envoyer l'e-mail de confirmation",
  confirm_refund: 'Confirmer le remboursement',
  refund_confirmation_message:
    'Êtes-vous sûr de vouloir rembourser ce billet ? Cette action est irréversible.',
  refund_amount: 'Montant du remboursement',
  processing: 'Traitement en cours...',
  deduct_platform_fee: 'Déduire les Frais de Plateforme',
  platform_fee_toggle_description:
    'Lorsque activé, les frais de plateforme seront déduits du montant du remboursement',
  'Remove Deformation': 'Remove Deformation',
  'Deformed Price': 'Deformed Price',
  'Final Price': 'Final Price',
  original_price: 'Original Price',
  platform_fee: 'Platform Fee',
  platform_fee_deduction: 'Platform Fee Deduction',
  final_refund_amount: 'Final Refund Amount',
  'No deformations available': 'No price deformations available',
  'Price deformation added': 'Price deformation added successfully',
  'Price deformation removed': 'Price deformation removed',
  'Price Deformations Management': 'Price Deformations Management',
  'Add Price Deformation': 'Add Price Deformation',
  'No price deformations defined yet': 'No price deformations defined yet',
  Inactive: 'Inactive',
  off: 'off',
  Priority: 'Priorité',
  Domains: 'Domains',
  'Are you sure you want to delete this price deformation?':
    'Are you sure you want to delete this price deformation?',
  'Price deformation deleted successfully': 'Price deformation deleted successfully',
  'Failed to delete price deformation': 'Failed to delete price deformation',
  'Ticket Restrictions': 'Restrictions des billets',
  'Add Access Restriction': "Ajouter une restriction d'accès",
  'Access Restriction': "Restriction d'accès",
  Access_Restriction_Description:
    "L'accès aux billets peut être limité selon le domaine de votre e-mail.",
  'Allowed Domains': 'Domaines autorisés',
  'Restriction Rules': 'Règles de restriction',
  'A ticket can have either multiple price deformations OR one access restriction, but not both.':
    "Un billet peut avoir soit plusieurs déformations de prix SOIT une restriction d'accès, mais pas les deux.",
  'Adding an access restriction will remove all price deformations. Continue?':
    "L'ajout d'une restriction d'accès supprimera toutes les déformations de prix. Continuer ?",
  total_tickets_sold: 'Billets vendus',
  total_revenue: 'Revenu total',
  eventTicketStatistics: "Statistiques des billets de l'événement",
  eventCapacity: "Capacité de l'événement",
  totalTickets: 'Total des billets',
  totalReservations: 'Total des réservations',
  ticketName: 'Nom du billet',
  initialQuantity: 'Quantité initiale',
  soldQuantity: 'Quantité vendue',
  noTicketData: 'Aucune donnée de billet disponible',
  errorLoadingTickets: 'Erreur lors du chargement des données des billets',
  na: 'N/D',
  confirm_send_email: "Confirmer l'envoi de l'email",
  send_email_confirmation_message:
    "Êtes-vous sûr de vouloir envoyer l'email de confirmation à ce destinataire ?",
  recipient: 'Destinataire',
  sending: 'Envoi en cours...',
  send: 'Envoyer',
  ticketInvitation: {
    import: {
      csvMode: 'Import CSV',
      singleMode: 'Import individuel',
      missingFields: 'Veuillez remplir tous les champs requis',
      invalidEmail: 'Veuillez entrer une adresse email valide',
      'success.single': 'Invitation envoyée avec succès',
      sendInvitation: "Envoyer l'invitation",
      numTickets: 'Nombre de billets',
      invitationMode: 'Invitation',
      physicalMode: 'Billet physique',
      steps: {
        setup: 'Configuration',
        preview: 'Aperçu & Import',
      },
      next: 'Suivant',
      back: 'Retour',
      summary: "Résumé de l'importation",
      totalRecords: "Nombre total d'enregistrements",
      selectedTicket: 'Catégorie de billet sélectionnée',
      title: 'Importer des invitations',
      select_ticket_category: 'Catégorie de Billet',
      progress: 'Traitement {{current}}/{{total}} ({{success}} réussis, {{failed}} échoués)',
      dragOrSelect: 'Déposez votre fichier CSV ici ou cliquez pour sélectionner',
      dropHere: 'Déposez le fichier CSV ici',
      mapColumns: 'Mapper les colonnes CSV',
      previewTitle: 'Aperçu',
      records: 'enregistrements',
      firstThreeRecords: 'Trois premiers enregistrements',
      importButton: 'Importer {{count}} invitations',
      errors: {
        unknown: "Une erreur inconnue s'est produite",
        csvEmpty: 'Le fichier CSV est vide',
        invalidFormat: 'Format CSV invalide',
        parseError: "Erreur lors de l'analyse du fichier CSV",
        fileTooLarge: 'Fichier trop volumineux (max 5Mo)',
        invalidFileType: 'Seuls les fichiers CSV sont autorisés',
        invalidDataRows: '{{count}} lignes contiennent des données invalides',
        missingMapping: 'Veuillez mapper toutes les colonnes requises',
        creationFailed: 'Échec de la création des invitations',
      },
      success: {
        partial:
          'Import terminé : {{success}} réussis, {{failed}} échoués.\nDétails :\n{{details}}',
        complete: '{{count}} invitations créées avec succès',
        single: 'Invitation envoyée avec succès',
        physical: 'Billet physique créé avec succès',
      },
      explanation: {
        main: "Importez des billets pour plusieurs participants à l'aide d'un fichier CSV. Parfait pour migrer depuis d'autres systèmes de billetterie ou créer des billets pour une liste d'invités prédéfinie.",
        features: "Cet outil d'importation va :",
        feature1: 'Créer des billets numériques avec des QR codes uniques pour chaque participant',
        feature2: 'Envoyer des emails de confirmation aux participants avec leurs QR codes',
        feature3:
          "Vous permettre d'attribuer des catégories de billets spécifiques à tous les invités importés",
      },
    },
  },
  tickets: {
    default_insurance_description: 'Garantie pour remboursement en cas d\'imprévu',
    price_per_ticket_ht: 'par billet HT',
    hide_description: 'Masquer le billet (visible uniquement sur la page secrète)',
    validation: {
      titleRequired: 'Le titre est requis',
      descriptionRequired: 'La description est requise',
      priceZero: 'Le prix ne peut pas être zéro',
      priceRequired: 'Le prix est requis',
      initialQuantityZero: 'La quantité initiale ne peut pas être zéro',
      maxQuantityLimit: 'La quantité maximale doit être inférieure à la quantité initiale',
      maxQuantityZero: 'La quantité maximale ne peut pas être zéro',
      minQuantityLimit:
        'La quantité minimale doit être inférieure à la quantité maximale et initiale',
      minQuantityZero: 'La quantité minimale ne peut pas être zéro',
      categoryRequired: 'La catégorie est requise',
      productRequired: 'Le produit est requis',
      quantityRequired: 'La quantité est requise',
      quantityGreaterThanZero: 'La quantité doit être supérieure à zéro',
      withProductRequired: 'Le produit est requis lorsque iscomposite est vrai',
      fieldRequired: 'Ce champ est requis',
      vatRateRange: 'Le taux de TVA doit être compris entre 1 et 100',
    },
  },
  accessRequests: {
    sign_in: 'Se connecter',
    already_have_account: 'Vous avez déjà un compte ?',
    request_access: "Demander l'accès",
    request_access_title: "Demander l'accès à la plateforme",
    form_description:
      "Remplissez le formulaire ci-dessous pour demander l'accès à notre plateforme",
    welcome_message: "Obtenez l'accès à notre plateforme",
    full_name: 'Nom complet',
    email: 'Email',
    company_name: "Nom de l'entreprise",
    position: 'Poste',
    reason: "Pourquoi avez-vous besoin d'accès ?",
    reason_optional: 'Optionnel',
    cancel: 'Annuler',
    submit: 'Envoyer la demande',
    submitting: 'Envoi en cours...',
    please_fill_all_fields: 'Veuillez remplir tous les champs obligatoires',
    invalid_email: 'Veuillez saisir une adresse email valide',
    error_submitting_request: "Erreur lors de l'envoi de la demande. Veuillez réessayer.",
    phone: 'Numéro de téléphone',
    phone_optional: "Optionnel - Inclure l'indicatif du pays",
    company_optional: 'Optionnel',
    position_optional: 'Optionnel',
    source: 'Comment nous avez-vous trouvé ?',
    invalid_phone: 'Veuillez saisir un numéro de téléphone valide',
    source_options: {
      search_engine: 'Moteur de recherche (Google, Bing, etc.)',
      social_media: 'Réseaux sociaux',
      friend: 'Ami ou collègue',
      advertisement: 'Publicité',
    },
  },
  price_deformation: {
    name_required: 'Le nom est requis',
    deformation_type_required: 'Le type de déformation est requis',
    value_required: 'La valeur est requise',
    value_positive: 'La valeur doit être positive',
    invalid_value: 'Valeur invalide',
    domain_required: 'Au moins un domaine est requis',
    edit_price: 'Modifier la déformation de prix',
    new_price: 'Nouvelle déformation de prix',
    edit_access: "Modifier la restriction d'accès",
    new_access: "Nouvelle restriction d'accès",
    name: 'Nom',
    description: 'Description',
    active: 'Actif',
    deformation_type: 'Type de déformation',
    percentage: 'Pourcentage',
    fixed_amount: 'Montant fixe',
    deformation_value: 'Valeur de déformation',
    email_domains: 'Domaines email',
    add_domain: 'Ajouter un domaine',
    priority: 'Priorité',
    cancel: 'Annuler',
    update: 'Mettre à jour',
    create: 'Créer',
    priority_info:
      "La priorité détermine l'ordre dans lequel les restrictions sont appliquées. Les restrictions de priorité plus élevée (nombre plus grand) sont vérifiées en premier. Par exemple, une restriction de priorité 2 sera vérifiée avant la priorité 1.",
    other: 'Autre',
    condition_type: 'Type de restriction',
    email_domain_type: "Domaine d'email",
    email_address_type: 'Adresse email',
    email_addresses: 'Adresses email',
    add_email: 'Ajouter un email',
    import_csv: 'Importer depuis CSV',
    email_required: 'Au moins une adresse email est requise',
    emails_count: '{{count}} adresses email ajoutées',
    max_tickets_per_email: 'Nombre maximum de billets par e-mail',
    max_tickets_placeholder: 'Laissez vide pour illimité',
    max_tickets_helper:
      "Limitez le nombre de billets qu'un client peut acheter avec le même e-mail",
    max_tickets_info:
      'Définir pour limiter le nombre de billets pouvant être achetés avec une seule adresse e-mail. Laissez vide pour aucune limite.',
    min_tickets_value: 'La valeur minimale est 1',
    integer_tickets_value: 'Veuillez entrer un nombre entier',
    large_email_list_info:
      "Vous avez importé une grande liste d'adresses email. Cela peut prendre un certain temps pour traiter toutes les adresses.",
    showing_preview: "Afficher l'aperçu  pour les {{count}} adresses email importées",
  },
  single_ticket: 'Billet',
  Edit_Messages: 'Modifier les messages',
  Email_Preview: "Aperçu de l'email",
  Error_loading_email_template: "Erreur lors du chargement du modèle d'email",
  No_email_template_found: "Aucun modèle d'email trouvé",
  No_preview_available: 'Aucun aperçu disponible',
  Edit_success: 'Modification réussie !',
  Edit_failed: 'Échec de la modification !',
  Loading: 'Chargement...',
  multiple_tickets: 'Billets',
  access_restrictions: "Restrictions d'accès",
  hidden_links: 'Liens cachés',
  tickets_count: 'Nombre de billets',
  stop_sell_time: "L'arrêt des ventes est à",
  drag_drop_instruction: 'Glissez et déposez pour réorganiser les billets',
  create_tickets: 'Créez les billets pour votre événement',
  access_restriction_title: "Restriction d'accès",
  access_restriction_description: 'Gérez qui peut accéder à vos billets',
  add_access_restriction: "Ajouter une restriction d'accès",
  inactive: 'Inactif',
  priority: 'Priorité',
  allowed_domains: 'Domaines autorisés',
  delete_confirmation: "Êtes-vous sûr de vouloir supprimer cette restriction d'accès ?",
  'Domain-based': 'Basé sur le domaine',
  'Email-based': "Basé sur l'email",
  'Allowed Values': 'Valeurs autorisées',
  'email addresses': 'adresses email',
  'Access restrictions limit ticket purchases to specific email domains or addresses. Multiple restrictions can be active at the same time.':
    "Les restrictions d'accès limitent les achats de billets à des domaines ou adresses email spécifiques. Plusieurs restrictions peuvent être actives en même temps.",
  'Access restrictions limit ticket purchases to specific email domains or addresses. Only one restriction can be active at a time.':
    "Les restrictions d'accès limitent les achats de billets à des domaines ou adresses email spécifiques. Une seule restriction peut être active à la fois.",
  'Allowed Emails': 'Emails autorisés',
  more: 'de plus',
  'No access restrictions have been created yet. Create one to limit ticket purchases to specific email domains or addresses.':
    "Aucune restriction d'accès n'a encore été créée. Créez-en une pour limiter les achats de billets à des domaines ou adresses email spécifiques.",
  'Are you sure you want to delete this access restriction?':
    "Êtes-vous sûr de vouloir supprimer cette restriction d'accès?",
  'Successfully added': 'Ajouté avec succès',
  'Successfully updated': 'Mis à jour avec succès',
  // French translations
  bus: {
    title: 'Gestion des Navettes',
    newTrip: 'Nouvelle Navette',
    active: 'Actives',
    past: 'Passées',
    all: 'Toutes',
    name: 'Nom du car',
    description: 'Description',
    route: 'Itinéraire',
    departureLocation: 'Lieu de Départ',
    arrivalLocation: "Lieu d'Arrivée",
    duration: 'Durée',
    minutes: 'minutes',
    capacity: 'Capacité',
    price: 'Prix',
    currency: 'Devise',
    isRoundTrip: 'Aller-Retour',
    schedules: 'Horaires',
    noTripsFound: 'Aucune navette trouvée',
    noSchedulesFound: 'Aucun horaire trouvé pour cette navette',
    actions: 'Actions',
    addSchedule: 'Ajouter un Horaire',
    edit: 'Modifier la Navette',
    delete: 'Supprimer la Navette',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette navette ?',
    confirmDeleteSchedule: 'Êtes-vous sûr de vouloir supprimer cet horaire ?',
    departureDate: 'Date de Départ',
    departureTime: 'Heure de Départ',
    returnDate: 'Date de Retour',
    returnTime: 'Heure de Retour',
    availableSeats: 'Places Disponibles',
    status: 'Statut',
    createSuccess: 'Navette créée avec succès',
    createError: 'Erreur lors de la création de la navette',
    updateSuccess: 'Navette mise à jour avec succès',
    updateError: 'Erreur lors de la mise à jour de la navette',
    deleteSuccess: 'Navette supprimée avec succès',
    deleteError: 'Erreur lors de la suppression de la navette',
    scheduleAddSuccess: 'Horaire ajouté avec succès',
    scheduleAddError: "Erreur lors de l'ajout de l'horaire",
    scheduleDeleteSuccess: 'Horaire supprimé avec succès',
    scheduleDeleteError: "Erreur lors de la suppression de l'horaire",
    fetchError: 'Erreur lors de la récupération des navettes',
    import: 'Importer des trajets',
    importing: 'Importation des trajets de bus',
    importSuccess: 'Trajets de bus importés avec succès',
    importError: "Échec de l'importation des trajets de bus",
    parseError: "Échec de l'analyse du fichier JSON",
    readError: 'Échec de la lecture du fichier',
    invalidFileType: 'Type de fichier invalide. Veuillez sélectionner un fichier JSON',
    importBusTrips: 'Importer des trajets de bus',
    previewImport: "Aperçu de l'importation",
    foundTrips: '{count} trajets trouvés dans le fichier',
    details: 'Détails',
    roundTrip: 'Aller-retour',
    showSchedules: 'Afficher les horaires',
    hideSchedules: 'Masquer les horaires',
    importToDatabase: 'Importer dans la base de données',
    dropzoneInstructions: 'Téléchargez un fichier JSON avec les données des trajets de bus',
    dragAndDrop: 'Glissez et déposez votre fichier ici',
    dropFileHere: 'Déposez le fichier ici',
    orClickToSelect: 'ou cliquez pour sélectionner un fichier',
    onlyJsonFiles: 'Seuls les fichiers JSON sont pris en charge',
    direction: 'Direction',
    tripNumber: 'Trajet N°',
    filterByDirection: 'Filtrer par direction',
    allDirections: 'Toutes les directions',
    outbound: 'Aller',
    return: 'Retour',
    aller: 'Aller',
    retour: 'Retour',
    allSchedules: 'Tous les horaires',
    outboundSchedules: 'Horaires aller',
    returnSchedules: 'Horaires retour',
    outboundTripNote: 'Ce trajet aller ira de {from} à {to} avec une durée de {duration} minutes.',
    returnTripNote: 'Ce trajet retour ira de {from} à {to} avec une durée de {duration} minutes.',
    passengerCount: 'Passagers',
    bookingSummary: 'Résumé des Réservations',
    overallFillRate: 'Taux de Remplissage Global',
    totalPassengers: 'Passagers Totaux',
    trips: 'trajets',
    passengers: 'passagers',
    bookingLegend: 'Légende des Réservations',
    plentySeats: 'Places disponibles',
    fillingUp: 'En remplissage',
    almostFull: 'Presque complet',
    scheduleManager: 'Gestionnaire des Horaires',
    selectBus: 'Sélectionner un Bus',
    seats: 'places',
    viewSchedules: 'Voir les Horaires',
    editSchedule: "Modifier l'Horaire",
    statusActive: 'Actif',
    statusAvailable: 'Disponible',
    statusFull: 'Complet',
    statusCancelled: 'Annulé',
    scheduleUpdateSuccess: 'Horaire mis à jour avec succès',
    scheduleUpdateError: "Erreur lors de la mise à jour de l'horaire",
    totalRevenue: 'Revenu total',
    occupancyRate: "Taux d'occupation",
    busStats: 'Statistiques des bus',
    activeBuses: 'Bus actifs',
    totalSales: 'Ventes totales',
    fillRate: 'Taux de remplissement',
    totalCapacity: 'Capacité totale',
    allBuses: 'Tous les bus',
    observation: 'Observation',
    seatsLeft: 'places restantes',
    customMessage: 'Message client',
    customMessagePlaceholder:
      "Vous pouvez réserver des billets de bus dans les deux sens. Les billets de retour sont gratuits à l'achat d'un billet de départ.",
    customMessageHelp:
      'Ce message sera affiché aux clients lors de la sélection des bus pour ce trajet.',
  },
  // Role translations
  roles: {
    Owner: 'Propriétaire',
    organizer: 'Organisateur',
    promoter: 'Promoteur',
    ambassador: 'ambassadeur',
    bouncer: 'Videur',
    staff: 'Personnel',
    Ambassador: 'Ambassadeur',
    Bouncer: 'Videur',
    Staff: 'Personnel',
    Organizer: 'Organisateur',
    Referral: 'PromoBooster',
  },
  join_instadrink: 'Rejoindre ID Network',
  join_instadrink_network: 'Rejoindre le Réseau ID',
  become_part_of_our_community: 'Devenez membre de notre communauté',
  i_would_like_to_invite_you_to_join_my_network: 'Je vous invite à rejoindre mon réseau !',
  loading_public_invite: "Chargement du lien d'invitation...",
  join_network_now: 'Rejoindre le Réseau',
  please_fix_form_errors: 'Veuillez corriger les erreurs dans le formulaire',
  thank_you_for_joining_my_network: "Merci d'avoir rejoint mon réseau 🥂",
  invitation_request_sent_successfully_check_your_email_finish_registration:
    "Demande d'invitation envoyée avec succès. Veuillez vérifier votre email 📧 pour finaliser l'inscription.",
  i_am_a: 'Role',
  processing_invitation_request: "Traitement de la demande d'invitation...",
  // Invitation translations
  invitation: {
    you_are_invited_as: 'Vous êtes invité en tant que',
    invitation_date: "Date d'invitation",
    invitation_details: "Détails de l'invitation",
    invitation_preview: "Aperçu de l'invitation",
    please_fix_form_errors: 'Veuillez corriger les erreurs du formulaire',
    error_loading_invitation: "Erreur lors du chargement de l'invitation",
    status: {
      pending: 'En attente',
      accepted: 'Acceptée',
      canceled: 'Annulée',
      rejected: 'Refusée',
      expired: 'Expirée',
    },
    you_can_now_login: 'Vous pouvez maintenant vous connecter',
    redirecting_to_dashboard: 'Redirection vers le tableau de bord...',
    logging_in_automatically: 'Connexion automatique...',
    go_to_login: 'Aller à la page de connexion',
    account_created_successfully: 'Compte créé avec succès',
    by: 'par',
    password_requirements: {
      min: 'Au moins 8 caractères',
      uppercase: 'Au moins une lettre majuscule',
      lowercase: 'Au moins une lettre minuscule',
      number: 'Au moins un chiffre',
      special: 'Au moins un caractère spécial',
    },
  },
  tickets_in_reservation: 'Billets dans la réservation',
  payment_id: 'ID de paiement',
  origin: 'Origine',
  bus_tickets: 'Billets de bus',
  type: 'Type',
  route: 'Itinéraire',
  departure_time: 'Heure de départ',
  outbound: 'Aller',
  return: 'Retour',
  not_specified: 'Non spécifié',
  invalid_date: 'Date invalide',
  total_bus_tickets: 'Total billets de bus',
  mixed: 'Mixte',
  sent: 'Envoyé',
  not_sent: 'Non envoyé',
  view_details: 'Voir les détails',
  reservation_details: 'Détails de la Réservation',
  reservation_id: 'ID de Réservation',
  client: 'Client',
  email: 'Email',
  phone: 'Téléphone',
  payment_information: 'Informations de Paiement',
  total_tickets: 'Total des Billets',

  notes: 'Notes',
  edit_ticket: 'Modifier le billet',
  edit_client_information: 'Modifier les informations du client',
  edit_ticket_info: 'Modifier les informations du billet',

  edit_form: 'Formulaire',
  select_ticket_to_edit: 'Sélectionnez un billet à modifier',

  client_information: 'Informations client',
  ticket_holder_information: 'Informations du détenteur du billet',
  note_client_email_unchanged: "Note : L'email du client reste inchangé",

  update_failed: 'Mise à jour échouée',

  save_changes: 'Enregistrer les Modifications',
  saving: 'Enregistrement...',
  ticket_updated_successfully: 'Informations du billet mises à jour avec succès',
  error_updating_ticket: 'Erreur lors de la mise à jour des informations du billet',
  invalid_email_format: "Format d'email invalide",
  ticket: {
    insurance_options: 'Options de garantie',
    default_insurance_description: 'Garantie pour remboursement en cas d\'imprévu',
    enable_insurance: "Activer l'option de garantie remboursement pour les clients",
    insurance_price: 'Prix de le garantie',
    max_refund_time: 'Délai maximal de remboursement',
    refund_time_before_event:
      "Heures avant le début de l'événement où le remboursement est disponible",
    insurance_description: 'Description de le garantie',
    insurance_description_placeholder: 'Expliquez les conditions de garantie à vos clients',
    insurance_description_help:
      'Définissez les paramètres de garantie pour ce billet. Les clients pourront acheter cette assurance lors du paiement.',
    insurance_options_readonly: 'Les options de garantie sont en lecture seule.',
  },
  ticketView: {
    insurance: 'Assurance',
    insurance_available: 'Assurance remboursement disponible',
    insurance_price: 'Prix de le garantie',
    insurance_refund_time: 'Délai de remboursement',
    hours_before_event: "heures avant l'événement",
    insurance_description: 'Conditions de garantie',
  },
  event_faqs: {
    title: "FAQ de l'événement",
    tabs: {
      sections: 'Sections FAQ',
      useful_links: 'Liens utiles',
      contacts: 'Informations de contact',
    },
    add_section: 'Ajouter une section',
    edit_section: 'Modifier la section',
    section_title: 'Titre de la section',
    no_sections:
      "Aucune section FAQ créée. Cliquez sur 'Ajouter une section' pour créer votre première section.",
    items_count: '{{count}} questions',
    add_item: 'Ajouter une question',
    edit_item: 'Modifier la question',
    question: 'Question',
    answer: 'Réponse',
    no_items: 'Pas encore de questions dans cette section',
    confirm_delete_section:
      'Êtes-vous sûr de vouloir supprimer cette section? Toutes les questions de cette section seront supprimées.',
    confirm_delete_item: 'Êtes-vous sûr de vouloir supprimer cette question?',

    add_link: 'Ajouter un lien',
    edit_link: 'Modifier le lien',
    link_title: 'Titre du lien',
    link_url: 'URL',
    no_links: "Aucun lien utile créé. Cliquez sur 'Ajouter un lien' pour créer votre premier lien.",
    confirm_delete_link: 'Êtes-vous sûr de vouloir supprimer ce lien?',
    invalid_url: 'Veuillez entrer une URL valide (ex: https://exemple.com)',

    add_contact: 'Ajouter un contact',
    edit_contact: 'Modifier le contact',
    contact_name: 'Nom',
    contact_role: 'Rôle',
    contact_email: 'Email',
    contact_phone: 'Téléphone',
    no_contacts:
      "Aucun contact créé. Cliquez sur 'Ajouter un contact' pour créer votre premier contact.",
    confirm_delete_contact: 'Êtes-vous sûr de vouloir supprimer ce contact?',
    invalid_email: 'Veuillez entrer une adresse email valide',
  },
  common: {
    continue: 'Continuer',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    hours: 'Heures',
    minutes: 'Minutes',
    actions: 'Actions',
    save_success: 'Changes saved successfully',
    save_error: 'Error saving changes',
    error_loading: 'Error loading data',
    copy: 'Copier',
    copied: 'Copié',
    close: 'Fermer',
    remove: 'Supprimer',
    goBack: 'Retourner',
    none: 'Aucun',
  },
  ticketsStats: {
    timeAnalysis: 'Analyse Temporelle',
    dailySalesVelocity: 'Vélocité de Vente Quotidienne',
    hourlySalesVelocity: 'Vélocité de Vente Horaire',
    peakDays: 'Jours de Pointe des Ventes',
    peakHours: 'Heures de Pointe des Ventes',
    ticketsSold: 'Billets Vendus',
    salesCount: 'Nombre de Ventes',
    revenue: 'Revenu',
    noTimeData: 'Aucune donnée temporelle disponible',
    noHourlyDataForSelectedDay: 'Aucune donnée horaire disponible pour le jour sélectionné',
    noTicketData: "Aucune donnée de billet disponible pour l'analyse",
    day: 'Jour',
    hour: 'Heure',
    selectDay: 'Sélectionner un Jour',
    peakPeriods: 'Périodes de Pointe',
  },

  artistLineup: {
    title: 'Programmation Artistes',
    manageLineup: 'Gérer la Programmation des Artistes',
    currentLineup: 'Programmation Actuelle',
    noArtists: "Aucun artiste n'a encore été ajouté à cet événement.",
    addFirstArtist: 'Ajouter Votre Premier Artiste',
    addArtist: 'Ajouter un Artiste',
    editArtist: "Modifier l'Artiste",
    removeSuccess: 'Artiste supprimé avec succès',
    addSuccess: 'Artiste ajouté avec succès',
    updateSuccess: 'Artiste mis à jour avec succès',
    reorderSuccess: 'Programmation réorganisée avec succès',
    confirmRemove: 'Êtes-vous sûr de vouloir supprimer cet artiste ?',
    artistName: "Nom de l'Artiste",
    performanceTime: 'Heure de Performance',
    biography: 'Biographie',
    imageUrl: "URL de l'Image de l'Artiste",
    socialLinks: 'Réseaux Sociaux',
    website: 'Site Web',
    followers: 'abonnés',
    viewOnSpotify: 'Voir sur Spotify',
    generateLink: 'Partager avec Plateformes Musicales',
    shareMusicPlatform: 'Partager avec les Plateformes Musicales',
    shareInfo:
      "Partagez ces liens avec les plateformes musicales pour promouvoir votre événement. Le lien de réservation est destiné aux utilisateurs pour acheter des billets, tandis que le lien API fournit des données d'événement pour l'intégration.",
    bookingLinkTitle: 'Lien de Réservation (Pour Utilisateurs)',
    apiLinkTitle: 'Lien API (Pour Plateformes Musicales)',
    securityNote: 'Note de Sécurité',
    securityDetails:
      'Ces liens incluent un jeton de sécurité unique à votre événement. Vous pouvez régénérer le lien à tout moment si nécessaire.',
    linkCopied: 'Lien copié dans le presse-papiers',
    searchArtist: 'Rechercher un Artiste sur Spotify',
    searchSpotify: 'Rechercher un artiste sur Spotify',
    addArtistDetails: "Ajouter les Détails de l'Artiste",
    manualEntry: 'Vous ne trouvez pas votre artiste ? Ajoutez manuellement :',
    addManually: 'Ajouter un Artiste Manuellement',
    artistFound: 'Artiste trouvé sur Spotify ! Complétez les détails supplémentaires ci-dessous.',
    noResults: 'Aucun artiste trouvé avec ce nom',
    performsAt: 'Joue à',
    notifySubscribers: 'Notifier les Abonnés des Artistes',
    notifySuccess: 'Notification envoyée avec succès',
    confirmNotify:
      'Cela notifiera les abonnés des artistes Spotify dans votre programmation à propos de votre événement. Continuer ?',
  },
  passculture: {
    subtitle: 'Intégration Pass Culture',
    selectVenue: 'Sélectionner un lieu Pass Culture',
    saveVenue: 'Enregistrer le lieu',
    venueSaved: 'Lieu enregistré avec succès',
    venueSelectionHelp:
      'Sélectionnez un lieu Pass Culture pour lier votre événement. Vous devez avoir un lieu enregistré sur Pass Culture pour publier votre événement.',
    selectVenueDescription:
      'Avant de publier sur Pass Culture, vous devez sélectionner un lieu depuis votre compte Pass Culture.',
    venue: 'Lieu',
    venueSelected: 'Lieu Pass Culture sélectionné',
    venueLinkedSuccess:
      "Votre événement est maintenant lié à un lieu Pass Culture. Vous pouvez maintenant configurer la description de l'événement pour Pass Culture.",
    ticketCategories: 'Catégories de billets',
    // Description section
    eventDescription: 'Description Pass Culture',
    eventDescriptionHelp:
      'Fournissez une description détaillée de votre événement pour les utilisateurs de Pass Culture. Celle-ci peut être différente de la description principale de votre événement.',
    description: 'Description',

    // Publishing
    readyToPublish: 'Prêt à publier',
    publishInfo:
      'Votre événement est maintenant prêt à être publié sur Pass Culture. Cliquez sur le bouton ci-dessous pour publier.',
    publish: 'Publier sur Pass Culture',
    refreshStatus: 'Actualiser le statut',

    // Publication data
    publicationData: 'Données de publication Pass Culture',
    publishedOn: 'Publié le',
    publishing: 'Publication en cours...',
    passCultureId: 'ID Pass Culture',
    status: 'Statut',
    details: "Détails de l'événement Pass Culture",

    // Success messages
    success: {
      venueSaved: "Lieu associé avec succès à l'événement",
      descriptionSaved: 'Description Pass Culture enregistrée avec succès',
      eventPublished: "Événement '{name}' publié avec succès sur Pass Culture",
      statusRefreshed: 'Statut Pass Culture actualisé avec succès',
      emailSaved: 'Email de contact enregistré avec succès',
      stocksAdded: 'Les stocks ont été ajoutés avec succès à Pass Culture',
    },

    // Error messages
    errors: {
      noVenueSelected: 'Vous devez sélectionner un lieu avant de publier sur Pass Culture',
      saveFailed: "Échec de l'enregistrement des modifications",
      loadingVenuesFailed: 'Échec du chargement des lieux depuis Pass Culture',
      publishEventFailed: "Échec de la publication de l'événement sur Pass Culture",
      refreshStatusFailed: "Échec de l'actualisation du statut Pass Culture",
      eventNotFound: 'Événement non trouvé',
      invalidEmail: 'Veuillez saisir une adresse email valide',
      noContactEmail: 'Veuillez fournir un email de contact avant de publier',
      addStocksFailed: "Échec de l'ajout des stocks à Pass Culture",
    },

    contactEmail: 'Email de contact',
    contactEmailHelp:
      'Veuillez fournir un email de contact pour les utilisateurs Pass Culture. Cet email sera affiché aux utilisateurs sur la plateforme Pass Culture.',
    email: 'Email',
    addStocks: 'Ajouter des stocks',
    stocksInformation: 'Informations sur les stocks',
    stocksAddedSuccess: '{{count}} stocks ont été ajoutés avec succès à Pass Culture',
    stocksCount: 'Total des stocks',
    lastStockUpdate: 'Dernière mise à jour',
    warnings: {
      noStocks: "Aucun stock n'a encore été ajouté à cet événement sur Pass Culture",
      noTicketsFound:
        "Aucun billet trouvé pour cet événement. Veuillez créer des billets avant d'ajouter des stocks.",
      noOrganizerLinked:
        "Cet événement n'est pas lié à un organisateur. Veuillez d'abord attribuer un organisateur à l'événement.",
    },

    stocks: {
      dialogTitle: 'Ajouter des stocks à Pass Culture',
      step1: 'Configurer les stocks',
      step1Description:
        'Choisissez comment vous souhaitez ajouter des stocks à Pass Culture pour cet événement.',
      step2: 'Confirmer et créer',
      step2Description: 'Vérifiez votre sélection et créez les stocks sur Pass Culture.',
      step3: 'Succès',
      step3Description: 'Vos stocks ont été créés avec succès sur Pass Culture.',
      useExistingTickets: 'Utiliser les billets existants de mon événement',
      ticketsFound: 'Billets trouvés',
      ticketsDescription:
        "Vos billets d'événement seront automatiquement associés aux catégories de prix de Pass Culture.",
      willUseExistingTickets: 'Vous allez créer {{count}} stocks basés sur vos billets existants',
      willCreateCustomStocks: 'Vous allez créer des stocks personnalisés sur Pass Culture',
      createStocks: 'Créer des stocks',
      successMessage: 'Les stocks ont été créés avec succès sur Pass Culture',
    },

    // Dialog content
    publishDialog: {
      title: 'Publier sur Pass Culture',
      publishing: 'Publication en cours...',
      description:
        'Vous êtes sur le point de publier cet événement sur Pass Culture. Une fois publié, il sera disponible pour les utilisateurs de Pass Culture après approbation.',
    },

    // Event status

    eventDetails: "Détails de l'événement",
    category: 'Catégorie',
    date: 'Date',
    time: 'Heure',

    venueId: 'ID du lieu',
    passCultureInfo: 'Informations Pass Culture',

    passCultureIntegration: 'Intégration Pass Culture',
    notPublishedYet: "Cet événement n'a pas encore été publié sur Pass Culture.",

    currentStatus: 'Statut actuel',
    passCultureDetails: 'Détails Pass Culture',
    lastUpdated: 'Dernière mise à jour',
    bookingsCount: 'Réservations',
    remainingStock: 'Stock restant',
    publicationDate: 'Date de publication',
    lastModified: 'Dernière modification',
    rejectionReason: 'Motif de rejet',
    rawResponse: 'Données brutes de Pass Culture',
    unknown: 'Inconnu',
    noStatusData:
      "Aucune donnée de statut n'est disponible. Vérifiez le statut pour obtenir des informations à jour.",
    checkStatus: 'Vérifier le statut',
    ticketsMapping: 'Correspondance des billets',
    ticketsMappingDescription:
      "Ce tableau montre comment vos billets d'événement sont associés aux catégories Pass Culture.",
    price: 'Prix',
    available: 'Disponible',
    passCultureCategory: 'Catégorie Pass Culture',
    notMapped: 'Non associé',
    ticketsMappingNote:
      'Seuls les billets disponibles à la vente seront associés aux catégories Pass Culture.',
    noTicketsAvailable: "Aucun billet n'est disponible pour cet événement.",
    ticketInfo: 'Informations sur les billets',
    moreCategories: 'Et plus de catégories...',
    tabs: {
      overview: 'Aperçu',
      status: 'Statut',
      tickets: 'Billets',
    },

    events: {
      notPublished: 'Non publié',
      publishError: 'Erreur de publication',
      published: 'Publié',
    },
    comingSoon: {
      title: 'Intégration Pass Culture',
      message:
        "L'intégration avec Pass Culture arrive bientôt. Cette fonctionnalité vous permettra de publier vos événements sur la plateforme Pass Culture. Restez à l'écoute pour les mises à jour !",
    },
  },
  passculturedocumentation: {
    title: 'Intégration Pass Culture',
    category: "Configuration d'Événement",
    intro:
      "Pass Culture est une initiative du gouvernement français qui fournit des bons culturels aux jeunes. En vous intégrant avec Pass Culture, vous pouvez rendre vos événements accessibles aux utilisateurs de Pass Culture et élargir votre portée d'audience. Ce guide vous accompagnera dans le processus complet de configuration pour intégrer des événements individuels avec Pass Culture.",
    important: 'Important :',
    eventLevelConfig:
      "L'intégration Pass Culture est configurée au niveau de l'événement. Chaque événement que vous souhaitez rendre disponible sur Pass Culture doit être configuré individuellement via son propre onglet Pass Culture.",

    whatIs: {
      title: "Qu'est-ce que Pass Culture ?",
      description:
        'Pass Culture est une plateforme numérique qui offre des crédits culturels aux jeunes de 15 à 20 ans en France. Les utilisateurs reçoivent des bons qui peuvent être utilisés pour acheter des produits et services culturels, notamment :',
      services: {
        concerts: 'Concerts et événements musicaux',
        theater: 'Billets de théâtre et de cinéma',
        books: 'Livres et ateliers culturels',
        exhibitions: "Expositions d'art et expériences culturelles",
      },
    },

    benefits: {
      title: "Avantages de l'Intégration",
      youngAudience: 'Atteindre un public jeune (15-20 ans)',
      governmentBacked: 'Système de paiement soutenu par le gouvernement',
      visibility: 'Visibilité accrue des événements',
      guaranteedPayments: 'Paiements garantis',
    },

    prerequisites: {
      title: 'Prérequis',
      description:
        'Avant de pouvoir vous intégrer avec Pass Culture, vous devez remplir certaines exigences et avoir des informations spécifiques prêtes.',
      business: {
        title: 'Informations Commerciales Requises',
        siren: 'Numéro SIREN ou SIRET',
        sirenDesc: "Votre numéro officiel d'enregistrement commercial français",
        legalEntity: 'Entité juridique commerciale',
        legalEntityDesc: 'Doit être une entreprise enregistrée en France',
        license: "Licence d'activité culturelle",
        licenseDesc: "Licence appropriée pour l'organisation d'événements culturels",
      },
      account: {
        title: 'Configuration du Compte Pass Culture',
        register: "S'inscrire sur Pass Culture Pro",
        registerDesc: 'Créer un compte sur https://passculture.pro',
        verification: 'Compléter la vérification commerciale',
        verificationDesc: 'Soumettre les documents requis pour approbation',
        apiAccess: "Approbation d'accès API",
        apiAccessDesc: "Attendre l'approbation de l'équipe Pass Culture pour l'accès API",
      },
    },

    integration: {
      title: "Guide de Configuration d'Intégration",
      description:
        "Suivez ces étapes pour intégrer Pass Culture avec votre organisation Instadrink. Assurez-vous d'avoir complété les prérequis avant de commencer.",
    },

    steps: {
      businessId: {
        title: 'Ajouter Votre Identifiant Commercial',
        description:
          "D'abord, vous devez ajouter votre numéro SIREN ou SIRET au profil de votre organisation dans Instadrink.",
        step1: "Aller dans Paramètres de l'Organisation → Informations Générales",
        step2: 'Saisir votre numéro SIREN (9 chiffres) ou SIRET (14 chiffres)',
        step3: 'Sauvegarder les paramètres de votre organisation',
        warning:
          'Votre numéro SIREN/SIRET doit correspondre exactement à celui enregistré dans votre compte Pass Culture Pro.',
      },
      access: {
        title: "Accéder à l'Intégration Pass Culture",
        description:
          "Naviguer vers la section d'intégration Pass Culture pour votre événement spécifique.",
        step1: "Aller sur votre Tableau de Bord d'Événement",
        step2: "Cliquer sur l'onglet 'Pass Culture' dans les paramètres de l'événement",
        step3: 'Vous verrez le numéro SIREN/SIRET de votre organisation affiché',
      },
      venue: {
        title: "Sélectionner le Lieu de l'Événement",
        description:
          "Une fois dans l'onglet Pass Culture, vous verrez les lieux disponibles basés sur le numéro SIREN/SIRET de votre organisation. Sélectionnez le lieu où cet événement spécifique aura lieu.",
        step1: "Dans l'onglet Pass Culture, vous verrez un menu déroulant de sélection de lieu",
        step2:
          'Les lieux disponibles sont automatiquement chargés basés sur le SIREN/SIRET de votre organisation',
        step3: 'Sélectionner le lieu où votre événement aura lieu dans le menu déroulant',
        step4:
          'Examiner les détails du lieu (adresse, accessibilité, etc.) qui apparaissent à droite',
        step5: "Cliquer 'Sauvegarder le Lieu' pour lier ce lieu à votre événement",
        noVenuesInfo:
          "Si aucun lieu n'apparaît, vous pourriez avoir besoin de synchroniser avec Pass Culture d'abord (voir étape suivante) ou vérifier que le SIREN/SIRET de votre organisation est correctement configuré et a des lieux associés dans Pass Culture.",
      },
      eventDetails: {
        title: "Préparer les Détails de l'Événement pour la Publication",
        description:
          'Maintenant que vous avez sélectionné un lieu, vous devez préparer deux éléments clés avant de pouvoir publier votre événement sur Pass Culture.',
        importantNote:
          "Seulement deux champs sont requis à cette étape : description de l'événement et email de contact. Cependant, votre événement doit aussi avoir des billets avec des catégories PassCulture pour activer la publication.",
        requiredInfo: "Informations d'Événement Requises :",
        eventDescription: "Description de l'Événement pour Pass Culture",
        eventDescriptionTip:
          'Adaptez votre description pour plaire aux jeunes de 15-20 ans. Utilisez un langage engageant et accessible et mettez en valeur ce qui rend votre événement spécial.',
        contactEmail: 'Email de Contact pour les Utilisateurs Pass Culture',
        contactEmailTip:
          'Fournissez une adresse email spécifique où les utilisateurs Pass Culture peuvent vous joindre avec des questions sur votre événement.',
        ticketRequirement: 'Exigence Critique - Catégories de Billets PassCulture :',
        veryImportant: 'Très Important :',
        ticketWarning:
          "Pour publier un événement sur Pass Culture, votre événement doit avoir des billets avec des catégories PassCulture. Le bouton publier restera désactivé jusqu'à ce que cette condition soit remplie.",
        createCategories: 'Créer des Catégories de Billets PassCulture',
        createCategoriesDesc:
          "Aller dans l'onglet Billets de votre événement → Catégories, et créer au moins une catégorie avec 'Intégration PassCulture' activée",
        enableIntegration: "Activer l'Intégration PassCulture",
        enableIntegrationDesc:
          "Lors de la création ou modification d'une catégorie de billet, activer le paramètre 'Intégration PassCulture'",
        createTickets: 'Créer des Billets avec des Catégories PassCulture',
        createTicketsDesc:
          "Assurez-vous d'avoir des billets actifs assignés à ces catégories activées PassCulture",
        publishingConditions: 'Conditions de Publication :',
        condition1: "Description de l'événement remplie et optimisée pour un public jeune",
        condition2: 'Email de contact valide fourni',
        condition3: "Au moins une catégorie de billet a l'intégration PassCulture activée",
        condition4: "L'événement a des billets actifs utilisant des catégories PassCulture",
        condition5: "Date de l'événement est d'au moins 15 jours dans le futur",
        condition6: 'Prix des billets sont dans les limites Pass Culture (max 300€)',
        proTip:
          "Si le bouton publier reste désactivé après avoir rempli le formulaire, vérifiez que vous avez créé des catégories de billets avec l'intégration PassCulture activée dans l'onglet Billets.",
        writingTips:
          'Utilisez des mots-clés comme "étudiants", "jeunes artistes", mentionnez des prix spéciaux ou remises étudiantes, et mettez en valeur les aspects sociaux/culturels qui plaisent aux 15-20 ans.',
        howToFillTitle: 'Comment remplir les informations requises :',
        howToFillStep1:
          "Dans l'onglet Pass Culture, vous verrez des champs de texte pour la description et l'email de contact",
        howToFillStep2:
          "Remplissez les deux champs et cliquez sur 'Enregistrer' pour stocker vos informations",
        howToFillStep3:
          "Le bouton 'Publier sur Pass Culture' sera activé lorsque toutes les conditions seront remplies",
        howToFillStep4:
          "Cliquez sur 'Publier sur Pass Culture' pour envoyer votre événement à la plateforme Pass Culture",
      },
      finalConfirmation: {
        title: 'Confirmation Finale et Publication',
        description:
          'Une fois que toutes les conditions sont remplies et que vous cliquez sur "Publier sur Pass Culture", une boîte de dialogue de confirmation apparaîtra pour que vous puissiez réviser toutes les informations de l\'événement une dernière fois avant de les envoyer à Pass Culture.',
        publishingDialog: 'Dialogue de Publication - Révision Finale :',
        step1: "Cliquer sur le bouton 'Publier sur Pass Culture' lorsqu'il devient activé",
        step2:
          "Une boîte de dialogue de confirmation s'ouvrira montrant tous les détails de l'événement",
        step3: 'Examiner attentivement toutes les informations affichées dans la boîte de dialogue',
        step4: "Cliquer 'Publier sur Pass Culture' pour confirmer et envoyer à Pass Culture",
        informationDisplayed: 'Informations Affichées dans la Boîte de Dialogue de Confirmation :',
        venue: 'Lieu (Lieu)',
        venueDesc: "L'ID du lieu Pass Culture où votre événement aura lieu",
        contactEmailInfo: 'Email de Contact (Email de contact)',
        contactEmailInfoDesc:
          "L'email de contact que les utilisateurs Pass Culture utiliseront pour vous joindre",
        eventDescriptionInfo: "Description de l'Événement (Description)",
        eventDescriptionInfoDesc:
          "Aperçu de votre description d'événement optimisée pour Pass Culture",
        passCultureCategories: 'Catégories Pass Culture',
        passCultureCategoriesDesc:
          "Liste des catégories de billets qui ont l'intégration Pass Culture activée",
        imageCaption:
          "La boîte de dialogue de confirmation finale montrant tous les détails de l'événement avant la publication sur Pass Culture",
        lastChanceTitle: 'Dernière Chance de Réviser :',
        lastChanceWarning:
          "C'est votre dernière opportunité de vérifier toutes les informations avant d'envoyer votre événement à Pass Culture. Assurez-vous que tout est correct, en particulier le lieu et l'email de contact, car ceux-ci ne peuvent pas être facilement modifiés après la publication.",
        afterPublishing: 'Après avoir Cliqué "Publier sur Pass Culture" :',
        publishingProcess: 'Processus de Publication',
        publishingProcessDesc:
          "Le système enverra vos données d'événement à Pass Culture (peut prendre quelques secondes)",
        successConfirmation: 'Confirmation de Succès',
        successConfirmationDesc:
          "Vous recevrez un message de succès lorsque l'événement sera publié avec succès",
        stocksDialog: 'Dialogue de Stocks',
        stocksDialogDesc:
          "Une nouvelle boîte de dialogue s'ouvrira pour vous aider à ajouter des stocks de billets à Pass Culture",
        whatHappensNextTitle: 'Ce qui se Passe Ensuite :',
        whatHappensNext:
          "Après une publication réussie, votre événement sera visible dans l'environnement d'intégration de Pass Culture pour les tests, ou en production après l'approbation de modération (généralement 24-48 heures).",
        tipTitle: 'Conseil :',
        cancelTip:
          'Si vous devez annuler ou apporter des modifications, cliquez "Annuler" pour revenir en arrière et modifier les détails de votre événement avant la publication.',
      },
      addStocks: {
        title: 'Ajouter des Stocks à Pass Culture',
        description:
          'Une fois votre événement publié avec succès sur Pass Culture, vous devez ajouter des stocks pour permettre aux utilisateurs de réserver des billets.',
        stockDefinition: {
          title: '📋 Clarification importante :',
          description:
            'Dans la terminologie Pass Culture, un "stock" n\'est pas littéralement un billet. Un stock représente une combinaison de :',
          dates: 'Dates et heures spécifiques',
          datesDesc: "où l'événement a lieu",
          quantity: 'Nombre de billets disponibles',
          quantityDesc: 'pour ces dates/heures',
          pricing: 'Informations de tarification',
          pricingDesc: 'pour les billets',
          category: 'Catégorie de billet',
          categoryDesc: '(ex: Standard, VIP, Étudiant, etc.)',
        },
        eventStatusAfterPublishing: "Statut de l'événement après publication",
        statusPublished: 'Événement publié sur Pass Culture',
        statusPublishedDesc:
          'Votre événement est maintenant visible sur Pass Culture mais ne peut pas encore être réservé',
        venueAndContact: 'Lieu et contact configurés',
        venueAndContactDesc:
          'Les informations de lieu et de contact sont enregistrées dans Pass Culture',
        stocksWarningTitle: 'Votre événement a besoin de stocks pour être réservable',
        stocksWarningDesc:
          'Sans stocks (combinaisons date/heure/tarif), les utilisateurs ne peuvent pas réserver de billets via Pass Culture, même si votre événement est publié',
        understandingStocks: {
          title: 'Comprendre les Stocks vs Billets',
          exampleTitle: 'Exemple :',
          exampleDescription:
            'Si vous avez un concert le vendredi à 20h avec 100 billets à 25€ chacun, cela crée un stock dans Pass Culture. Si vous avez aussi un spectacle le samedi à 20h avec 150 billets à 30€ chacun, cela crée un deuxième stock.',
          formula:
            'Chaque stock = Une combinaison spécifique de date + heure + prix + quantité disponible + catégorie de billet',
        },
        addingStocksProcess: "Processus d'ajout de stocks",
        processStep1: "Cliquer sur le bouton 'Ajouter des Stocks' dans l'onglet Pass Culture",
        processStep2:
          'Sélectionner quelles catégories de billets doivent être disponibles sur Pass Culture',
        processStep3: "Choisir les dates/heures d'événement spécifiques à inclure",
        processStep4:
          "Définir la quantité et le tarif pour chaque combinaison (cela crée les 'stocks')",
        step1SelectCategories: 'Étape 1 : Sélectionner les catégories de billets',
        onlyPassCultureCategoriesUpdated:
          'Seules les catégories activées Pass Culture apparaissent',
        onlyPassCultureCategoriesUpdatedDesc:
          "Rappel : vous devez activer 'Intégration PassCulture' lors de la création des catégories de billets",
        preSelectedCategoriesUpdated:
          "Les catégories sont pré-sélectionnées si elles ont l'intégration Pass Culture activée",
        preSelectedCategoriesUpdatedDesc:
          'Vous pouvez décocher les catégories que vous ne voulez pas inclure dans cette création de stock',
        continueStepUpdated: "Cliquer sur 'Continuer' pour procéder à la sélection date/heure",
        imageAltUpdated:
          "Dialogue d'ajout de stocks Pass Culture montrant la sélection des catégories de billets",
        imageCaptionUpdated:
          'Étape 1 : Sélectionner quelles catégories de billets inclure dans vos stocks Pass Culture',
        remainingStepsOverviewUpdated: 'Aperçu des Étapes Restantes',
        remainingStep2Title: "Sélectionner les Dates et Heures d'Événement",
        remainingStep2Desc:
          'Choisir quelles représentations/sessions spécifiques rendre disponibles sur Pass Culture',
        remainingStep3Title: 'Définir les Quantités et Tarifs',
        remainingStep3Desc:
          'Définir combien de billets sont disponibles et à quel prix pour chaque combinaison date/catégorie',
        remainingStep4Title: 'Confirmer et Créer les Stocks',
        remainingStep4Desc:
          'Vérifier toutes les combinaisons et créer les stocks qui seront envoyés à Pass Culture',
        whatThisAchievesUpdatedTitle: 'Ce que cela accomplit :',
        whatThisAchievesUpdated:
          'Chaque combinaison unique de date/heure + catégorie de billet + tarif devient un "stock" séparé dans Pass Culture. Cela permet aux utilisateurs de voir toutes les options disponibles et de réserver la représentation et le type de billet spécifiques qu\'ils veulent.',
        importantWithoutStocksUpdated:
          'Sans stocks, votre événement apparaît sur Pass Culture mais ne peut pas être réservé. Les stocks sont ce qui rend votre événement réellement achetable par les utilisateurs Pass Culture.',
      },
    },

    proTip: 'Conseil Pro :',
    writingTips: 'Conseils de Rédaction pour Public Jeune :',

    venuesOfferers: {
      title: 'Comprendre les Lieux et Structures',
      offerer: {
        title: 'Structure',
        description:
          'La structure représente votre organisation/entité commerciale dans Pass Culture. Elle contient vos informations commerciales et est liée à votre numéro SIREN.',
        includes: 'La structure inclut :',
        item1: 'Nom commercial et informations légales',
        item2: 'Numéro SIREN',
        item3: 'Date de création du compte',
        item4: 'Statut de validation',
      },
      venues: {
        title: 'Lieux',
        description:
          "Les lieux sont les emplacements physiques où vos événements ont lieu. Chaque lieu a des informations spécifiques et des détails d'accessibilité.",
        includes: 'Chaque lieu inclut :',
        item1: 'Nom et adresse du lieu',
        item2: 'Numéro SIRET (si applicable)',
        item3: "Informations d'accessibilité",
        item4: "Domaine d'activité",
      },
    },

    environments: {
      title: "Environnement d'Intégration vs Production",
      features: 'Fonctionnalités :',
      warningNote:
        "Testez toujours minutieusement dans l'environnement d'intégration avant de demander l'accès en production. L'équipe Pass Culture examinera votre intégration et pourrait exiger des modifications avant approbation.",
      integration: {
        label: 'Intégration',
        title: 'Environnement de Test',
        description:
          'Utilisé pour les tests et le développement. Vos événements ne seront pas visibles aux vrais utilisateurs Pass Culture.',
        feature1: 'Environnement de test sécurisé',
        feature2: "Pas de transactions d'argent réel",
        feature3: 'Événements non visibles au public',
        feature4: 'Fonctionnalité API complète',
      },
      production: {
        label: 'Production',
        title: 'Environnement en Direct',
        description:
          "L'environnement en direct où vos événements sont visibles aux vrais utilisateurs Pass Culture.",
        feature1: 'Événements visibles au public',
        feature2: "Transactions d'argent réel",
        feature3: 'Intégration Pass Culture complète',
        feature4: "Nécessite l'approbation Pass Culture",
      },
    },

    troubleshooting: {
      title: 'Dépannage des Problèmes Courants',
      solutions: 'Solutions :',
      noVenues: {
        title: 'Erreur "Aucun lieu trouvé"',
        description:
          "Cela signifie généralement que votre SIREN/SIRET n'est pas trouvé dans Pass Culture ou n'a pas de lieux associés.",
        solution1: 'Vérifiez que votre numéro SIREN/SIRET est correct',
        solution2: 'Vérifiez que vous avez complété la configuration de lieu dans Pass Culture Pro',
        solution3: 'Contactez le support Pass Culture pour vérifier le statut de votre compte',
      },
      syncFailed: {
        title: 'Erreur "Échec de synchronisation"',
        description:
          "Problèmes de réseau ou d'authentification empêchant la synchronisation avec l'API Pass Culture.",
        solution1: 'Vérifiez votre connexion internet et réessayez',
        solution2: 'Attendez quelques minutes et relancez la synchronisation',
        solution3: 'Contactez le support Instadrink si le problème persiste',
      },
      needSiren: {
        title: 'Avertissement "Besoin SIREN ou SIRET"',
        description: "Le profil de votre organisation n'a pas de numéro SIREN ou SIRET configuré.",
        solution1: 'Aller dans Paramètres Organisation → Informations Générales',
        solution2: 'Ajouter votre numéro SIREN à 9 chiffres ou SIRET à 14 chiffres',
      },
      eventsNotAppearing: {
        title: "Événements n'apparaissant pas dans Pass Culture",
        description: 'Vos événements sont créés mais pas visibles sur la plateforme Pass Culture.',
        solution1:
          "Assurez-vous d'avoir sélectionné un lieu Pass Culture pour votre événement dans l'onglet Pass Culture de l'événement",
        solution2: "Vérifiez que votre événement respecte les critères d'éligibilité Pass Culture",
        solution4: 'Attendez 24-48 heures pour la modération Pass Culture',
      },
    },

    bestPractices: {
      title: 'Meilleures Pratiques',
      regularSync: {
        title: 'Synchronisation Régulière',
        description:
          "Synchronisez vos lieux régulièrement pour vous assurer d'avoir les dernières informations de Pass Culture, surtout si vous avez ajouté de nouveaux lieux ou mis à jour des existants.",
      },

      targetAudience: {
        title: 'Public Cible',
        description:
          "Rappelez-vous que les utilisateurs Pass Culture ont entre 15 et 20 ans. Adaptez vos descriptions d'événements et marketing pour plaire à cette démographie plus jeune.",
      },
    },

    eventRequirements: {
      title: "Exigences d'Événements Pass Culture",
      description:
        'Tous les événements ne sont pas éligibles pour Pass Culture. Assurez-vous que vos événements respectent ces critères :',
      eligible: {
        title: "Types d'Événements Éligibles",
        concerts: 'Concerts et performances musicales en direct',
        theater: 'Spectacles de théâtre et performances dramatiques',
        artExhibitions: "Expositions d'art et ateliers culturels",
        literaryEvents: 'Événements littéraires et présentations de livres',
        photography: 'Expositions de photographie et multimédia',
        cinema: 'Projections de cinéma et festivals de films',
      },
      nonEligible: {
        title: "Types d'Événements Non-Éligibles",
        sports: 'Événements sportifs et compétitions',
        business: "Conférences d'affaires et séminaires",
        privateParties: 'Fêtes privées et célébrations',
        commercial: 'Lancements de produits commerciaux',
        religious: 'Événements religieux ou politiques',
        educational: 'Cours éducatifs ou formations',
      },
      additional: {
        title: 'Exigences Supplémentaires',
        timing: 'Timing',
        timing1:
          "Les événements doivent être publiés au moins 15 jours avant la date de l'événement",
        timing2: "La réservation doit fermer au moins 2 heures avant le début de l'événement",
        pricing: 'Prix',
        pricing1: 'Prix maximum du billet : 300€',
        pricing2: 'Les événements gratuits sont autorisés et encouragés',
      },
    },

    support: {
      title: 'Support et Ressources',
      links: {
        title: 'Liens Utiles',
        pro: 'Pass Culture Pro',
        proDesc: 'https://passculture.pro - Plateforme principale pour les fournisseurs culturels',
        documentation: 'Documentation Pass Culture',
        documentationDesc: 'Documentation API officielle et directives',
        app: 'Application Pass Culture',
        appDesc: "Téléchargez l'app pour voir comment vos événements apparaissent aux utilisateurs",
      },
      help: {
        title: "Obtenir de l'Aide",
        instadrink: 'Support Instadrink',
        instadrinkDesc: "support@instadrink.com - Pour les problèmes techniques d'intégration",
        passculture: 'Support Pass Culture',
        passcultureDesc:
          'Contactez via la plateforme Pass Culture Pro pour les problèmes de compte',
        liveChat: 'Chat en Direct',
        liveChatDesc: 'Utilisez le widget de chat dans votre tableau de bord Instadrink',
      },
    },

    faq: {
      title: 'Questions Fréquemment Posées',
      q1: {
        question: 'Q : Combien de temps faut-il pour être approuvé pour Pass Culture ?',
        answer:
          "R : Le processus d'approbation prend généralement 2 à 4 semaines après avoir soumis tous les documents requis. Les tests et la validation peuvent ajouter 1 à 2 semaines supplémentaires avant l'approbation en production.",
      },
      q2: {
        question: 'Q : Puis-je utiliser Pass Culture si je ne suis pas basé en France ?',
        answer:
          "R : Pass Culture est spécifiquement pour les fournisseurs culturels opérant en France. Vous avez besoin d'un numéro SIREN/SIRET français et vos événements doivent avoir lieu en France.",
      },
      q3: {
        question: 'Q : Que se passe-t-il si mon événement est annulé ?',
        answer:
          "R : Si vous annulez un événement, les utilisateurs Pass Culture seront automatiquement remboursés. Vous devriez annuler l'événement à la fois dans Instadrink et notifier Pass Culture dès que possible.",
      },
      q4: {
        question: 'Q : Comment puis-je recevoir les paiements des réservations Pass Culture ?',
        answer:
          'R : Pass Culture gère les paiements directement et transfère les fonds sur votre compte bancaire selon leur calendrier de paiement. Vous configurerez les détails bancaires dans votre compte Pass Culture Pro.',
      },
      q5: {
        question:
          "Q : Puis-je modifier les événements après qu'ils soient publiés sur Pass Culture ?",
        answer:
          "R : Oui, mais les changements sont soumis aux politiques de Pass Culture. Les changements majeurs comme la date, l'heure ou le lieu peuvent nécessiter une re-approbation. Les augmentations de prix ne sont généralement pas autorisées après publication.",
      },
    },
    readyToStart: {
      title: 'Prêt à Commencer ?',
      description:
        "Maintenant que vous comprenez comment fonctionne l'intégration Pass Culture, vous êtes prêt à commencer le processus de configuration ! Commencez par vous assurer d'avoir votre numéro SIREN ou SIRET, puis suivez le guide étape par étape ci-dessus.",
      button: "Commencer la Configuration d'Intégration",
    },
  },

  dashboard: 'Tableau de bord',
  organizers: 'Organisateurs',
  organizerDetails: "Détails de l'organisateur",
  generalInfo: 'Informations générales',
  backToOrganizers: 'Retour aux organisateurs',
  backToOrganizer: "Retour à l'organisateur",
  organizerNotFound: 'Organisateur non trouvé',
  failedToFetchOrganizer: "Échec de récupération des données de l'organisateur",

  // Integration specific
  integrations: 'Intégrations',
  integrationsPageDescription:
    'Connectez votre organisateur à des services externes pour améliorer vos événements et atteindre plus de clients.',
  comingSoon: 'Bientôt disponible',
  integrationComingSoon:
    "L'intégration {name} est actuellement en développement et sera bientôt disponible.",

  // Integration descriptions
  passCultureIntegrationDescription:
    'Pass Culture est une application mobile et un site web qui offre 300€ aux jeunes de 18 ans à dépenser en biens et expériences culturels. Connectez votre organisateur pour importer automatiquement les lieux et publier vos événements.',
  ticketingIntegrationDescription:
    "Connectez votre organisateur aux plateformes de billetterie populaires pour synchroniser les données d'événements, gérer les ventes de billets et suivre la participation sur plusieurs canaux.",
  crmIntegrationDescription:
    "Intégrez des systèmes de gestion de la relation client pour gérer votre base de clients, suivre l'historique des communications et créer des campagnes marketing pour vos événements.",

  // Tab labels
  ticketing: 'Billetterie',

  // Pass Culture specific translations
  passCultureIntegration: 'Intégration Pass Culture',
  identifier: 'Identifiant',
  noIdentifier: 'Aucun identifiant configuré',
  lastSynced: 'Dernière synchronisation',
  venues: 'Lieux',
  offerer: 'Offreur',
  syncWithPassCulture: 'Synchroniser avec Pass Culture',
  passCultureVenues: 'Lieux Pass Culture',
  passCultureOfferer: 'Offreur Pass Culture',
  syncResults: 'Résultats de synchronisation',
  noVenuesFound: 'Aucun lieu trouvé',
  noOffererData: "Données d'offreur non disponibles",
  syncedVenues: '{{count}} lieux synchronisés avec succès',
  passCultureSyncSuccess: '{{count}} lieux synchronisés avec succès avec Pass Culture',
  passCultureSyncFailed: 'Échec de la synchronisation avec Pass Culture',
  syncFailed: 'La synchronisation a échoué',
  needSirenOrSiret:
    "L'organisateur a besoin d'un numéro SIREN ou SIRET pour se synchroniser avec Pass Culture",
  close: 'Fermer',
  never: 'Jamais',
  siren: 'SIREN',
  createdAt: 'Créé le',
  additionalInfo: 'Informations supplémentaires',
  notAvailable: 'Non disponible',
  goodies: {
    // Section Headers
    section: {
      title: 'Produits Dérivés',
      description:
        'Gérez les produits dérivés que les clients peuvent acheter lors de la réservation de billets pour cet événement.',
    },

    // Actions
    actions: {
      new: 'Ajouter un produit',
      edit: 'Modifier le produit',
      add: 'Ajouter un produit',
      save: 'Enregistrer les modifications',
      create: 'Créer un produit',
      delete: 'Supprimer le produit',
      delete_confirm:
        'Êtes-vous sûr de vouloir supprimer ce produit ? Cette action ne peut pas être annulée.',
      manage: 'Gérer les produits',
      hide: 'Masquer les produits',
      clear_cart: 'Vider le panier',
      checkout: 'Commander',
      add_to_cart: 'Ajouter au panier',
      adding: 'Ajout en cours...',
      remove: 'Retirer',
      close: 'Fermer',
    },

    // Table Headers
    table: {
      name: 'Nom',
      price: 'Prix',
      stock: 'Stock',
      active: 'Actif',
      selected: 'sélectionné(s)',
      search: 'Rechercher un produit...',
    },

    // Form Fields
    form: {
      name: 'Nom',
      description: 'Description',
      price: 'Prix',
      stock: 'Stock',
      image: 'Image',
      active: 'Actif',
      in_stock: 'En stock',
      out_of_stock: 'Épuisé',
      quantity: 'Quantité',
    },

    // Cart
    cart: {
      title: 'Vos produits',
      subtotal: 'Sous-total',
      checkout_notice: 'Les produits seront ajoutés à votre réservation de billet.',
      increase_quantity: 'Augmenter la quantité',
      decrease_quantity: 'Diminuer la quantité',
      open: 'Ouvrir le panier',
    },

    // Tooltips
    tooltips: {
      name: 'Entrez le nom du produit',
      description: 'Fournissez une description détaillée du produit',
      price: 'Définissez le prix de ce produit',
      stock: 'Entrez la quantité disponible de ce produit',
      image: 'Téléchargez une image du produit',
      active: "Activez pour rendre ce produit disponible à l'achat",
    },

    // Errors
    errors: {
      loading: 'Erreur lors du chargement des produits',
      none_available: 'Aucun produit disponible pour cet événement',
    },

    // Language tabs
    languages: 'Onglets de traduction (Anglais, Français, Espagnol, Portugais, Allemand)',
  },
  participantInfos: {
    know_from_attendees: 'Connaître les participants',
    know_from_attendees_description:
      "Envoyez un message aux participants de l'événement pour leur faire savoir que vous les connaissez.",
    add_custom_field: 'Ajouter un champ personnalisé',
    field_name: 'Nom du champ',
    field_type: 'Type de champ',
    add_field: 'Ajouter le champ',
    options: 'Options',
    add_option: 'Ajouter une option',
    add: 'Ajouter',
    Text: 'Texte',
    Number: 'Nombre',
    Email: 'E-mail',
    Phone: 'Téléphone',
    Date: 'Date',
    'Multiple Choice': 'Choix multiple',
    Dropdown: 'Liste déroulante',
    Checkbox: 'Case à cocher',
    type: 'Type',
    Edit_data_success: 'Données mises à jour avec succès !',
    Edit_data_failed: 'Échec de la mise à jour des données !',
    no_options_added: 'Aucune option ajoutée',
    edit: 'Modifier',
    options_for: 'Options pour',
    enter_option_placeholder: 'Saisissez une option et appuyez sur Entrée ou Ajouter',
    multiple_choice_helper_text: 'Les participants pourront sélectionner une option dans la liste.',
    dropdown_helper_text:
      'Les participants verront un menu déroulant pour sélectionner une option.',
    checkbox_helper_text: 'Les participants pourront sélectionner plusieurs options dans la liste.',
    'Single Choice': 'Choix unique',
    single_choice_explanation:
      'Les participants pourront sélectionner UNE SEULE option de la liste.',
    multiple_choice_explanation:
      'Les participants pourront sélectionner PLUSIEURS options de la liste.',
    minimum_options_warning: "Vous avez besoin d'au moins 2 options pour ce type de question.",
  },
  'Multi-day Festival Ticket': 'Billet Festival Multi-jours',
  'Allow ticket to be validated once per festival day':
    'Permettre la validation une fois par jour de festival',
  'Multi-day Festival Configuration': 'Configuration Festival Multi-jours',
  'This ticket can be validated once per festival day. Validations reset daily at the specified time.':
    "Ce billet peut être validé une fois par jour de festival. Les validations se remettent à zéro quotidiennement à l'heure spécifiée.",
  Example: 'Exemple',
  'Festival June 10-13, reset at 02:00 means:':
    'Festival 10-13 juin, remise à zéro à 02:00 signifie :',
  'Day 1: June 10 from event start until June 11 02:00':
    "Jour 1: 10 juin du début de l'événement jusqu'au 11 juin 02:00",
  'Day 2: June 11 02:00 until June 12 02:00': "Jour 2: 11 juin 02:00 jusqu'au 12 juin 02:00",
  'Day 3: June 12 02:00 until June 13 02:00': "Jour 3: 12 juin 02:00 jusqu'au 13 juin 02:00",
  'Day 4: June 13 02:00 until event end': "Jour 4: 13 juin 02:00 jusqu'à la fin de l'événement",
  'Daily Reset Time': 'Heure de Remise à Zéro Quotidienne',
  'Time when daily validations reset (24h format). Recommended: 02:00 for festivals':
    'Heure où les validations quotidiennes se remettent à zéro (format 24h). Recommandé: 02:00 pour les festivals',
  'Invalid time format. Use HH:MM (24h format)':
    "Format d'heure invalide. Utilisez HH:MM (format 24h)",
  'Bus Tickets View': 'Vue Billets de Bus',
  export_bus_tickets: 'Exporter Billets de Bus',
  no_bus_tickets_to_export: 'Aucun billet de bus à exporter',
  no_bus_tickets_to_export_for_status: 'Aucun billet de bus à exporter pour le statut: {{status}}',

  // Bus Ticket Fields
  departure: 'Départ',
  scanned: 'Scanné',
  not_scanned: 'Non Scanné',
  // Bus Ticket Actions
  view_reservation_details: 'Voir Détails de la Réservation',
  send_email_to_reservation: 'Envoyer Email à la Réservation',
  unknown: 'Inconnu',
  confirm_bus_refund: 'Confirmer le Remboursement du Billet de Bus',
  bus_refund_confirmation_message:
    'Êtes-vous sûr de vouloir rembourser ce billet de bus ? Cette action ne peut pas être annulée.',
  bus_ticket_details: 'Détails du Billet de Bus',
  refund_bus_ticket: 'Rembourser le Billet de Bus',
  only_confirmed_bus_tickets_can_be_refunded:
    'Seuls les billets de bus confirmés peuvent être remboursés',
  cannot_refund_free_ticket: 'Impossible de rembourser les billets gratuits',
  bus_ticket_refunded_successfully: 'Billet de bus remboursé avec succès',
  failed_to_refund_bus_ticket: 'Échec du remboursement du billet de bus',
  scanningAnalytics: 'Analyses de Scan',
  noScanningData: 'Aucune donnée de scan disponible',
  totalValidations: 'Validations Totales',
  validationRate: 'Taux de Validation',
  uniqueScanners: 'Scanners Uniques',
  avgValidationsPerTicket: 'Moy. Validations/Billet',
  multipleValidatedTickets: 'Billets Validés Plusieurs Fois',
  dailyValidationInsights: 'Aperçus des Validations Quotidiennes',
  dailyBreakdown: 'Répartition Quotidienne',
  uniqueTickets: 'Billets Uniques',
  singleValidations: 'Validations Simples',
  multipleValidations: 'Validations Multiples',
  ticketTypeValidationStats: 'Stats de Validation par Type de Billet',
  ticketTypeValidationBreakdown: 'Répartition des Validations par Type',
  ticketType: 'Type de Billet',
  multipleValidationRate: 'Taux de Validation Multiple',
  dailyValidationTrends: 'Tendances des Validations Quotidiennes',
  hourlyValidationPattern: 'Modèle de Validation Horaire',
  scannerDailyActivity: 'Activité Quotidienne des Scanners',
  validationEfficiencyMetrics: "Métriques d'Efficacité de Validation",
  maxValidationsPerTicket: 'Max Validations/Billet',
  activeDays: 'Jours Actifs',
  avgValidationsPerDay: 'Moy. Validations/Jour',
  detailedValidationHistory: 'Historique Détaillé des Validations',
  firstValidation: 'Première Validation',
  lastValidation: 'Dernière Validation',
  multipleValidationsDetails: 'Détails des Validations Multiples',
  ticketsWithMultipleValidationsExplanation:
    'Billets qui ont été validés plusieurs fois (courant dans les festivals multi-jours)',
  ticketStatusDistribution: 'Répartition des Statuts de Billets',
  scannerActivity: 'Activité des Scanners',
  detailedStatusBreakdown: 'Répartition Détaillée des Statuts',
  dailyValidations: 'Validations Quotidiennes',
  hourlyValidations: 'Validations Horaires',
  ticketId: 'ID Billet',
  clientName: 'Nom Client',
  validations: 'Validations',
  lastScanner: 'Dernier Scanner',
  physicalSale: 'Vente Physique',
  salesAnalytics: 'Analyses de Vente',
  eventStatistics: "Statistiques de l'Événement",
  ticketsSold: 'Billets Vendus',
  validatedTickets: 'Billets Validés',
  quickInsights: 'Aperçus Rapides',
  eventStatus: "Statut de l'Événement",
  ticketTypes: 'Types de Billets',
  types: 'Types',
  quantities: 'Quantités',
  revenue: 'Revenus',
  timeline: 'Chronologie',
  edited: 'Modifié',

  // Music Studio Service Management
  studio: {
    customization: {
      title: 'Personnalisation du Studio',
      subtitle: "Personnalisez l'apparence de votre studio pour les clients et visiteurs",
      resetTooltip: 'Réinitialiser aux paramètres par défaut',
      previewTooltip: 'Aperçu de la personnalisation',
      saveChanges: 'Enregistrer les Modifications',
      enableCustomization: 'Activer la Personnalisation',
      enableDescription:
        'Lorsque activée, vos paramètres personnalisés seront appliqués à la page du studio',
      choosePersonality: 'Choisir la Personnalité du Studio',
      tabs: {
        layout: 'Mise en Page',
        theme: 'Thème',
        content: 'Contenu',
      },
      layout: {
        heroStyle: 'Style de Hero',
        heroStyles: {
          fullscreen: 'Plein Écran',
          banner: 'Bannière',
          split: 'Divisé',
          minimal: 'Minimal',
        },
        logoPosition: 'Position du Logo',
        logoPositions: {
          overlayLeft: 'Superposition Gauche',
          center: 'Centre',
          above: 'Au-dessus',
          side: 'Côté',
        },
        ctaPosition: "Position de l'Appel à l'Action",
        ctaPositions: {
          hero: 'Dans Hero',
          below: 'Sous Hero',
          floating: 'Flottant',
          multiple: 'Positions Multiples',
        },
        sectionOrder: 'Ordre des Sections',
        sectionOrderDescription:
          "L'ordre dans lequel les sections apparaissent sur votre page studio",
      },
    },
    theme: {
      title: 'Thème du Studio',
      subtitle:
        "Gérez l'identité visuelle de votre studio avec un logo et des images de couverture personnalisés",
      logoSection: {
        title: 'Logo du Studio',
        description: 'Téléchargez le logo de votre studio. Taille recommandée : 256x256px, max 2MB',
        changeLogo: 'Changer le Logo',
        uploadLogo: 'Télécharger le Logo',
        removeLogo: 'Supprimer le Logo',
        clickToPreview: 'Cliquez pour prévisualiser',
      },
      coverSection: {
        title: 'Image de Couverture',
        description:
          "Téléchargez l'image de couverture de votre studio. Taille recommandée : 1200x400px, max 5MB",
        changeCoverImage: "Changer l'Image de Couverture",
        uploadCoverImage: "Télécharger l'Image de Couverture",
        removeCoverImage: "Supprimer l'Image de Couverture",
      },
      guidelines: {
        title: 'Directives du Thème',
        logoRequirements: 'Exigences du Logo',
        logoSpecs: {
          squareFormat: 'Format carré (ratio 1:1) recommandé',
          minMaxSize: 'Minimum 256x256px, maximum 512x512px',
          format: 'Format PNG ou JPG',
          maxFileSize: 'Taille de fichier maximale : 2MB',
          transparentBg: 'Fond transparent préféré pour PNG',
        },
        coverRequirements: "Exigences de l'Image de Couverture",
        coverSpecs: {
          landscapeFormat: 'Format paysage (ratio 3:1) recommandé',
          minSize: 'Minimum 1200x400px',
          format: 'Format PNG ou JPG',
          maxFileSize: 'Taille de fichier maximale : 5MB',
          highQuality: 'Les images de haute qualité se présentent mieux',
        },
      },
      messages: {
        logoSizeError: 'La taille du fichier logo doit être inférieure à 2MB',
        coverSizeError: "La taille du fichier de l'image de couverture doit être inférieure à 5MB",
        invalidImageFile: 'Veuillez sélectionner un fichier image valide',
        logoUpdated: 'Logo mis à jour avec succès !',
        logoUpdateFailed: 'Échec de la mise à jour du logo',
        coverUpdated: 'Image de couverture mise à jour avec succès !',
        coverUpdateFailed: "Échec de la mise à jour de l'image de couverture",
        confirmRemoveLogo: 'Êtes-vous sûr de vouloir supprimer le logo du studio ?',
        confirmRemoveCover: "Êtes-vous sûr de vouloir supprimer l'image de couverture ?",
        logoRemoved: 'Logo supprimé avec succès !',
        logoRemoveFailed: 'Échec de la suppression du logo',
        coverRemoved: 'Image de couverture supprimée avec succès !',
        coverRemoveFailed: "Échec de la suppression de l'image de couverture",
      },
      preview: {
        logoTitle: 'Aperçu du Logo',
        coverTitle: "Aperçu de l'Image de Couverture",
        close: 'Fermer',
      },
    },
    showcase: {
      title: 'Vitrine Musicale',
      settings: {
        title: 'Paramètres de la Vitrine Musicale',
        subtitle: 'Configurez la vitrine musicale de votre studio pour les clients',
        saveSettings: 'Enregistrer les Paramètres',
        enableShowcase: 'Activer la Vitrine Musicale',
        enableDescription:
          'Lorsque activée, votre vitrine musicale sera visible par les clients sur votre profil de studio',
        showcaseTitle: 'Titre de la Vitrine',
        showcaseTitlePlaceholder: 'ex: Nos Dernières Productions',
        showcaseDescription: 'Description de la Vitrine',
        showcaseDescriptionPlaceholder: 'Décrivez votre vitrine musicale...',
      },
      tracks: {
        title: 'Morceaux de Musique',
        subtitle: 'Ajoutez des morceaux de musique pour présenter le travail de votre studio',
        addTrack: 'Ajouter un Morceau',
        addFirstTrack: 'Ajouter le Premier Morceau',
        editTrack: 'Modifier le Morceau',
        noTracksYet:
          'Aucun morceau ajouté pour le moment. Ajoutez votre premier morceau pour commencer !',
        enableShowcaseFirst:
          'Activez la vitrine musicale ci-dessus pour commencer à ajouter des morceaux',
        trackCount: 'Morceaux de Musique ({{count}})',
        hidden: 'Masqué',
        by: 'par',
      },
      trackDialog: {
        addTitle: 'Ajouter un Morceau',
        editTitle: 'Modifier le Morceau',
        trackTitle: 'Titre du Morceau *',
        trackTitlePlaceholder: 'Entrez le titre du morceau',
        artist: 'Artiste',
        artistPlaceholder: "Nom de l'artiste ou du groupe",
        platform: 'Plateforme *',
        url: 'URL *',
        description: 'Description',
        descriptionPlaceholder: 'Description ou notes optionnelles sur ce morceau',
        cancel: 'Annuler',
        add: 'Ajouter',
        update: 'Mettre à jour',
        addTrackButton: 'Ajouter le Morceau',
        updateTrackButton: 'Mettre à jour le Morceau',
      },
      platforms: {
        youtube: 'YouTube',
        spotify: 'Spotify',
        soundcloud: 'SoundCloud',
        apple_music: 'Apple Music',
        bandcamp: 'Bandcamp',
        other: 'Autre',
      },
      urlHints: {
        youtube: 'ex: https://www.youtube.com/watch?v=dQw4w9WgXcQ ou https://youtu.be/dQw4w9WgXcQ',
        spotify: 'ex: https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC',
        soundcloud: 'ex: https://soundcloud.com/artiste/nom-du-morceau',
        apple_music: 'ex: https://music.apple.com/us/album/nom-chanson/id123456789?i=123456789',
        bandcamp: 'ex: https://artiste.bandcamp.com/track/nom-chanson',
        other: "Entrez l'URL de n'importe quelle plateforme musicale",
      },
      actions: {
        openLink: 'Ouvrir le lien',
        hideTrack: 'Masquer le morceau',
        showTrack: 'Afficher le morceau',
        editTrack: 'Modifier le morceau',
        removeTrack: 'Supprimer le morceau',
      },
      messages: {
        settingsSaved: 'Paramètres de la vitrine enregistrés avec succès !',
        settingsSaveFailed: "Échec de l'enregistrement des paramètres de la vitrine",
        enterTitle: 'Veuillez entrer un titre de morceau',
        enterUrl: 'Veuillez entrer une URL de morceau',
        invalidUrl: "Format d'URL {{platform}} invalide",
        trackUpdated: 'Morceau mis à jour avec succès !',
        trackAdded: 'Morceau ajouté avec succès !',
        trackSaveFailed: "Échec de l'enregistrement du morceau",
        confirmRemove: 'Êtes-vous sûr de vouloir supprimer "{{title}}" de la vitrine ?',
        trackRemoved: 'Morceau supprimé avec succès !',
        trackRemoveFailed: 'Échec de la suppression du morceau',
        trackHidden: 'Morceau masqué avec succès !',
        trackShown: 'Morceau affiché avec succès !',
        trackToggleFailed: 'Échec du basculement de la visibilité du morceau',
        tracksReordered: 'Morceaux réorganisés avec succès !',
        tracksReorderFailed: 'Échec de la réorganisation des morceaux',
      },
    },
    availability: {
      title: 'Disponibilité du Studio',
      subtitle:
        "Configurez les heures d'ouverture de votre studio, les créneaux horaires de réservation et les règles de disponibilité",
      loading: 'Chargement des paramètres de disponibilité...',
      loadError:
        'Échec du chargement des paramètres de disponibilité. Veuillez actualiser la page.',
      tabs: {
        workingHours: "Heures d'Ouverture",
        bookingRules: 'Règles de Réservation',
        timeSlots: 'Créneaux Horaires',
      },
      daysOfWeek: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
      },
      workingHours: {
        title: 'Horaire Hebdomadaire',
        description:
          "Définissez les heures d'ouverture de votre studio pour chaque jour de la semaine. Activez le mode 24 heures ou définissez des horaires traversant minuit (ex: 22h00 à 06h00 le lendemain)",
        startTime: 'Heure de Début',
        endTime: 'Heure de Fin',
        is24Hours: '24h',
        nextDay: 'le lendemain',
        crossMidnightSchedule: 'Horaire traversant minuit :',
      },
      crossDayPolicy: {
        title: 'Politique de Réservation Multi-Jours',
        enableCrossDayBookings: 'Activer les Réservations Multi-Jours',
        enableDescription:
          "Permettre les réservations qui s'étendent après minuit (ex: 23h00 à 02h00)",
        maxCrossDayHours: 'Heures Maximales Multi-Jours',
        maxCrossDayHoursHelp:
          "Nombre maximum d'heures qu'une réservation peut s'étendre sur plusieurs jours",
        allowWeekendCrossover: 'Autoriser le Passage Week-end',
        allowWeekendCrossoverHelp:
          'Permettre aux réservations de passer du week-end à la semaine ou vice versa',
        requireSameDayStart: 'Exiger Début Même Jour',
        requireSameDayStartHelp:
          'La réservation doit commencer et se terminer le même jour calendaire',
      },
      bookingRules: {
        title: 'Configuration des Réservations',
        description: 'Configurez les règles et restrictions de réservation',
        advanceBookingDays: "Jours de Réservation à l'Avance",
        advanceBookingDaysHelp: "Combien de jours à l'avance les clients peuvent réserver",
        minBookingNotice: 'Préavis Minimum (heures)',
        minBookingNoticeHelp: 'Heures minimales avant la réservation',
        maxBookingDuration: 'Durée Maximum de Session (minutes)',
        maxBookingDurationHelp: 'Durée maximale de réservation',
        bufferTime: 'Temps de Pause (minutes)',
        bufferTimeHelp: 'Temps de pause entre les réservations',
        autoApproveBookings: 'Approuver automatiquement les réservations',
        autoApproveBookingsHelp:
          'Approuver automatiquement les demandes de réservation sans examen manuel',
        allowBackToBackBookings: 'Autoriser les réservations consécutives',
        allowBackToBackBookingsHelp: 'Permettre de planifier des réservations consécutives',
      },
      timeSlots: {
        title: 'Configuration des Créneaux Horaires',
        description: 'Configurez les créneaux horaires et intervalles de réservation',
        timeSlotUnit: 'Unité de Créneau Horaire',
        timeSlotDuration: 'Durée par Défaut du Créneau (minutes)',
        timeSlotDurationHelp: 'Durée par défaut des créneaux de réservation',
        info: "Les créneaux horaires seront générés en fonction de vos heures d'ouverture et de l'unité de temps sélectionnée. Les clients peuvent choisir parmi les créneaux disponibles lors de la réservation.",
        units: {
          '15min': '15 minutes',
          '30min': '30 minutes',
          '1hr': '1 heure',
        },
      },
      validation: {
        advanceBookingDaysRequired: "Les jours de réservation à l'avance sont requis",
        minBookingNoticeRequired: 'Le préavis minimum de réservation est requis',
        maxBookingDurationRequired: 'La durée maximale de réservation est requise',
        timeSlotDurationRequired: 'La durée du créneau horaire est requise',
        bufferTimeRequired: 'Le temps de pause est requis',
      },
      actions: {
        reset: 'Réinitialiser',
        saveSettings: 'Enregistrer les Paramètres',
      },
      messages: {
        settingsSaved: 'Paramètres de disponibilité enregistrés avec succès !',
        saveFailed: "Une erreur s'est produite. Veuillez réessayer.",
      },
    },
    settings: {
      title: 'Paramètres Généraux',
      subtitle: 'Configurez les paramètres et préférences de votre studio',
      tabs: {
        general: 'Général',
        bookingRules: 'Règles de Réservation',
        notifications: 'Notifications',
        pricingPayment: 'Tarification et Paiement',
        studioBusiness: 'Business du Studio',
      },
      general: {
        studioName: 'Nom du Studio',
        studioNameHelp: 'Le nom de votre studio ou organisation',
        emailAddress: 'Adresse E-mail',
        emailAddressHelp: 'E-mail de contact principal pour votre studio',
        phoneNumber: 'Numéro de Téléphone',
        phoneNumberHelp: 'Numéro de téléphone de contact principal',
        address: 'Adresse',
        addressHelp: 'Adresse physique de votre studio',
        description: 'Description',
        descriptionHelp: 'Brève description de votre studio et de ses services',
        saveButton: 'Enregistrer les Paramètres Généraux',
        noLocationsFound: 'Aucun emplacement trouvé',
      },
      bookingRules: {
        title: 'Règles de Réservation',
        description: 'Configurez comment les clients peuvent réserver votre studio',
        requiresApproval: 'Nécessite une Approbation',
        requiresApprovalHelp: 'Approuver manuellement les réservations avant confirmation',
        autoApprove: 'Approuver Automatiquement les Réservations',
        autoApproveHelp:
          'Approuver automatiquement les demandes de réservation sans révision manuelle',
        cancellationPolicy: "Autoriser l'Annulation",
        cancellationPolicyHelp:
          'Les clients peuvent annuler leurs réservations dans le délai autorisé',

        cancellationWindow: "Fenêtre d'Annulation (heures)",
        cancellationWindowHelp: 'Heures avant la réservation pour annulation gratuite',
        depositRequired: 'Dépôt Requis',
        depositRequiredHelp: 'Nécessiter un dépôt pour confirmer les réservations',
        depositPercentage: 'Pourcentage du Dépôt',
        depositPercentageHelp: 'Pourcentage du total requis comme dépôt',
        minAdvanceBooking: 'Réservation Anticipée Minimale (heures)',
        maxAdvanceBooking: 'Réservation Anticipée Maximale (jours)',
        maxAdvanceBookingHelp: "Nombre maximal de jours à l'avance pour effectuer des réservations",
        bufferTime: 'Temps de Préparation (minutes)',
        bufferTimeHelp: 'Temps entre les réservations pour la préparation',
        minBookingDurationHelp: 'Durée minimale pour une réservation',
        minAdvanceBookingHelp: "Heures minimales à l'avance pour effectuer des réservations",
        minBookingDuration: 'Durée Minimale de Réservation (minutes)',
        maxBookingDurationHelp: 'Durée maximale pour une réservation',
        maxBookingDuration: 'Durée Maximale de Réservation (minutes)',
        bookingSpacingTitle: 'Espacement et Approbation des Réservations',
        allowBackToBack: 'Autoriser les Réservations Consécutives',
        allowBackToBackHelp:
          'Autoriser les réservations à commencer immédiatement après la fin de la précédente',
        saveButton: 'Enregistrer les Règles de Réservation',
        saveSuccess: 'Règles de réservation enregistrées avec succès',
        saveFailed: "Échec de l'enregistrement des règles de réservation",
      },
      paymentSettings: {
        title: 'Paramètres de Paiement',
        subtitle: 'Configurez comment les paiements sont collectés pour les réservations',
        paymentMode: 'Mode de Paiement',
        paymentModeRequired: 'Le mode de paiement est requis',
        invalidPaymentMode: 'Mode de paiement invalide',

        // Payment Modes
        manualMode: 'Confirmation Manuelle (Aucun Paiement Requis)',
        manualModeDescription:
          'Les réservations sont confirmées sans paiement. Le propriétaire confirme manuellement.',
        fullMode: 'Paiement Complet pour Confirmer la Réservation',
        fullModeDescription: "Le client doit payer 100% à l'avance pour confirmer la réservation.",
        depositMode: "Paiement d'Acompte",
        depositModeDescription:
          "Le client paie un pourcentage d'acompte. Le solde restant est dû ultérieurement.",
        holdMode: 'Autorisation de Paiement (Pré-autorisation)',
        holdModeDescription:
          'Placer une autorisation sur le moyen de paiement du client. Facturer après confirmation de la réservation par le propriétaire.',

        // Deposit Settings
        depositConfiguration: "Configuration de l'Acompte",
        depositConfigurationHelp:
          "Configurez le pourcentage d'acompte et les restrictions optionnelles de réservation anticipée",
        depositPercentage: "Pourcentage d'Acompte",
        depositPercentageHelp: 'Pourcentage du prix total requis comme acompte (0-100%)',
        depositPercentageMin: "Le pourcentage d'acompte doit être d'au moins 0%",
        depositPercentageMax: "Le pourcentage d'acompte ne peut pas dépasser 100%",
        depositPercentageRequired: "Le pourcentage d'acompte est requis pour le mode acompte",

        restrictDepositToAdvanceDays: "Restreindre l'Acompte aux Réservations Anticipées",
        restrictDepositToAdvanceDaysHelp:
          "Exiger un acompte uniquement pour les réservations effectuées X jours à l'avance",
        depositOnlyForAdvanceDays: "Acompte Requis pour les Jours d'Avance",
        depositOnlyForAdvanceDaysHelp:
          "Exiger un acompte uniquement pour les réservations effectuées ce nombre de jours à l'avance",
        depositOnlyForAdvanceDaysMin: 'Les jours doivent être 0 ou plus',
        depositOnlyForAdvanceDaysRequired: "Veuillez spécifier le nombre de jours d'avance",

        // Payment Hold
        paymentHoldTitle: 'Autorisation de Retenue de Paiement',
        paymentHoldDescription:
          "Une autorisation de pré-autorisation sera placée sur le moyen de paiement du client. Le montant ne sera pas facturé jusqu'à ce que vous confirmiez manuellement la réservation. L'autorisation expire généralement après 7 jours si elle n'est pas confirmée.",

        // Payment Methods
        acceptedMethodsTitle: 'Moyens de Paiement Acceptés',
        acceptedMethodsSubtitle: 'Sélectionnez les moyens de paiement que vous acceptez',
        atLeastOneMethodRequired:
          'Au moins un moyen de paiement doit être sélectionné lorsque le paiement est requis',

        acceptCash: 'Espèces',
        acceptCashHelp: 'Accepter les paiements en espèces sur place',
        acceptCard: 'Carte (Sur place)',
        acceptCardHelp: 'Accepter les paiements par carte sur place',
        acceptOnlinePayment: 'Paiement en Ligne',
        acceptOnlinePaymentHelp: 'Accepter les paiements en ligne via Stripe',

        // Stripe
        stripeIntegrationTitle: 'Intégration Stripe Requise',
        stripeIntegrationDescription:
          "Pour accepter les paiements en ligne, vous devez connecter votre compte Stripe. Contactez le support pour configurer l'intégration Stripe Connect.",
        stripeAccountIdRequired: "L'ID de compte Stripe est requis pour les paiements en ligne",

        // Messages
        saveButton: 'Enregistrer les Paramètres de Paiement',
        saveSuccess: 'Paramètres de paiement enregistrés avec succès',
        saveFailed: "Échec de l'enregistrement des paramètres de paiement",
        applyToNewBookings:
          'Les paramètres de paiement seront appliqués à toutes les nouvelles réservations. Les réservations existantes restent inchangées.',

        // Days
        days: 'jours',
      },
      notifications: {
        title: 'Paramètres de Notification',
        description: 'Gérez comment vous et vos clients recevez les notifications',
        emailNotifications: 'Notifications par E-mail',
        smsNotifications: 'SMS Notifications',
        emailNotificationsHelp: 'Activer les notifications par e-mail',
        smsNotificationsHelp: 'Recevoir des notifications par SMS',
        whatsappNotifications: 'Notifications WhatsApp',
        whatsappNotificationsHelp: 'Activer les notifications WhatsApp',
        customerNotifications: 'Notifications Clients',
        notifyOnBooking: "Notifier lors d'une Nouvelle Réservation",
        notifyOnBookingHelp:
          "Envoyer une notification au client lors de la création d'une réservation",
        notifyOnStatusChange: "Notifier lors d'un Changement de Statut",
        notifyOnStatusChangeHelp: 'Notifier le client lorsque le statut de la réservation change',
        notifyBeforeSession: 'Rappel Avant la Session',
        notifyBeforeSessionHelp: 'Envoyer un rappel avant la session prévue',
        ownerNotifications: 'Notifications Propriétaire',
        notifyOwnerOnBooking: 'Notifier le Propriétaire pour les Nouvelles Réservations',
        notifyOwnerOnBookingHelp:
          'Avertir le propriétaire du studio des nouvelles demandes de réservation',
        notifyOwnerOnCancellation: 'Notifier le Propriétaire des Annulations',
        notifyOwnerOnCancellationHelp:
          'Avertir le propriétaire du studio des annulations de réservation',
      },
      studioBusiness: {
        title: 'Paramètres Business du Studio',
        description: 'Gérez la visibilité publique et les paramètres business de votre studio',
        isPublic: 'Studio Public',
        isPublicHelp: 'Rendre le studio visible dans les recherches et listes publiques',
        acceptBookings: 'Accepter les Réservations',
        acceptBookingsOn: 'Votre studio accepte de nouvelles demandes de réservation',
        acceptBookingsOff: 'Les nouvelles réservations sont temporairement désactivées',
        acceptsBookings: 'Accepter les Réservations',
        acceptsBookingsHelp: 'Accepter de nouvelles demandes de réservation',
        musicStyles: 'Styles de Musique',
        musicStylesHelp:
          'Sélectionnez les styles de musique que votre studio prend en charge (maintenez Ctrl/Cmd pour la sélection multiple)',
        country: 'Pays',
        currency: 'Devise',
        timezone: 'Fuseau Horaire',
        language: 'Langue',
        websiteUrl: 'URL du Site Web',
        websiteUrlHelp: 'Site web de votre studio (optionnel)',
        socialMedia: 'Réseaux Sociaux',
        musicStylePlaceholder: 'Ajouter un style ou genre musical (ex: Rock, Jazz, Hip Hop)',
        noMusicStyles:
          'Aucun style musical ajouté pour le moment. Ajoutez-en pour aider les clients à trouver votre studio.',
        saveButton: 'Enregistrer les Paramètres Business du Studio',
        saveSuccess: 'Paramètres business du studio enregistrés avec succès',
        saveFailed: "Échec de l'enregistrement des paramètres business du studio",
        socialMediaHelp: 'Liens vers vos profils de réseaux sociaux',
      },
      validation: {
        nameRequired: 'Le nom du studio est requis',
        emailRequired: "L'adresse e-mail est requise",
        emailInvalid: 'Adresse e-mail invalide',
        phoneRequired: 'Le numéro de téléphone est requis',
        addressRequired: "L'adresse est requise",
      },
      messages: {
        settingsSaved: 'Paramètres enregistrés avec succès !',
        saveFailed: "Échec de l'enregistrement des paramètres",
        notificationsSaved: 'Paramètres de notification enregistrés avec succès !',
        notificationsSaveFailed: "Échec de l'enregistrement des paramètres de notification",
      },
    },
    navigation: {
      rooms: 'Salles',
      engineers: 'Ingénieurs',
      equipment: 'Équipement',
      services: 'Services',
      customization: 'Personnalisation de Page',
      theme: 'Thème du Studio',
      showcase: 'Vitrine Musicale',
      gallery: 'Galerie du Studio',
      certifications: 'Certifications',
      artists: 'Artistes Vedettes',
      bookings: 'Réservations',
      availability: 'Disponibilité',
      settings: 'Paramètres Généraux',
      entities: 'Entités',
      operations: 'Opérations',
    },
    forms: {
      labels: {
        name: 'Nom',
        description: 'Description',
        capacity: 'Capacité',
        hourlyRate: 'Tarif Horaire (€)',
        email: 'Adresse E-mail',
        phone: 'Numéro de Téléphone',
        website: 'Site Web',
        instagram: 'Instagram',
        soundcloud: 'SoundCloud',
        spotify: 'Spotify',
        youtube: 'YouTube',
        yearsOfExperience: "Années d'Expérience",
        specialties: 'Spécialités',
        bio: 'Biographie',
        serialNumber: 'Numéro de Série',
        model: 'Modèle',
        brand: 'Marque',
        purchaseDate: "Date d'Achat",
        warrantyExpiration: 'Expiration de Garantie',
        notes: 'Notes',
        type: 'Type',
        condition: 'État',
        category: 'Catégorie',
        title: 'Titre',
        url: 'URL',
        platform: 'Plateforme',
        genre: 'Genre',
        issuedBy: 'Émis par',
        issuedDate: "Date d'Émission",
        expiryDate: "Date d'Expiration",
        certificateNumber: 'Numéro de Certificat',
      },
      placeholders: {
        searchEquipment: 'Rechercher équipement...',
        searchRooms: 'Rechercher salles...',
        searchEngineers: 'Rechercher ingénieurs...',
        roomDescription: 'Décrivez les caractéristiques et capacités de la salle...',
        engineerBio: 'Parlez-nous de votre expérience et expertise...',
        equipmentNotes: 'Notes supplémentaires sur cet équipement...',
        selectGenre: 'Sélectionner genre...',
        selectType: 'Sélectionner type...',
        selectCondition: 'Sélectionner état...',
        selectCategory: 'Sélectionner catégorie...',
        enterUrl: 'Entrer URL...',
        enterTitle: 'Entrer titre...',
        searchArtists: 'Rechercher artistes...',
        artistBio: "Biographie et réalisations de l'artiste...",
      },
      validation: {
        required: 'Ce champ est requis',
        emailInvalid: 'Adresse e-mail invalide',
        urlInvalid: "Format d'URL invalide",
        numberMin: "Doit être d'au moins {min}",
        numberMax: "Doit être d'au plus {max}",
        stringMin: 'Doit contenir au moins {min} caractères',
        stringMax: 'Doit contenir au plus {max} caractères',
      },
    },
    equipment: {
      types: {
        microphone: 'Microphone',
        outboard: 'Traitement externe',
        amplifier: 'Amplificateur',
        synthesizer: 'Synthétiseur',
        interface: 'Interface',
        monitor: 'Moniteur',
        headphones: 'Casque',
        instrument: 'Instrument',
        cable: 'Câble',
        stand: 'Support',
        rack: 'Rack',
        computer: 'Ordinateur',
        software: 'Logiciel',
        other: 'Autre',
      },
      conditions: {
        excellent: 'Excellent',
        good: 'Bon',
        fair: 'Correct',
        poor: 'Mauvais',
        repairNeeded: 'Réparation Nécessaire',
      },
    },
    rooms: {
      features: {
        soundproof: 'Insonorisé',
        airConditioning: 'Climatisation',
        naturalLight: 'Lumière Naturelle',
        pianoAvailable: 'Piano Disponible',
        drumsAvailable: 'Batterie Disponible',
        guitarsAmpsAvailable: 'Amplis Guitare Disponibles',
        isolationBooth: "Cabine d'Isolation",
        loungeArea: 'Coin Détente',
        kitchenette: 'Kitchenette',
        parking: 'Parking',
        wifiInternet: 'WiFi/Internet',
        videoRecording: 'Enregistrement Vidéo',
      },
    },
    status: {
      booking: {
        pending: 'En Attente',
        confirmed: 'Confirmé',
        inProgress: 'En Cours',
        completed: 'Terminé',
        cancelled: 'Annulé',
        noShow: 'Absence',
      },
      payment: {
        unpaid: 'Non Payé',
        partial: 'Partiel',
        paid: 'Payé',
        refunded: 'Remboursé',
      },
      active: 'Actif',
      inactive: 'Inactif',
      available: 'Disponible',
      unavailable: 'Indisponible',
    },
    time: {
      days: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
      },
      units: {
        fifteenMin: '15 minutes',
        thirtyMin: '30 minutes',
        oneHour: '1 heure',
        twoHours: '2 heures',
      },
    },
    genres: {
      rock: 'Rock',
      pop: 'Pop',
      hiphop: 'Hip Hop',
      electronic: 'Électronique',
      jazz: 'Jazz',
      classical: 'Classique',
      folk: 'Folk',
      country: 'Country',
      reggae: 'Reggae',
      blues: 'Blues',
      metal: 'Metal',
      punk: 'Punk',
      funk: 'Funk',
      soul: 'Soul',
      rnb: 'R&B',
      indie: 'Indie',
      alternative: 'Alternatif',
      world: 'Musique du Monde',
      experimental: 'Expérimental',
      ambient: 'Ambient',
      other: 'Autre',
    },
    actions: {
      add: 'Ajouter',
      edit: 'Modifier',
      delete: 'Supprimer',
      save: 'Enregistrer',
      cancel: 'Annuler',
      create: 'Créer',
      update: 'Mettre à jour',
      upload: 'Télécharger',
      download: 'Télécharger',
      view: 'Voir',
      activate: 'Activer',
      deactivate: 'Désactiver',
      refresh: 'Actualiser',
      search: 'Rechercher',
      filter: 'Filtrer',
      sort: 'Trier',
      export: 'Exporter',
      import: 'Importer',
      duplicate: 'Dupliquer',
      archive: 'Archiver',
      restore: 'Restaurer',
      markAsCompleted: 'Marquer comme Terminé',
      markAsPending: 'Marquer comme En Attente',
      markAsConfirmed: 'Marquer comme Confirmé',
      markAsCancelled: 'Marquer comme Annulé',
      markAsInProgress: 'Marquer comme En Cours',
      markAsNoShow: 'Marquer comme Absence',
      toggleStatus: 'Basculer Statut',
      fullScreen: 'Plein Écran',
      exitFullScreen: 'Quitter Plein Écran',
    },
    messages: {
      success: {
        created: '{item} créé avec succès',
        updated: '{item} mis à jour avec succès',
        deleted: '{item} supprimé avec succès',
        activated: '{item} activé avec succès',
        deactivated: '{item} désactivé avec succès',
        uploaded: 'Fichier téléchargé avec succès',
        saved: 'Modifications enregistrées avec succès',
      },
      error: {
        createFailed: 'Échec de création de {item}',
        updateFailed: 'Échec de mise à jour de {item}',
        deleteFailed: 'Échec de suppression de {item}',
        uploadFailed: 'Échec du téléchargement',
        loadFailed: 'Échec de chargement de {item}',
        networkError: 'Erreur réseau',
        unauthorizedAccess: 'Accès non autorisé',
      },
      confirmation: {
        deleteItem: 'Êtes-vous sûr de vouloir supprimer ce {item} ?',
        deleteMultiple: 'Êtes-vous sûr de vouloir supprimer {count} éléments ?',
        activateItem: 'Êtes-vous sûr de vouloir activer ce {item} ?',
        deactivateItem: 'Êtes-vous sûr de vouloir désactiver ce {item} ?',
      },
      info: {
        noData: 'Aucun {item} trouvé',
        noDataWithFilters: 'Aucun {item} trouvé correspondant à vos critères',
        loading: 'Chargement de {item}...',
        uploading: 'Téléchargement en cours...',
        saving: 'Enregistrement en cours...',
        emptyState: 'Commencez par ajouter votre premier {item}',
      },
    },
    tables: {
      headers: {
        name: 'Nom',
        type: 'Type',
        status: 'Statut',
        capacity: 'Capacité',
        hourlyRate: 'Tarif Horaire',
        features: 'Caractéristiques',
        condition: 'État',
        brand: 'Marque',
        model: 'Modèle',
        serialNumber: 'Numéro de Série',
        purchaseDate: "Date d'Achat",
        customer: 'Client',
        dateTime: 'Date et Heure',
        room: 'Salle',
        payment: 'Paiement',
        amount: 'Montant',
        actions: 'Actions',
        specialties: 'Spécialités',
        experience: 'Expérience',
        contact: 'Contact',
        platform: 'Plateforme',
        genre: 'Genre',
        category: 'Catégorie',
        issuedBy: 'Émis par',
        validUntil: "Valide Jusqu'au",
      },
    },
    dialogs: {
      titles: {
        addRoom: 'Ajouter Nouvelle Salle',
        editRoom: 'Modifier Salle',
        addEquipment: 'Ajouter Nouvel Équipement',
        editEquipment: 'Modifier Équipement',
        addEngineer: 'Ajouter Nouvel Ingénieur',
        editEngineer: 'Modifier Ingénieur',
        addArtist: 'Ajouter Artiste Vedette',
        editArtist: 'Modifier Artiste Vedette',
        addCertification: 'Ajouter Nouvelle Certification',
        editCertification: 'Modifier Certification',
        bookingDetails: 'Détails de la Réservation',
        confirmDelete: 'Confirmer Suppression',
        uploadFiles: 'Télécharger Fichiers',
        selectImage: 'Sélectionner Image',
        cropImage: 'Recadrer Image',
      },
    },
    descriptions: {
      roomManagement: "Gérer les salles et espaces d'enregistrement du studio",
      equipmentManagement: "Suivre et gérer l'inventaire d'équipement du studio",
      engineerManagement: 'Gérer les ingénieurs du son et le personnel technique',
      artistManagement:
        'Mettre en valeur les artistes vedettes qui ont travaillé dans votre studio',
      galleryManagement: 'Créer une galerie visuelle de vos espaces de studio',
      certificationManagement: 'Afficher les certifications et prix du studio',
      bookingManagement: 'Gérer les rendez-vous et réservations',
      availabilityManagement: 'Configurer les horaires de disponibilité et règles de réservation',
      settingsManagement: 'Configurer les paramètres généraux et préférences du studio',
      customizationManagement: "Personnaliser l'apparence de la page publique de votre studio",
      themeManagement: "Gérer l'image de marque et le thème visuel du studio",
    },
  },

  // ManageBookings translations
  'Booking Management': 'Gestion des Réservations',
  'Manage appointments and reservations for': 'Gérer les rendez-vous et réservations pour',
  Calendar: 'Calendrier',
  'Exit Full Screen': 'Quitter Plein Écran',
  'Full Screen': 'Plein Écran',
  Refresh: 'Actualiser',
  'Total Bookings': 'Total Réservations',
  Confirmed: 'Confirmé',
  'Total Revenue': "Chiffre d'Affaires Total",
  'Search bookings...': 'Rechercher réservations...',
  Status: 'Statut',
  Payment: 'Paiement',
  'All Status': 'Tous Statuts',
  'All Payments': 'Tous Paiements',
  'No bookings found': 'Aucune réservation trouvée',
  'Try adjusting your search or filter criteria':
    "Essayez d'ajuster vos critères de recherche ou de filtrage",
  'No bookings have been created yet': "Aucune réservation n'a encore été créée",
  Customer: 'Client',
  'Date & Time': 'Date et Heure',
  Room: 'Salle',
  Actions: 'Actions',
  Duration: 'Durée',
  Paid: 'Payé',
  'Mark as Pending': 'Marquer comme En Attente',
  'Mark as Confirmed': 'Marquer comme Confirmé',
  'Mark as In Progress': 'Marquer comme En Cours',
  'Mark as Completed': 'Marquer comme Terminé',
  'Mark as Cancelled': 'Marquer comme Annulé',
  'Mark as No Show': 'Marquer comme Absence',
  'Delete Booking': 'Supprimer Réservation',
  'Booking Details': 'Détails de la Réservation',
  'Customer Information': 'Informations Client',
  Phone: 'Téléphone',
  'Booking Information': 'Informations de Réservation',
  Purpose: 'Objet',
  'Payment Information': 'Informations de Paiement',
  'Total Amount': 'Montant Total',
  'Paid Amount': 'Montant Payé',
  'Payment Status': 'Statut de Paiement',
  Notes: 'Notes',
  'Customer Notes': 'Notes du Client',
  'Special Requirements': 'Exigences Spéciales',
  'Internal Notes': 'Notes Internes',
  'Unknown Room': 'Salle Inconnue',
  'Invalid Date': 'Date Invalide',
  'Booking status updated successfully': 'Statut de réservation mis à jour avec succès',
  'Failed to update booking status': 'Échec de la mise à jour du statut de réservation',
  'Are you sure you want to delete this booking?':
    'Êtes-vous sûr de vouloir supprimer cette réservation ?',
  'Booking deleted successfully': 'Réservation supprimée avec succès',
  'Failed to delete booking': 'Échec de la suppression de la réservation',
  'Error loading bookings': 'Erreur lors du chargement des réservations',
  'Unknown error': 'Erreur inconnue',
  Unpaid: 'Non Payé',
  Partial: 'Partiel',
  Refunded: 'Remboursé',
  'In Progress': 'En Cours',
  Completed: 'Terminé',
  Cancelled: 'Annulé',
  'No Show': 'Absence',

  // ManageRooms translations
  'Room name is required': 'Le nom de la salle est requis',
  'Capacity must be at least 1': "La capacité doit être d'au moins 1",
  'Capacity is required': 'La capacité est requise',
  'Hourly rate must be positive': 'Le tarif horaire doit être positif',
  'Hourly rate is required': 'Le tarif horaire est requis',
  'User not authenticated': 'Utilisateur non authentifié',
  'Room updated successfully!': 'Salle mise à jour avec succès !',
  'Room created successfully!': 'Salle créée avec succès !',
  'Are you sure you want to delete this room?': 'Êtes-vous sûr de vouloir supprimer cette salle ?',
  'Room deleted successfully!': 'Salle supprimée avec succès !',
  'Failed to delete room': 'Échec de la suppression de la salle',
  'Room status updated': 'Statut de la salle mis à jour',
  'Failed to update room status': 'Échec de la mise à jour du statut de la salle',
  'Recording Rooms': "Salles d'Enregistrement",
  'Manage your recording studio rooms and their configurations':
    "Gérez vos salles de studio d'enregistrement et leurs configurations",
  'Add Room': 'Ajouter une Salle',
  'Loading rooms...': 'Chargement des salles...',
  'Failed to load rooms. Please try again.': 'Échec du chargement des salles. Veuillez réessayer.',
  'No rooms found': 'Aucune salle trouvée',
  'Get started by adding your first recording room':
    "Commencez par ajouter votre première salle d'enregistrement",
  Image: 'Image',
  'Room Name': 'Nom de la Salle',
  Capacity: 'Capacité',
  'Hourly Rate': 'Tarif Horaire',
  Features: 'Caractéristiques',
  Active: 'Actif',
  people: 'personnes',
  hour: 'heure',
  'Edit Room': 'Modifier la Salle',
  'Add New Room': 'Ajouter une Nouvelle Salle',
  'Hourly Rate (€)': 'Tarif Horaire (€)',
  'Room Features': 'Caractéristiques de la Salle',
  'Room Images': 'Images de la Salle',
  'Uploading images...': 'Téléchargement des images...',
  'Update Room': 'Mettre à Jour la Salle',
  'Create Room': 'Créer la Salle',

  // ManageEquipment translations
  'Failed to load equipment': "Échec du chargement de l'équipement",
  'Please fill in all required fields': 'Veuillez remplir tous les champs requis',
  'Equipment updated successfully': 'Équipement mis à jour avec succès',
  'Equipment created successfully': 'Équipement créé avec succès',
  'An error occurred while saving equipment':
    "Une erreur s'est produite lors de l'enregistrement de l'équipement",
  'Are you sure you want to delete this equipment?':
    'Êtes-vous sûr de vouloir supprimer cet équipement ?',
  'Equipment deleted successfully': 'Équipement supprimé avec succès',
  'An error occurred while deleting equipment':
    "Une erreur s'est produite lors de la suppression de l'équipement",
  'Equipment made available': 'Équipement rendu disponible',
  'Equipment marked unavailable': 'Équipement marqué comme indisponible',
  'An error occurred while updating equipment':
    "Une erreur s'est produite lors de la mise à jour de l'équipement",
  'Recording Equipment': "Équipement d'Enregistrement",
  'Manage your recording studio equipment, microphones, instruments, and gear':
    "Gérez l'équipement de votre studio d'enregistrement, microphones, instruments et matériel",
  'Search equipment...': 'Rechercher équipement...',
  Availability: 'Disponibilité',
  All: 'Tous',
  Unavailable: 'Indisponible',
  'Add Equipment': 'Ajouter Équipement',
  'No Equipment Found': 'Aucun Équipement Trouvé',
  'Start by adding your recording studio equipment to manage availability and rental rates.':
    "Commencez par ajouter l'équipement de votre studio d'enregistrement pour gérer la disponibilité et les tarifs de location.",
  Equipment: 'Équipement',
  'Brand/Model': 'Marque/Modèle',
  Condition: 'État',
  Location: 'Emplacement',
  'Equipment Name *': "Nom de l'Équipement *",
  'Type *': 'Type *',
  Brand: 'Marque',
  Model: 'Modèle',
  'Serial Number': 'Numéro de Série',
  'Condition *': 'État *',
  'Hourly Rate ($)': 'Tarif Horaire ($)',
  'Daily Rate ($)': 'Tarif Journalier ($)',
  'Weekly Rate ($)': 'Tarif Hebdomadaire ($)',
  'Studio A, Storage Room, etc.': 'Studio A, Salle de Stockage, etc.',
  Create: 'Créer',

  // ManageEngineers translations
  'Manage Engineers': 'Gérer les Ingénieurs',
  'Add Engineer': 'Ajouter un Ingénieur',
  'Sound engineer management for': 'Gestion des ingénieurs du son pour',
  'No engineers added yet': 'Aucun ingénieur ajouté pour le moment',
  'Add sound engineers to your team to handle recording sessions and technical support.':
    "Ajoutez des ingénieurs du son à votre équipe pour gérer les sessions d'enregistrement et le support technique.",
  'Add Your First Engineer': 'Ajouter Votre Premier Ingénieur',

  // ManageServices translations
  'Manage Services': 'Gérer les Services',
  'Add Service': 'Ajouter un Service',
  'Studio services management for': 'Gestion des services de studio pour',
  'No services defined yet': 'Aucun service défini pour le moment',
  'Define services like recording, mixing, mastering, and rehearsal sessions with pricing and duration.':
    "Définissez des services comme l'enregistrement, le mixage, le mastering et les sessions de répétition avec tarification et durée.",
  'Add Your First Service': 'Ajouter Votre Premier Service',

  // ManageGallery translations
  'Failed to load gallery photos': 'Échec du chargement des photos de la galerie',
  'Failed to load gallery data': 'Échec du chargement des données de la galerie',
  'Gallery settings saved successfully!': 'Paramètres de la galerie sauvegardés avec succès !',
  'Failed to save gallery settings': 'Échec de la sauvegarde des paramètres de la galerie',
  'Failed to upload photos': 'Échec du téléchargement des photos',
  'Photo updated successfully!': 'Photo mise à jour avec succès !',
  'Failed to save photo': 'Échec de la sauvegarde de la photo',
  'Are you sure you want to delete this photo? This action cannot be undone.':
    'Êtes-vous sûr de vouloir supprimer cette photo ? Cette action ne peut pas être annulée.',
  'Photo deleted successfully!': 'Photo supprimée avec succès !',
  'Failed to delete photo': 'Échec de la suppression de la photo',
  'Failed to update photo order': "Échec de la mise à jour de l'ordre des photos",
  'Studio Gallery': 'Galerie du Studio',
  'Showcase your studio with beautiful photos organized by category':
    'Mettez en valeur votre studio avec de belles photos organisées par catégorie',
  'Gallery Settings': 'Paramètres de la Galerie',
  'Enable Studio Gallery': 'Activer la Galerie du Studio',
  'When enabled, your studio gallery will be visible in the showcase':
    "Lorsqu'elle est activée, votre galerie de studio sera visible dans la vitrine",
  'Upload Photos': 'Télécharger des Photos',
  'Upload multiple photos at once. You can organize them by category after upload.':
    'Téléchargez plusieurs photos à la fois. Vous pouvez les organiser par catégorie après le téléchargement.',
  photos: 'photos',
  'No photos in this category yet. Upload some photos and organize them here.':
    'Aucune photo dans cette catégorie pour le moment. Téléchargez quelques photos et organisez-les ici.',
  'Edit Photo': 'Modifier la Photo',
  'Add Photo': 'Ajouter une Photo',
  'Photo Title': 'Titre de la Photo',
  Save: 'Enregistrer',

  // ManageCertifications translations
  'Failed to load certifications': 'Échec du chargement des certifications',
  'Failed to load certifications data': 'Échec du chargement des données de certification',
  'Certifications settings saved successfully!':
    'Paramètres de certification sauvegardés avec succès !',
  'Failed to save certifications settings':
    'Échec de la sauvegarde des paramètres de certification',
  'Image uploaded successfully!': 'Image téléchargée avec succès !',
  'Failed to upload image': "Échec du téléchargement de l'image",
  'Please enter a certification title': 'Veuillez entrer un titre de certification',
  'Certification updated successfully!': 'Certification mise à jour avec succès !',
  'Certification added successfully!': 'Certification ajoutée avec succès !',
  'Failed to save certification': 'Échec de la sauvegarde de la certification',
  'Are you sure you want to delete this certification? This action cannot be undone.':
    'Êtes-vous sûr de vouloir supprimer cette certification ? Cette action ne peut pas être annulée.',
  'Certification deleted successfully!': 'Certification supprimée avec succès !',
  'Failed to delete certification': 'Échec de la suppression de la certification',
  'Failed to update certification order': "Échec de la mise à jour de l'ordre des certifications",
  'Certifications & Awards': 'Certifications et Prix',
  "Showcase your studio's achievements, awards, and certifications":
    'Mettez en valeur les réalisations, prix et certifications de votre studio',
  'Add Certification': 'Ajouter une Certification',
  'Certifications Settings': 'Paramètres des Certifications',
  'Enable Certifications & Awards': 'Activer les Certifications et Prix',
  'When enabled, your certifications and awards will be visible in the showcase':
    "Lorsqu'elles sont activées, vos certifications et prix seront visibles dans la vitrine",
  'Enable certifications above to start adding your achievements':
    'Activez les certifications ci-dessus pour commencer à ajouter vos réalisations',
  'Add First Certification': 'Ajouter la Première Certification',
  'No certifications added yet. Add your first certification to get started!':
    'Aucune certification ajoutée pour le moment. Ajoutez votre première certification pour commencer !',
  'Issued by': 'Émis par',
  Date: 'Date',
  'Edit certification': 'Modifier la certification',
  'Delete certification': 'Supprimer la certification',
  'Edit Certification': 'Modifier la Certification',
  'Certification Title': 'Titre de la Certification',
  'Issuer/Organization': 'Émetteur/Organisation',
  'e.g., Grammy Awards, Music Producers Guild': 'ex: Grammy Awards, Music Producers Guild',
  'Date Awarded': "Date d'Attribution",
  'Describe the achievement or certification...': 'Décrivez la réalisation ou la certification...',
  'Certification Image': 'Image de Certification',
  Certification: 'Certification',

  // ShareBoost translations
  shareboost: {
    title: 'Configuration ShareBoost',
    description: 'Programme de cashback pour récompenser les utilisateurs qui partagent vos événements',
    programTitle: 'ShareBoost - Cashback pour partages clients',
    programSubtitle: 'Récompensez automatiquement les participants qui partagent votre événement',
    configure: 'Configurer ShareBoost',
    enableProgram: 'Activer le programme ShareBoost',
    enableDescription: 'Permettre aux participants de gagner du cashback en partageant votre événement',
    statistics: 'Statistiques ShareBoost',
    advancedSettings: 'Paramètres avancés',
    estimatedImpact: 'Impact estimé',
    estimatedCashback: 'Basé sur {{conversions}} conversions estimées, vous pourriez dépenser environ {{amount}}€',

    section: {
      rewardSettings: 'Paramètres des Récompenses',
      budgetSettings: 'Paramètres du Budget',
      payoutSettings: 'Paramètres de Paiement',
    },

    field: {
      cashbackPercentage: 'Pourcentage de cashback',
      cashbackPercentageHelp: 'Pourcentage du montant d\'achat que le partageur recevra (5-20%)',
      friendDiscount: 'Réduction pour l\'ami',
      friendDiscountHelp: 'Pourcentage de réduction pour la personne qui utilise le lien de partage (0-20%)',
      minPurchase: 'Montant d\'achat minimum',
      minPurchaseHelp: 'Montant minimum d\'achat pour être éligible au cashback',
      maxCashbackPerShare: 'Cashback maximum par partage',
      maxCashbackPerShareHelp: 'Montant maximum de cashback qu\'un utilisateur peut gagner par partage',
      requireSharerPurchase: 'Exiger que le partageur achète un billet',
      requireSharerPurchaseHelp: 'Si activé, le partageur doit acheter un billet pour l\'événement pour être éligible au cashback',
      maxBudget: 'Budget total maximum',
      maxBudgetHelp: 'Budget total maximum que vous souhaitez allouer au programme ShareBoost',
      processingDelay: 'Délai de traitement',
  // SMS Usage translations
  'SMS Usage': 'Utilisation SMS',
  'Monitor your SMS notification usage and costs':
    'Surveillez votre utilisation de SMS et vos coûts de notification',
  'Free Plan': 'Plan Gratuit',
  'Basic Plan': 'Plan Basique',
  'Pro Plan': 'Plan Pro',
  'Enterprise Plan': 'Plan Enterprise',
  'SMS Quota Exceeded': 'Quota SMS Dépassé',
  "You've reached your SMS quota. Please contact support to upgrade.":
    'Vous avez atteint votre quota SMS. Veuillez contacter le support pour mettre à niveau.',
  'Approaching SMS Limit': 'Approche de la Limite SMS',
  "You've used {percent}% of your SMS quota. Consider upgrading your plan.":
    'Vous avez utilisé {percent}% de votre quota SMS. Envisagez de mettre à niveau votre plan.',
  'Current Month Usage': 'Utilisation du Mois en Cours',
  'Lifetime Statistics': 'Statistiques Totales',
  'Total Cost': 'Coût Total',
  'Average Daily': 'Moyenne Quotidienne',
  'Peak Day': 'Jour de Pointe',
  'SMS Sent': 'SMS Envoyés',
  'Daily Limit': 'Limite Quotidienne',
  'Monthly Limit': 'Limite Mensuelle',
  'Alert Threshold': "Seuil d'Alerte",
  'Per SMS Cost': 'Coût par SMS',
  'Monthly Cost': 'Coût Mensuel',
  'Total Lifetime Cost': 'Coût Total Cumulé',
  'Lifetime SMS Sent': 'Total SMS Envoyés',
  'Notification Type Breakdown': 'Répartition par Type de Notification',
  'Daily Usage Trend (Last 30 Days)': 'Tendance Utilisation Quotidienne (30 Derniers Jours)',
  'SMS Count': 'Nombre de SMS',
  notification: 'notification',
  reminder: 'rappel',
  confirmation: 'confirmation',
  alert: 'alerte',
  marketing: 'marketing',
  other: 'autre',
  method: 'méthode',

  manual: 'Manuel',
  full: 'Complet',
  deposit: 'Dépôt',
  hold: 'Autorisation',

      processingDelayHelp: 'Nombre de jours avant que le cashback soit disponible pour retrait',
      minPayout: 'Montant minimum de retrait',
      minPayoutHelp: 'Montant minimum que les utilisateurs doivent accumuler avant de pouvoir retirer',
      maxSharesPerUser: 'Partages maximum par utilisateur',
      maxSharesPerUserHelp: 'Nombre maximum de fois qu\'un utilisateur peut partager',
      maxRewardsPerUser: 'Récompenses maximum par utilisateur',
      maxRewardsPerUserHelp: 'Montant total maximum de cashback qu\'un utilisateur peut gagner',
      expirationDays: 'Jours d\'expiration',
      expirationDaysHelp: 'Nombre de jours pendant lesquels un lien de partage reste valide',
    },

    payout: {
      percentageRefund: 'Remboursement en pourcentage',
      percentageRefundHelp: 'Le partageur reçoit un pourcentage du montant des billets achetés via son lien de partage',
      wallet: 'Portefeuille',
      walletHelp: 'Les utilisateurs peuvent utiliser leur cashback comme crédit pour de futurs achats',
      bankTransfer: 'Virement bancaire',
      bankTransferHelp: 'Les utilisateurs peuvent retirer leur cashback sur leur compte bancaire',
      instantPayout: 'Paiement instantané',
      instantPayoutHelp: 'Les utilisateurs reçoivent leur cashback immédiatement (frais supplémentaires appliqués)',
    },

    stats: {
      totalShares: 'Partages totaux',
      conversions: 'Conversions',
      cashbackPaid: 'Cashback payé',
    },

    validation: {
      minCashback: 'Le cashback doit être d\'au moins 5%',
      maxCashback: 'Le cashback ne peut pas dépasser 20%',
      cashbackRequired: 'Le pourcentage de cashback est requis',
      minDiscount: 'La réduction doit être d\'au moins 0%',
      maxDiscount: 'La réduction ne peut pas dépasser 20%',
      discountRequired: 'Le pourcentage de réduction est requis',
      minPurchase: 'Le montant d\'achat minimum doit être positif',
      purchaseRequired: 'Le montant d\'achat minimum est requis',
      minMaxCashback: 'Le cashback maximum doit être d\'au moins 1€',
      maxCashbackRequired: 'Le cashback maximum par partage est requis',
      minBudget: 'Le budget doit être d\'au moins 1€',
      budgetRequired: 'Le budget total maximum est requis',
      minDelay: 'Le délai doit être d\'au moins 0 jour',
      maxDelay: 'Le délai ne peut pas dépasser 30 jours',
      delayRequired: 'Le délai de traitement est requis',
      minPayout: 'Le montant minimum de retrait doit être d\'au moins 1€',
      payoutRequired: 'Le montant minimum de retrait est requis',
      payoutMethodRequired: 'Au moins une méthode de paiement doit être sélectionnée',
    },

    success: {
      configSaved: 'Configuration ShareBoost enregistrée avec succès',
    },

    error: {
      configFailed: 'Échec de l\'enregistrement de la configuration ShareBoost',
    },

    warning: {
      lowBudget: 'Attention: Il ne reste que {{remaining}}€ sur votre budget total de {{total}}€',
    },
  },
  days: 'jours',

  // Promotion Programs
  'Promotion Programs': 'Programmes de Promotion',
  'Configure cashback and referral programs for your event':
    'Configurez les programmes de cashback et de parrainage pour votre événement',
  'PromoBooster - Professional Promoters': 'PromoBooster - Promoteurs Professionnels',
  'Reward professional promoters with RP points and referral codes':
    'Récompensez les promoteurs professionnels avec des points RP et des codes de parrainage',
  'Configure rewards for professional promoters':
    'Configurez les récompenses pour les promoteurs professionnels',
  'Enable PromoBooster Program': 'Activer le programme PromoBooster',
  'Allow professional promoters to earn RP points by referring customers':
    'Permettre aux promoteurs professionnels de gagner des points RP en parrainant des clients',

  // Engineer Weekly Availability
  'Schedule Type': 'Type d\'horaire',
  'Choose how to manage this engineer\'s availability': 'Choisissez comment gérer la disponibilité de cet ingénieur',
  'Studio Default': 'Par défaut du studio',
  'Fixed Schedule': 'Horaire fixe',
  'Weekly Schedules': 'Horaires hebdomadaires',
  'This engineer will follow the studio\'s default schedule. You can still block specific dates below.':
    'Cet ingénieur suivra l\'horaire par défaut du studio. Vous pouvez toujours bloquer des dates spécifiques ci-dessous.',
  'Set a fixed weekly schedule that repeats every week.':
    'Définissez un horaire hebdomadaire fixe qui se répète chaque semaine.',
  'Set a fixed weekly schedule that repeats every week':
    'Définissez un horaire hebdomadaire fixe qui se répète chaque semaine',
  'Configure different schedules for different weeks. Perfect for varying workloads or seasonal changes.':
    'Configurez différents horaires pour différentes semaines. Parfait pour les charges de travail variables ou les changements saisonniers.',
  'Week-by-Week Schedules': 'Horaires semaine par semaine',
  'weeks configured': 'semaines configurées',
  'Week of': 'Semaine du',
  'Custom schedule set for this week': 'Horaire personnalisé défini pour cette semaine',
  'Remove custom schedule for this week': 'Supprimer l\'horaire personnalisé pour cette semaine',
  'Week Notes (optional)': 'Notes de la semaine (optionnel)',
  'e.g., Holiday week, Peak season, Reduced hours...':
    'ex : Semaine de vacances, Haute saison, Horaires réduits...',
  'Use Studio Default Availability': 'Utiliser la disponibilité par défaut du studio',
  'Inherit the studio\'s working hours and availability settings':
    'Hériter des heures de travail et des paramètres de disponibilité du studio',

  // Import modular translations
  ...globalDashboardFr,
  ...privacyFr,
  ...analyticsFr,
  ...shareboostFr,
  ...stripeConnectFr,
  ...campaignFr,
};

export default fr;
